module.exports = [
	{
		"id": "IAuthenticatedUser",
		"longname": "IAuthenticatedUser",
		"name": "IAuthenticatedUser",
		"scope": "global",
		"kind": "interface",
		"augments": [
			"IBase"
		],
		"params": [],
		"customTags": [
			{
				"tag": "model",
				"value": "AuthenticatedUser"
			}
		],
		"meta": {
			"lineno": 17,
			"filename": "IAuthenticatedUser.js",
			"path": "/lib/interfaces"
		},
		"order": 74
	},
	{
		"id": "ICall",
		"longname": "ICall",
		"name": "ICall",
		"scope": "global",
		"kind": "interface",
		"augments": [
			"IBase"
		],
		"params": [],
		"customTags": [
			{
				"tag": "model",
				"value": "Call"
			}
		],
		"meta": {
			"lineno": 15,
			"filename": "ICall.js",
			"path": "/lib/interfaces"
		},
		"order": 94
	},
	{
		"id": "IChannel",
		"longname": "IChannel",
		"name": "IChannel",
		"scope": "global",
		"kind": "interface",
		"augments": [
			"IBase"
		],
		"description": "Base channel class.\r\rUse the `type` property to determine whether it is a\r`ITextChannel`, `IDirectMessageChannel` or `IVoiceChannel`:\r\r```js\rDiscordie.ChannelTypes: {\r  GUILD_TEXT: 0,   // ITextChannel\r  DM: 1,           // IDirectMessageChannel\r  GUILD_VOICE: 2,  // IVoiceChannel\r  GROUP_DM: 3      // IDirectMessageChannel\r}\r```",
		"params": [],
		"customTags": [
			{
				"tag": "model",
				"value": "Channel"
			}
		],
		"meta": {
			"lineno": 37,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 98
	},
	{
		"id": "IChannelCollection",
		"longname": "IChannelCollection",
		"name": "IChannelCollection",
		"scope": "global",
		"kind": "interface",
		"augments": [
			"ICollectionBase"
		],
		"params": [],
		"meta": {
			"lineno": 16,
			"filename": "IChannelCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 114
	},
	{
		"id": "IDirectMessageChannel",
		"longname": "IDirectMessageChannel",
		"name": "IDirectMessageChannel",
		"scope": "global",
		"kind": "interface",
		"augments": [
			"IBase"
		],
		"params": [],
		"customTags": [
			{
				"tag": "model",
				"value": "Channel"
			}
		],
		"meta": {
			"lineno": 20,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 127
	},
	{
		"id": "IDirectMessageChannelCollection",
		"longname": "IDirectMessageChannelCollection",
		"name": "IDirectMessageChannelCollection",
		"scope": "global",
		"kind": "interface",
		"augments": [
			"ICollectionBase"
		],
		"params": [],
		"meta": {
			"lineno": 15,
			"filename": "IDirectMessageChannelCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 163
	},
	{
		"id": "IGuild",
		"longname": "IGuild",
		"name": "IGuild",
		"scope": "global",
		"kind": "interface",
		"augments": [
			"IBase"
		],
		"params": [],
		"customTags": [
			{
				"tag": "model",
				"value": "Guild"
			}
		],
		"meta": {
			"lineno": 21,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 167
	},
	{
		"id": "IGuildCollection",
		"longname": "IGuildCollection",
		"name": "IGuildCollection",
		"scope": "global",
		"kind": "interface",
		"augments": [
			"ICollectionBase"
		],
		"params": [],
		"meta": {
			"lineno": 13,
			"filename": "IGuildCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 201
	},
	{
		"id": "IGuildMember",
		"longname": "IGuildMember",
		"name": "IGuildMember",
		"scope": "global",
		"kind": "interface",
		"augments": [
			"IUser"
		],
		"params": [],
		"customTags": [
			{
				"tag": "model",
				"value": "GuildMember"
			}
		],
		"meta": {
			"lineno": 16,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 204
	},
	{
		"id": "IInviteManager",
		"longname": "IInviteManager",
		"name": "IInviteManager",
		"scope": "global",
		"kind": "interface",
		"params": [],
		"meta": {
			"lineno": 10,
			"filename": "IInviteManager.js",
			"path": "/lib/interfaces"
		},
		"order": 228
	},
	{
		"id": "IMessage",
		"longname": "IMessage",
		"name": "IMessage",
		"scope": "global",
		"kind": "interface",
		"augments": [
			"IBase"
		],
		"description": "Chat message. Can be a system message depending on type:\r\r```js\rDiscordie.MessageTypes: {\r  DEFAULT: 0,\r  RECIPIENT_ADD: 1,\r  RECIPIENT_REMOVE: 2,\r  CALL: 3,\r  CHANNEL_NAME_CHANGE: 4,\r  CHANNEL_ICON_CHANGE: 5,\r  CHANNEL_PINNED_MESSAGE: 6\r}\r```",
		"params": [],
		"customTags": [
			{
				"tag": "model",
				"value": "Message"
			}
		],
		"meta": {
			"lineno": 33,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 234
	},
	{
		"id": "IMessageCollection",
		"longname": "IMessageCollection",
		"name": "IMessageCollection",
		"scope": "global",
		"kind": "interface",
		"augments": [
			"ICollectionBase"
		],
		"description": "Collection with all cached messages.\r\r**Includes deleted messages** - you can filter them by checking\r`IMessage.deleted` boolean.",
		"params": [],
		"meta": {
			"lineno": 19,
			"filename": "IMessageCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 258
	},
	{
		"id": "IPermissionOverwrite",
		"longname": "IPermissionOverwrite",
		"name": "IPermissionOverwrite",
		"scope": "global",
		"kind": "interface",
		"augments": [
			"IBase"
		],
		"params": [],
		"customTags": [
			{
				"tag": "model",
				"value": "PermissionOverwrite"
			}
		],
		"meta": {
			"lineno": 19,
			"filename": "IPermissionOverwrite.js",
			"path": "/lib/interfaces"
		},
		"order": 278
	},
	{
		"id": "IPermissions",
		"longname": "IPermissions",
		"name": "IPermissions",
		"scope": "global",
		"kind": "interface",
		"description": "Wrapper for numeric permission values.\r\rContains boolean getters/setters (different for roles and channels).\r\r- `.Text` section only exists for text channels;\r- `.Voice` section only exists for voice channels;\r- `.General` section exists for both;\r- Roles contain all properties - both `.Text` and `.Voice` sections.\r\rExample of role permission properties:\r```\rGeneral: {\r  CREATE_INSTANT_INVITE,\r  KICK_MEMBERS,\r  BAN_MEMBERS,\r  ADMINISTRATOR,\r  MANAGE_CHANNELS,\r  MANAGE_GUILD,\r  CHANGE_NICKNAME,\r  MANAGE_NICKNAMES,\r  MANAGE_ROLES,\r  MANAGE_WEBHOOKS,\r  MANAGE_EMOJIS,\r},\rText: {\r  READ_MESSAGES,\r  SEND_MESSAGES,\r  SEND_TTS_MESSAGES,\r  MANAGE_MESSAGES,\r  EMBED_LINKS,\r  ATTACH_FILES,\r  READ_MESSAGE_HISTORY,\r  MENTION_EVERYONE,\r  EXTERNAL_EMOTES,\r  ADD_REACTIONS,\r},\rVoice: {\r  CONNECT,\r  SPEAK,\r  MUTE_MEMBERS,\r  DEAFEN_MEMBERS,\r  MOVE_MEMBERS,\r  USE_VAD,\r}\r```\r\rExample of text channel permission properties:\r```\rGeneral: {\r  CREATE_INSTANT_INVITE,\r  MANAGE_CHANNEL,\r  MANAGE_PERMISSIONS\r},\rText: {\r  READ_MESSAGES,\r  SEND_MESSAGES,\r  SEND_TTS_MESSAGES,\r  MANAGE_MESSAGES,\r  EMBED_LINKS,\r  ATTACH_FILES,\r  READ_MESSAGE_HISTORY,\r  MENTION_EVERYONE,\r  EXTERNAL_EMOTES,\r  ADD_REACTIONS,\r}\r```",
		"params": [],
		"examples": [
			"var guild = client.Guilds.find(g => g.name == \"test\");\rguild.createRole().then(role => {\r  var perms = role.permissions;\r  perms.General.KICK_MEMBERS = true;\r  perms.General.BAN_MEMBERS = true;\r  perms.Text.MENTION_EVERYONE = true;\r\r  var newRoleName = \"Testing\";\r  var color = 0xE74C3C; // red\r  var hoist = true; // display as separate group\r\r  role.commit(newRoleName, color, hoist);\r}).catch(err => console.log(\"Failed to create role:\", err));"
		],
		"meta": {
			"lineno": 92,
			"filename": "IPermissions.js",
			"path": "/lib/interfaces"
		},
		"order": 285
	},
	{
		"id": "IRole",
		"longname": "IRole",
		"name": "IRole",
		"scope": "global",
		"kind": "interface",
		"augments": [
			"IBase"
		],
		"params": [],
		"customTags": [
			{
				"tag": "model",
				"value": "Role"
			}
		],
		"meta": {
			"lineno": 18,
			"filename": "IRole.js",
			"path": "/lib/interfaces"
		},
		"order": 286
	},
	{
		"id": "ITextChannel",
		"longname": "ITextChannel",
		"name": "ITextChannel",
		"scope": "global",
		"kind": "interface",
		"augments": [
			"IChannel"
		],
		"params": [],
		"customTags": [
			{
				"tag": "model",
				"value": "Channel"
			}
		],
		"meta": {
			"lineno": 18,
			"filename": "ITextChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 293
	},
	{
		"id": "IUser",
		"longname": "IUser",
		"name": "IUser",
		"scope": "global",
		"kind": "interface",
		"augments": [
			"IBase"
		],
		"description": "Object representing a user, user-bot, or a webhook-bot.\r\rBoth bots have the `bot` property set to true.\r\rEach webhook-bot object is unique to a message and may have different\rusername and avatar, the user collection only contains last seen data.\rUse `IMessage.author` to get a message-specific object.",
		"params": [],
		"customTags": [
			{
				"tag": "model",
				"value": "User"
			}
		],
		"meta": {
			"lineno": 23,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 305
	},
	{
		"id": "IUserCollection",
		"longname": "IUserCollection",
		"name": "IUserCollection",
		"scope": "global",
		"kind": "interface",
		"augments": [
			"ICollectionBase"
		],
		"params": [],
		"meta": {
			"lineno": 18,
			"filename": "IUserCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 324
	},
	{
		"id": "IVoiceChannel",
		"longname": "IVoiceChannel",
		"name": "IVoiceChannel",
		"scope": "global",
		"kind": "interface",
		"augments": [
			"IChannel"
		],
		"params": [],
		"customTags": [
			{
				"tag": "model",
				"value": "Channel"
			}
		],
		"meta": {
			"lineno": 12,
			"filename": "IVoiceChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 335
	},
	{
		"id": "IVoiceConnection",
		"longname": "IVoiceConnection",
		"name": "IVoiceConnection",
		"scope": "global",
		"kind": "interface",
		"params": [],
		"meta": {
			"lineno": 16,
			"filename": "IVoiceConnection.js",
			"path": "/lib/interfaces"
		},
		"order": 341
	},
	{
		"id": "IWebhookManager",
		"longname": "IWebhookManager",
		"name": "IWebhookManager",
		"scope": "global",
		"kind": "interface",
		"description": "Wrapper for webhook methods.\r\rExample webhook object:\r```js\r{\r  \"name\": \"abc\",\r  \"channel_id\": \"78231142373424474\",\r  \"token\": \"EtuNYHGkElBlE7BE266Jk...NzHvccXaUCQUOY64NbFWz9zbQ\",\r  \"avatar\": null,\r  \"guild_id\": \"78231498370026660\",\r  \"id\": \"232330225768333313\",\r  \"user\": {\r    \"username\": \"testuser\",\r    \"discriminator\": \"3273\",\r    \"id\": \"000000000000000000\",\r    \"avatar\": null\r  }\r}\r```",
		"params": [],
		"meta": {
			"lineno": 36,
			"filename": "IWebhookManager.js",
			"path": "/lib/interfaces"
		},
		"order": 355
	},
	{
		"id": "AuthenticatedUser",
		"longname": "AuthenticatedUser",
		"name": "AuthenticatedUser",
		"scope": "global",
		"kind": "model",
		"alias": "AuthenticatedUser",
		"meta": {
			"lineno": 11,
			"filename": "AuthenticatedUser.js",
			"path": "/lib/models"
		},
		"order": 364
	},
	{
		"id": "Call",
		"longname": "Call",
		"name": "Call",
		"scope": "global",
		"kind": "model",
		"alias": "Call",
		"meta": {
			"lineno": 10,
			"filename": "Call.js",
			"path": "/lib/models"
		},
		"order": 377
	},
	{
		"id": "Channel",
		"longname": "Channel",
		"name": "Channel",
		"scope": "global",
		"kind": "model",
		"alias": "Channel",
		"meta": {
			"lineno": 11,
			"filename": "Channel.js",
			"path": "/lib/models"
		},
		"order": 383
	},
	{
		"id": "Guild",
		"longname": "Guild",
		"name": "Guild",
		"scope": "global",
		"kind": "model",
		"alias": "Guild",
		"meta": {
			"lineno": 10,
			"filename": "Guild.js",
			"path": "/lib/models"
		},
		"order": 396
	},
	{
		"id": "GuildMember",
		"longname": "GuildMember",
		"name": "GuildMember",
		"scope": "global",
		"kind": "model",
		"alias": "GuildMember",
		"meta": {
			"lineno": 10,
			"filename": "GuildMember.js",
			"path": "/lib/models"
		},
		"order": 414
	},
	{
		"id": "Message",
		"longname": "Message",
		"name": "Message",
		"scope": "global",
		"kind": "model",
		"alias": "Message",
		"meta": {
			"lineno": 11,
			"filename": "Message.js",
			"path": "/lib/models"
		},
		"order": 424
	},
	{
		"id": "PermissionOverwrite",
		"longname": "PermissionOverwrite",
		"name": "PermissionOverwrite",
		"scope": "global",
		"kind": "model",
		"alias": "PermissionOverwrite",
		"meta": {
			"lineno": 10,
			"filename": "PermissionOverwrite.js",
			"path": "/lib/models"
		},
		"order": 444
	},
	{
		"id": "Role",
		"longname": "Role",
		"name": "Role",
		"scope": "global",
		"kind": "model",
		"alias": "Role",
		"meta": {
			"lineno": 10,
			"filename": "Role.js",
			"path": "/lib/models"
		},
		"order": 449
	},
	{
		"id": "User",
		"longname": "User",
		"name": "User",
		"scope": "global",
		"kind": "model",
		"alias": "User",
		"meta": {
			"lineno": 10,
			"filename": "User.js",
			"path": "/lib/models"
		},
		"order": 458
	},
	{
		"id": "VoiceConnectionInfo",
		"longname": "VoiceConnectionInfo",
		"name": "VoiceConnectionInfo",
		"scope": "global",
		"kind": "class",
		"meta": {
			"lineno": 13,
			"filename": "VoiceConnectionCollection.js",
			"path": "/lib/collections"
		},
		"order": 0
	},
	{
		"id": "GatewayReconnectHandler",
		"longname": "GatewayReconnectHandler",
		"name": "GatewayReconnectHandler",
		"scope": "global",
		"kind": "class",
		"meta": {
			"lineno": 10,
			"filename": "GatewayReconnectHandler.js",
			"path": "/lib/core"
		},
		"order": 49
	},
	{
		"id": "Discordie",
		"longname": "Discordie",
		"name": "Discordie",
		"scope": "global",
		"kind": "class",
		"description": "Additional constructor options:\r\r```js\rvar client = new Discordie({\r  // Maximum amount of messages to store in channel cache.\r  // Decreasing this will reduce memory usage over time.\r  // With low values (below 50) chances of message invalidation increase:\r  // accessing message properties (ex. `e.message.channel`) in callbacks\r  // of long running tasks (ex. HTTP requests) becomes unsafe.\r  messageCacheLimit: 1000, // < default\r\r  // Guild sharding:\r  // (Note that this is only intended to be used by large bots.)\r  // 'shardId'     is a number starting at 0 and less than 'shardCount'\r  // 'shardCount'  must be a number greater than 1\r  shardId: 0, shardCount: 2, // sharding is disabled by default\r\r  // Gateway auto-reconnect:\r  // If enabled, 'DISCONNECTED' event will also contain properties\r  // 'autoReconnect'  boolean, set to true\r  // 'delay'          delay in milliseconds until next connect attempt\r  autoReconnect: false, // < default\r});\r```",
		"meta": {
			"lineno": 151,
			"filename": "index.js",
			"path": "/lib"
		},
		"order": 57
	},
	{
		"id": "AudioEncoder",
		"longname": "AudioEncoder",
		"name": "AudioEncoder",
		"scope": "global",
		"kind": "class",
		"description": "Primary audio encoder class (low level).\rAll other encoders and streams abstract this class.",
		"meta": {
			"lineno": 24,
			"filename": "AudioEncoder.js",
			"path": "/lib/voice"
		},
		"order": 464
	},
	{
		"id": "FFmpegEncoder",
		"longname": "FFmpegEncoder",
		"name": "FFmpegEncoder",
		"scope": "global",
		"kind": "class",
		"augments": [
			"ExternalEncoderBase"
		],
		"description": "Simple FFmpeg wrapper that binds to a voice connection,\rencodes audio into opus\r(by default encodes using external process, not inside node.js).\r\rRequires `ffmpeg` or `avconv` installed and in PATH or current directory.\r\r> Please note that FFmpeg **must be compiled with `libopus` support**\r> and whatever other audio codecs you intend to use.\r\r```js\rvar info = client.VoiceConnections[0];\rif (!info) return console.log(\"Voice not connected\");\r\rvar encoder = info.voiceConnection.createExternalEncoder({\r  type: \"ffmpeg\",\r\r  // any source FFmpeg can read (http, rtmp, etc.) (FFmpeg option '-i');\r  // (with \"-\" source pipe data into `encoder.stdin`)\r  source: \"test.mp3\",\r\r  // \"opus\" or \"pcm\", in \"opus\" mode AudioEncoder.setVolume won't work\r  // - \"opus\" - encode audio using FFmpeg only and let node just stream opus\r  // - \"pcm\" - request pcm data from FFmpeg and encode inside node.js\r  format: \"opus\", // < default\r\r  // \"pcm\" mode option\r  frameDuration: 60, // < default\r\r  // optional array of additional arguments (applied to input stream)\r  inputArgs: [],\r\r  // optional array of additional arguments (applied to output stream)\r  // (this volume parameter is passed into FFmpeg and applied for both\r  //  \"pcm\" and \"opus\" formats, but can't be changed dynamically)\r  outputArgs: [\"-af\", \"volume=0.05\"],\r\r  // optional, 'true' redirects FFmpeg's stderr into console\r  //                  and starts with \"-loglevel warning\"\r  debug: false\r});\rif (!encoder) return console.log(\"Voice connection is disposed\");\r\rencoder.once(\"end\", () => console.log(\"stream end\"));\r\rvar encoderStream = encoder.play();\rencoderStream.resetTimestamp();\rencoderStream.removeAllListeners(\"timestamp\");\rencoderStream.on(\"timestamp\", time => console.log(\"Time \" + time));\r```\r\r> **Note:** Since so many users prefer the `ytdl-core` package over\r> `youtube-dl` and use it incorrectly, this is probably the best way to\r> work with it (filter formats from `getInfo` and pass url to FFmpeg):\r\r```js\rfunction playRemote(remote, info) {\r  function onMediaInfo(err, mediaInfo) {\r    if (err) return console.log(\"ytdl error:\", err);\r    // sort by bitrate, high to low; prefer webm over anything else\r    var formats = mediaInfo.formats.filter(f => f.container === \"webm\")\r    .sort((a, b) => b.audioBitrate - a.audioBitrate);\r\r    // get first audio-only format or fallback to non-dash video\r    var bestaudio = formats.find(f => f.audioBitrate > 0 && !f.bitrate) ||\r                    formats.find(f => f.audioBitrate > 0);\r    if (!bestaudio) return console.log(\"[playRemote] No valid formats\");\r\r    if (!info) info = client.VoiceConnections[0];\r    if (!info) return console.log(\"[playRemote] Voice not connected\");\r    // note that in this case FFmpeg must also be compiled with HTTPS support\r    var encoder = info.voiceConnection.createExternalEncoder({\r      type: \"ffmpeg\", source: bestaudio.url\r    });\r    encoder.play();\r  }\r  try {\r    ytdl.getInfo(remote, onMediaInfo);\r  } catch (e) { console.log(\"ytdl threw:\", e); }\r}\r```\r\r#### Events:\r\r- ** Event: `end` **\r\r  Emitted when stream done playing.\r\r- ** Event: `unpipe` **\r\r  Emitted when stream gets unpiped from `AudioEncoderStream`.\r  Proxies `AudioEncoderStream` unpipe event, fires only when\r  using `play()` method.\r  If you create file or http streams make sure descriptors get destroyed on\r  unpiping.",
		"meta": {
			"lineno": 111,
			"filename": "FFmpegEncoder.js",
			"path": "/lib/voice/players"
		},
		"order": 480
	},
	{
		"id": "OggOpusPlayer",
		"longname": "OggOpusPlayer",
		"name": "OggOpusPlayer",
		"scope": "global",
		"kind": "class",
		"augments": [
			"ExternalEncoderBase"
		],
		"description": "Simple wrapper for ogg opus streams. Streams audio on the fly without\rdecoding.\r\r```js\rvar info = client.VoiceConnections[0];\rif (!info) return console.log(\"Voice not connected\");\r\rvar source = fs.createReadStream(\"test.opus\");\rvar encoder = info.voiceConnection.createExternalEncoder({\r  type: \"OggOpusPlayer\",\r  source: source\r});\rif (!encoder) return console.log(\"Voice connection is disposed\");\r\rencoder.once(\"end\", () => console.log(\"stream end\"));\rencoder.once(\"error\", err => console.log(\"Ogg Error\", err));\r\rvar encoderStream = encoder.play();\rencoderStream.once(\"unpipe\", () => source.destroy()); // close descriptor\r\rencoderStream.resetTimestamp();\rencoderStream.removeAllListeners(\"timestamp\");\rencoderStream.on(\"timestamp\", time => console.log(\"Time \" + time));\r```\r\r#### Events:\r\r- ** Event: `end` **\r\r  Emitted when stream done playing.\r\r- ** Event: `unpipe` **\r\r  Emitted when stream gets unpiped from `AudioEncoderStream`.\r  Proxies `AudioEncoderStream` unpipe event, fires only when\r  using `play()` method.\r  If you create file or http streams make sure descriptors get destroyed on\r  unpiping.\r\r- ** Event: `error` **\r\r  Emitted if an error occurred while demuxing. The stream will unpipe\r  itself on this event.",
		"meta": {
			"lineno": 54,
			"filename": "OggOpusPlayer.js",
			"path": "/lib/voice/players"
		},
		"order": 482
	},
	{
		"id": "WebmOpusPlayer",
		"longname": "WebmOpusPlayer",
		"name": "WebmOpusPlayer",
		"scope": "global",
		"kind": "class",
		"augments": [
			"ExternalEncoderBase"
		],
		"description": "Simple wrapper for webm opus streams. Streams audio on the fly without\rdecoding.\r\r```js\rvar info = client.VoiceConnections[0];\rif (!info) return console.log(\"Voice not connected\");\r\rvar source = fs.createReadStream(\"test.webm\");\rvar encoder = info.voiceConnection.createExternalEncoder({\r  type: \"WebmOpusPlayer\",\r  source: source\r});\rif (!encoder) return console.log(\"Voice connection is disposed\");\r\rencoder.once(\"end\", () => console.log(\"stream end\"));\rencoder.once(\"error\", err => console.log(\"WebM Error\", err));\r\rvar encoderStream = encoder.play();\rencoderStream.once(\"unpipe\", () => source.destroy()); // close descriptor\r\rencoderStream.resetTimestamp();\rencoderStream.removeAllListeners(\"timestamp\");\rencoderStream.on(\"timestamp\", time => console.log(\"Time \" + time));\r```\r\r#### Events:\r\r- ** Event: `end` **\r\r  Emitted when stream done playing.\r\r- ** Event: `unpipe` **\r\r  Emitted when stream gets unpiped from `AudioEncoderStream`.\r  Proxies `AudioEncoderStream` unpipe event, fires only when\r  using `play()` method.\r  If you create file or http streams make sure descriptors get destroyed on\r  unpiping.\r\r- ** Event: `error` **\r\r  Emitted if an error occurred while demuxing. The stream will unpipe\r  itself on this event.",
		"meta": {
			"lineno": 56,
			"filename": "WebmOpusPlayer.js",
			"path": "/lib/voice/players"
		},
		"order": 483
	},
	{
		"id": "AudioEncoderStream",
		"longname": "AudioEncoderStream",
		"name": "AudioEncoderStream",
		"scope": "global",
		"kind": "class",
		"description": "This is a regular `Writable` stream that abstracts `AudioEncoder`.\r\rOnly one stream can be piped at a time, previous stream will automatically\runpipe if you connect a new one.\r\rStream instance is bound to a voice connection and persists until the\rconnection is disposed.\r\rYou also can `cork()` and `uncork()` it to pause or unpause like any other\rwritable stream.\r\r```js\rvar lame = require(\"lame\");\rvar mp3decoder = new lame.Decoder();\rvar file = fs.createReadStream(\"test.mp3\");\rfile.pipe(mp3decoder);\r\rmp3decoder.on('format', pcmfmt => {\r  var options = {\r    sampleRate: pcmfmt.sampleRate,\r    channels: pcmfmt.channels,\r  };\r\r  var info = client.VoiceConnections[0];\r  if (!info) return console.log(\"Voice not connected\");\r\r  var encoderStream = info.voiceConnection.getEncoderStream(options);\r  if (!encoderStream) return console.log(\"Connection is disposed\");\r\r  encoderStream.resetTimestamp();\r  // you can register timestamp listener only once on VOICE_CONNECTED\r  // instead of unregistering all listeners every time\r  encoderStream.removeAllListeners(\"timestamp\");\r  encoderStream.on(\"timestamp\", time => console.log(\"Time \" + time));\r\r  mp3decoder.pipe(encoderStream);\r  mp3decoder.once('end', () => console.log(\"stream end\"));\r\r  // must be registered after `pipe()`\r  encoderStream.once(\"unpipe\", () => file.destroy()); // close descriptor\r});\r```\r\r#### Events:\r\r- ** Event: `timestamp` **\r\r  Emits a `Number` value in seconds as argument when the `timestamp` is\r  incremented.",
		"meta": {
			"lineno": 61,
			"filename": "AudioEncoderStream.js",
			"path": "/lib/voice/streams"
		},
		"order": 484
	},
	{
		"id": "event:DISCONNECTED",
		"longname": "event:DISCONNECTED",
		"name": "DISCONNECTED",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when login or gateway auth failed,\ror primary gateway socket disconnects, closing all open sockets.\r\rNot emitted if disconnected using `client.disconnect()`.\r\rProperty `error` can contain following `Error` messages:\r\r- ** `\"Login failed\"` **\r\r  Set if REST `/login` endpoint returned an error.\r\r- ** `\"Could not get gateway\"` **\r\r  Set if REST `/gateway` endpoint returned an error.\r\r- ** `\"No token specified\"` **\r\r  Should never fire under normal circumstances.\r  Set if attempted to open gateway socket without token.\r\r- ** `\"Heartbeat ACK did not arrive in time\"` **\r\r- ** `\"Failed to connect to gateway: READY timed out\"` **\r\r  Set if server did not return a `READY` (initialization) packet\r  within 5 minutes.\r\r- ** `\"Disconnected from primary gateway\"` **\r\r  Emitted for any other errors. Property `error.exception` will contain\r  the `Number` error code from websocket.\r\rOriginal `Error` object or `Number` error code is stored\rwithin `DiscordieError` and can be inspected using `error.exception`.",
		"properties": [
			{
				"type": {
					"names": [
						"DiscordieError"
					]
				},
				"name": "error"
			},
			{
				"type": {
					"names": [
						"Boolean"
					]
				},
				"optional": true,
				"description": "Only present (and set to true) when auto-reconnect is enabled.",
				"name": "autoReconnect"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "Delay in milliseconds until next reconnect attempt.\rOnly present when auto-reconnect is enabled.",
				"name": "delay"
			}
		],
		"meta": {
			"lineno": 140,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 4
	},
	{
		"id": "event:GATEWAY_READY",
		"longname": "event:GATEWAY_READY",
		"name": "GATEWAY_READY",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when the `Discordie` instance is ready to use.\r\rAll objects except unavailable guilds and offline members of large guilds\r(250+ members) will be in cache when this event fires.\r\rYou can request offline members using `client.Users.fetchMembers()`.\rSee documentation for `IUserCollection.fetchMembers`.\r\r> **Note: Any other events may fire before `GATEWAY_READY`.**",
		"examples": [
			"var client = new Discordie();\rclient.connect({ token: \"bot_token\" });\rclient.Dispatcher.on(\"GATEWAY_READY\", e => {\r  // all objects except offline members of large guilds\r  // have been cached at this point\r});"
		],
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"description": "Raw event data",
				"name": "data"
			}
		],
		"meta": {
			"lineno": 185,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 5
	},
	{
		"id": "event:GATEWAY_RESUMED",
		"longname": "event:GATEWAY_RESUMED",
		"name": "GATEWAY_RESUMED",
		"scope": "global",
		"kind": "event",
		"description": "Emitted after gateway connection is resumed after a disconnect.\r\rConnections can be resumable if disconnected for short period of time.\r\rDoes not clear cache unlike `GATEWAY_READY`.",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"description": "Raw event data",
				"name": "data"
			}
		],
		"meta": {
			"lineno": 208,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 6
	},
	{
		"id": "event:VOICE_CONNECTED",
		"longname": "event:VOICE_CONNECTED",
		"name": "VOICE_CONNECTED",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when a new voice connection is fully initialized.",
		"properties": [
			{
				"type": {
					"names": [
						"VoiceSocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IVoiceConnection"
					]
				},
				"name": "voiceConnection"
			}
		],
		"meta": {
			"lineno": 220,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 7
	},
	{
		"id": "event:VOICE_DISCONNECTED",
		"longname": "event:VOICE_DISCONNECTED",
		"name": "VOICE_DISCONNECTED",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when a voice socket disconnects.\r\rProperty `error` can contain `null` or following `Error` messages:\r\r- ** `` `Disconnected from gateway socket: ${errorCode}` `` **\r\r  Set when an error occured on gateway socket.\r\r- ** `\"Failed to connect to voice: VOICE_SESSION_DESCRIPTION timed out\"` **\r\r- ** `\"Voice transport timed out\"` **\r\r- ** `\"Connected from another location\"` **\r\r- ** `\"Kicked from the voice channel\"` **\r\r  Set when server kicks the user from a voice channel,\r  user accounts do not support botapi multiserver voice.\r\r- ** `\"Changing server\"` **\r\r- ** `\"Guild unavailable\"` **\r\r  This event fires before `GUILD_UNAVAILABLE`.\r\r- ** `\"Call unavailable\"` **\r\r- ** `\"Session has been invalidated\"` **\r\r  Set when the gateway connection could not be resumed and new\r  session has been started. Fires for all previously active voice\r  connections.\r\r- ** `\"Manual disconnect\"` **\r\r  Set if `channel.leave()` or `client.disconnect()` was called.\r  Will also be set if channel or guild gets deleted (`VOICE_DISCONNECTED`\r  emits before `GUILD_DELETE` or `CHANNEL_DELETE` respectively).\r\rIf Discord decides to change voice servers - check if `endpointAwait`\ris not null and contains a `Promise` which will resolve when a new\rconnection is fully initialized (`VOICE_CONNECTED` will also fire)\rand reject if reconnect fails.\r\rCalls on `.join()` for channels of the same guild will return the same\rpromise.\r\rCall `.leave()` on pending connection's channel to cancel a reconnect.\rPending promise (`endpointAwait`) will be rejected with\r`Error` message \"Cancelled\".\r\rIf a gateway disconnects, pending connections that belong to the gateway\rwill be rejected with `Error` message `\"Gateway disconnected\"`.",
		"examples": [
			"client.Dispatcher.on(\"VOICE_DISCONNECTED\", e => {\r  const channel = e.voiceConnection.channel;\r  if (!channel) return console.log(\"Channel has been deleted\");\r\r  if (e.endpointAwait) {\r    // handle reconnect instantly if it's a server-switch disconnect\r    // transparently creates same promise as `oldChannel.join()`\r    // see the `reconnect` function below\r\r    // Note: During Discord outages it will act like the official client\r    //       and wait for an endpoint. Sometimes this can take a very\r    //       long time. To cancel pending reconnect just call leave on\r    //       the voice channel. Pending promise will reject with\r    //       `Error` message \"Cancelled\".\r\r\r    e.endpointAwait\r    .then(info => onConnected(info))\r    .catch(err => {\r      // server switching failed, do a regular backoff\r      setTimeout(() => reconnect(channel), 5000);\r    });\r    return;\r  }\r\r  // normal disconnect\r  setTimeout(() => reconnect(channel), 5000);\r});\rfunction reconnect(channel) {\r  var channelName = channel.name;\r  channel.join()\r  .then(info => onConnected(info))\r  .catch(err => console.log(\"Failed to connect to \" + channelName));\r  // this example will stop reconnecting after 1 attempt\r  // you can continue trying to reconnect\r}\rfunction onConnected(info) {\r  console.log(\"Connected to \" + info.voiceConnection.channel.name);\r}"
		],
		"properties": [
			{
				"type": {
					"names": [
						"VoiceSocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IVoiceConnection"
					]
				},
				"name": "voiceConnection"
			},
			{
				"type": {
					"names": [
						"Error",
						"null"
					]
				},
				"name": "error"
			},
			{
				"type": {
					"names": [
						"boolean"
					]
				},
				"description": "Indicating whether was caused by `IVoiceChannel.leave()` or\r`Discordie.disconnect()`, also true if channel/guild has been deleted",
				"name": "manual"
			},
			{
				"type": {
					"names": [
						"Promise.<VoiceConnectionInfo, (Error|Number)>"
					]
				},
				"description": "Indicates whether there is a reconnect pending, reconnects can occur when\rDiscord decides to move users to another voice server",
				"name": "endpointAwait"
			}
		],
		"meta": {
			"lineno": 227,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 8
	},
	{
		"id": "event:GUILD_UNAVAILABLE",
		"longname": "event:GUILD_UNAVAILABLE",
		"name": "GUILD_UNAVAILABLE",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when guild becomes unavailable.\rGuild is deleted from cache until another `GUILD_CREATE`.",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "guildId"
			}
		],
		"meta": {
			"lineno": 335,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 9
	},
	{
		"id": "event:CALL_UNAVAILABLE",
		"longname": "event:CALL_UNAVAILABLE",
		"name": "CALL_UNAVAILABLE",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when call becomes unavailable.",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "channelId"
			}
		],
		"meta": {
			"lineno": 344,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 10
	},
	{
		"id": "event:CALL_RING",
		"longname": "event:CALL_RING",
		"name": "CALL_RING",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when current user is being rung in a call.",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IDirectMessageChannel"
					]
				},
				"name": "channel"
			}
		],
		"meta": {
			"lineno": 352,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 11
	},
	{
		"id": "event:PRESENCE_MEMBER_INFO_UPDATE",
		"longname": "event:PRESENCE_MEMBER_INFO_UPDATE",
		"name": "PRESENCE_MEMBER_INFO_UPDATE",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when `username`, `avatar` or `discriminator` difference detected\rin an incoming `PRESENCE_UPDATE` event.",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"description": "Old instance of internal User model (immutable)",
				"name": "old"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"description": "New instance of internal User model (immutable)",
				"name": "new"
			}
		],
		"meta": {
			"lineno": 360,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 12
	},
	{
		"id": "event:VOICE_CHANNEL_LEAVE",
		"longname": "event:VOICE_CHANNEL_LEAVE",
		"name": "VOICE_CHANNEL_LEAVE",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when user leaves voice channel.\rFields `newChannelId`/`newGuildId` contain ids that will appear in\r`VOICE_CHANNEL_JOIN` event that will follow if user has moved to\ranother channel, otherwise null.",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IUser"
					]
				},
				"name": "user"
			},
			{
				"type": {
					"names": [
						"IChannel",
						"null"
					]
				},
				"name": "channel"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "channelId"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "guildId"
			},
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				},
				"description": "Next channel id if user moved to another channel",
				"name": "newChannelId"
			},
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				},
				"description": "Next guild id if user moved to another channel",
				"name": "newGuildId"
			}
		],
		"meta": {
			"lineno": 370,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 13
	},
	{
		"id": "event:VOICE_CHANNEL_JOIN",
		"longname": "event:VOICE_CHANNEL_JOIN",
		"name": "VOICE_CHANNEL_JOIN",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when user joins voice channel.",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IUser"
					]
				},
				"name": "user"
			},
			{
				"type": {
					"names": [
						"IChannel"
					]
				},
				"name": "channel"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "channelId"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "guildId"
			}
		],
		"meta": {
			"lineno": 388,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 14
	},
	{
		"id": "event:VOICE_USER_SELF_MUTE",
		"longname": "event:VOICE_USER_SELF_MUTE",
		"name": "VOICE_USER_SELF_MUTE",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when user self mute change is detected.\rManual client-side mute.",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IUser"
					]
				},
				"name": "user"
			},
			{
				"type": {
					"names": [
						"IChannel"
					]
				},
				"name": "channel"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "channelId"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "guildId"
			},
			{
				"type": {
					"names": [
						"boolean"
					]
				},
				"description": "Current state (is self muted)",
				"name": "state"
			}
		],
		"meta": {
			"lineno": 399,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 15
	},
	{
		"id": "event:VOICE_USER_SELF_DEAF",
		"longname": "event:VOICE_USER_SELF_DEAF",
		"name": "VOICE_USER_SELF_DEAF",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when user self deaf change is detected.\rManual client-side deafen.",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IUser"
					]
				},
				"name": "user"
			},
			{
				"type": {
					"names": [
						"IChannel"
					]
				},
				"name": "channel"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "channelId"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "guildId"
			},
			{
				"type": {
					"names": [
						"boolean"
					]
				},
				"description": "Current state (is self deafened)",
				"name": "state"
			}
		],
		"meta": {
			"lineno": 412,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 16
	},
	{
		"id": "event:VOICE_USER_MUTE",
		"longname": "event:VOICE_USER_MUTE",
		"name": "VOICE_USER_MUTE",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when user mute change is detected.\rGlobal server-side mute.",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IUser"
					]
				},
				"name": "user"
			},
			{
				"type": {
					"names": [
						"IChannel"
					]
				},
				"name": "channel"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "channelId"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "guildId"
			},
			{
				"type": {
					"names": [
						"boolean"
					]
				},
				"description": "Current state (is muted globally)",
				"name": "state"
			}
		],
		"meta": {
			"lineno": 425,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 17
	},
	{
		"id": "event:VOICE_USER_DEAF",
		"longname": "event:VOICE_USER_DEAF",
		"name": "VOICE_USER_DEAF",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when user deaf change is detected.\rGlobal server-side deafen.",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IUser"
					]
				},
				"name": "user"
			},
			{
				"type": {
					"names": [
						"IChannel"
					]
				},
				"name": "channel"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "channelId"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "guildId"
			},
			{
				"type": {
					"names": [
						"boolean"
					]
				},
				"description": "Current state (is deafened globally)",
				"name": "state"
			}
		],
		"meta": {
			"lineno": 438,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 18
	},
	{
		"id": "event:MESSAGE_CREATE",
		"longname": "event:MESSAGE_CREATE",
		"name": "MESSAGE_CREATE",
		"scope": "global",
		"kind": "event",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IMessage"
					]
				},
				"name": "message"
			}
		],
		"meta": {
			"lineno": 452,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 19
	},
	{
		"id": "event:MESSAGE_DELETE",
		"longname": "event:MESSAGE_DELETE",
		"name": "MESSAGE_DELETE",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when user deletes their message.\rContains null `message` if not cached.",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "channelId"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "messageId"
			},
			{
				"type": {
					"names": [
						"IMessage",
						"null"
					]
				},
				"name": "message"
			}
		],
		"meta": {
			"lineno": 458,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 20
	},
	{
		"id": "event:MESSAGE_DELETE_BULK",
		"longname": "event:MESSAGE_DELETE_BULK",
		"name": "MESSAGE_DELETE_BULK",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when a bot deletes more than 1 message at once.",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "channelId"
			},
			{
				"type": {
					"names": [
						"Array.<String>"
					]
				},
				"name": "messageIds"
			},
			{
				"type": {
					"names": [
						"Array.<IMessage>"
					]
				},
				"description": "Array of known deleted messages, can be empty",
				"name": "messages"
			}
		],
		"meta": {
			"lineno": 468,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 21
	},
	{
		"id": "event:MESSAGE_UPDATE",
		"longname": "event:MESSAGE_UPDATE",
		"name": "MESSAGE_UPDATE",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when user updates their message.\rContains null `message` if not cached.",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IMessage",
						"null"
					]
				},
				"name": "message"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"description": "Raw message object received from server",
				"name": "data"
			}
		],
		"meta": {
			"lineno": 478,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 22
	},
	{
		"id": "event:PRESENCE_UPDATE",
		"longname": "event:PRESENCE_UPDATE",
		"name": "PRESENCE_UPDATE",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when on changes for username, avatar, status or game.\r\rEmitted multiple times for each shared guild with the local user and the\ruser presence is for.\r\rCompare `user.status` and `user.previousStatus` to detect status changes.\r\rGames can be checked with `user.game` and `user.previousGame`\r(and helpers for names `user.gameName` and `user.previousGameName`)\rrespectively.\r\r> **Note:** Property `member` will contain `IUser` instance if user\r>           has left the `guild`.",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IGuild"
					]
				},
				"name": "guild"
			},
			{
				"type": {
					"names": [
						"IUser"
					]
				},
				"name": "user"
			},
			{
				"type": {
					"names": [
						"IGuildMember",
						"IUser"
					]
				},
				"name": "member"
			}
		],
		"meta": {
			"lineno": 488,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 23
	},
	{
		"id": "event:TYPING_START",
		"longname": "event:TYPING_START",
		"name": "TYPING_START",
		"scope": "global",
		"kind": "event",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IUser"
					]
				},
				"name": "user"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"description": "Unix timestamp",
				"name": "timestamp"
			},
			{
				"type": {
					"names": [
						"IChannel"
					]
				},
				"name": "channel"
			}
		],
		"meta": {
			"lineno": 510,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 24
	},
	{
		"id": "event:CHANNEL_CREATE",
		"longname": "event:CHANNEL_CREATE",
		"name": "CHANNEL_CREATE",
		"scope": "global",
		"kind": "event",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IChannel"
					]
				},
				"name": "channel"
			}
		],
		"meta": {
			"lineno": 519,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 25
	},
	{
		"id": "event:CHANNEL_DELETE",
		"longname": "event:CHANNEL_DELETE",
		"name": "CHANNEL_DELETE",
		"scope": "global",
		"kind": "event",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "channelId"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"description": "Raw channel object received from server",
				"name": "data"
			}
		],
		"meta": {
			"lineno": 525,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 26
	},
	{
		"id": "event:CHANNEL_UPDATE",
		"longname": "event:CHANNEL_UPDATE",
		"name": "CHANNEL_UPDATE",
		"scope": "global",
		"kind": "event",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IChannel"
					]
				},
				"name": "channel"
			},
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function returning an object `{before: ..., after: ...}` containing two\rraw channel objects.",
				"name": "getChanges"
			}
		],
		"meta": {
			"lineno": 532,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 27
	},
	{
		"id": "event:CHANNEL_RECIPIENT_ADD",
		"longname": "event:CHANNEL_RECIPIENT_ADD",
		"name": "CHANNEL_RECIPIENT_ADD",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when a user has been added to a group dm.",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IDirectMessageChannel"
					]
				},
				"name": "channel"
			},
			{
				"type": {
					"names": [
						"IUser"
					]
				},
				"name": "user"
			}
		],
		"meta": {
			"lineno": 541,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 28
	},
	{
		"id": "event:CHANNEL_RECIPIENT_REMOVE",
		"longname": "event:CHANNEL_RECIPIENT_REMOVE",
		"name": "CHANNEL_RECIPIENT_REMOVE",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when a user has been removed or left from a group dm.",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IDirectMessageChannel"
					]
				},
				"name": "channel"
			},
			{
				"type": {
					"names": [
						"IUser"
					]
				},
				"name": "user"
			}
		],
		"meta": {
			"lineno": 549,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 29
	},
	{
		"id": "event:GUILD_CREATE",
		"longname": "event:GUILD_CREATE",
		"name": "GUILD_CREATE",
		"scope": "global",
		"kind": "event",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IGuild"
					]
				},
				"name": "guild"
			},
			{
				"type": {
					"names": [
						"boolean"
					]
				},
				"description": "Indicates whether the guild has recovered from unavailable state",
				"name": "becameAvailable"
			}
		],
		"meta": {
			"lineno": 558,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 30
	},
	{
		"id": "event:GUILD_DELETE",
		"longname": "event:GUILD_DELETE",
		"name": "GUILD_DELETE",
		"scope": "global",
		"kind": "event",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "guildId"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"description": "Raw guild object received from server",
				"name": "data"
			},
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function returning a raw guild object or null.",
				"name": "getCachedData"
			}
		],
		"meta": {
			"lineno": 566,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 31
	},
	{
		"id": "event:GUILD_UPDATE",
		"longname": "event:GUILD_UPDATE",
		"name": "GUILD_UPDATE",
		"scope": "global",
		"kind": "event",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IGuild"
					]
				},
				"name": "guild"
			},
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function returning an object `{before: ..., after: ...}` containing two\rraw guild objects.",
				"name": "getChanges"
			}
		],
		"meta": {
			"lineno": 575,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 32
	},
	{
		"id": "event:GUILD_MEMBER_ADD",
		"longname": "event:GUILD_MEMBER_ADD",
		"name": "GUILD_MEMBER_ADD",
		"scope": "global",
		"kind": "event",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IGuild"
					]
				},
				"name": "guild"
			},
			{
				"type": {
					"names": [
						"IGuildMember"
					]
				},
				"name": "member"
			}
		],
		"meta": {
			"lineno": 585,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 33
	},
	{
		"id": "event:GUILD_MEMBER_REMOVE",
		"longname": "event:GUILD_MEMBER_REMOVE",
		"name": "GUILD_MEMBER_REMOVE",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when any other member of a joined guild leaves,\revents for self are blocked internally due to race condition between\r`GUILD_DELETE` and `GUILD_MEMBER_REMOVE`.",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IGuild"
					]
				},
				"name": "guild"
			},
			{
				"type": {
					"names": [
						"IUser"
					]
				},
				"name": "user"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"description": "Raw data received from server",
				"name": "data"
			},
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function returning a raw member object or null.",
				"name": "getCachedData"
			}
		],
		"meta": {
			"lineno": 592,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 34
	},
	{
		"id": "event:GUILD_MEMBER_UPDATE",
		"longname": "event:GUILD_MEMBER_UPDATE",
		"name": "GUILD_MEMBER_UPDATE",
		"scope": "global",
		"kind": "event",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IGuild"
					]
				},
				"name": "guild"
			},
			{
				"type": {
					"names": [
						"IGuildMember"
					]
				},
				"name": "member"
			},
			{
				"type": {
					"names": [
						"Array.<IRole>"
					]
				},
				"name": "rolesAdded"
			},
			{
				"type": {
					"names": [
						"Array.<IRole>"
					]
				},
				"name": "rolesRemoved"
			},
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				},
				"name": "previousNick"
			},
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function returning an object `{before: ..., after: ...}` containing two\rraw member objects.",
				"name": "getChanges"
			}
		],
		"meta": {
			"lineno": 605,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 35
	},
	{
		"id": "event:GUILD_BAN_ADD",
		"longname": "event:GUILD_BAN_ADD",
		"name": "GUILD_BAN_ADD",
		"scope": "global",
		"kind": "event",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IGuild"
					]
				},
				"name": "guild"
			},
			{
				"type": {
					"names": [
						"IUser"
					]
				},
				"name": "user"
			}
		],
		"meta": {
			"lineno": 619,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 36
	},
	{
		"id": "event:GUILD_BAN_REMOVE",
		"longname": "event:GUILD_BAN_REMOVE",
		"name": "GUILD_BAN_REMOVE",
		"scope": "global",
		"kind": "event",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IGuild"
					]
				},
				"name": "guild"
			},
			{
				"type": {
					"names": [
						"IUser"
					]
				},
				"name": "user"
			}
		],
		"meta": {
			"lineno": 626,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 37
	},
	{
		"id": "event:GUILD_ROLE_CREATE",
		"longname": "event:GUILD_ROLE_CREATE",
		"name": "GUILD_ROLE_CREATE",
		"scope": "global",
		"kind": "event",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IGuild"
					]
				},
				"name": "guild"
			},
			{
				"type": {
					"names": [
						"IRole"
					]
				},
				"name": "role"
			}
		],
		"meta": {
			"lineno": 634,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 38
	},
	{
		"id": "event:GUILD_ROLE_UPDATE",
		"longname": "event:GUILD_ROLE_UPDATE",
		"name": "GUILD_ROLE_UPDATE",
		"scope": "global",
		"kind": "event",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IGuild"
					]
				},
				"name": "guild"
			},
			{
				"type": {
					"names": [
						"IRole"
					]
				},
				"name": "role"
			},
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function returning an object `{before: ..., after: ...}` containing two\rraw role objects.",
				"name": "getChanges"
			}
		],
		"meta": {
			"lineno": 641,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 39
	},
	{
		"id": "event:GUILD_ROLE_DELETE",
		"longname": "event:GUILD_ROLE_DELETE",
		"name": "GUILD_ROLE_DELETE",
		"scope": "global",
		"kind": "event",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IGuild"
					]
				},
				"name": "guild"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "roleId"
			},
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function returning a raw role object or null.",
				"name": "getCachedData"
			}
		],
		"meta": {
			"lineno": 651,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 40
	},
	{
		"id": "event:GUILD_EMOJIS_UPDATE",
		"longname": "event:GUILD_EMOJIS_UPDATE",
		"name": "GUILD_EMOJIS_UPDATE",
		"scope": "global",
		"kind": "event",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IGuild"
					]
				},
				"name": "guild"
			},
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function returning an object `{before: ..., after: ...}` containing two\rfull emoji arrays in format provided by Discord.",
				"name": "getChanges"
			}
		],
		"meta": {
			"lineno": 661,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 41
	},
	{
		"id": "event:CALL_CREATE",
		"longname": "event:CALL_CREATE",
		"name": "CALL_CREATE",
		"scope": "global",
		"kind": "event",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IDirectMessageChannel"
					]
				},
				"name": "channel"
			},
			{
				"type": {
					"names": [
						"ICall"
					]
				},
				"name": "call"
			}
		],
		"meta": {
			"lineno": 671,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 42
	},
	{
		"id": "event:CALL_DELETE",
		"longname": "event:CALL_DELETE",
		"name": "CALL_DELETE",
		"scope": "global",
		"kind": "event",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "channelId"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"description": "Raw object received from server",
				"name": "data"
			}
		],
		"meta": {
			"lineno": 678,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 43
	},
	{
		"id": "event:CALL_UPDATE",
		"longname": "event:CALL_UPDATE",
		"name": "CALL_UPDATE",
		"scope": "global",
		"kind": "event",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IDirectMessageChannel"
					]
				},
				"name": "channel"
			},
			{
				"type": {
					"names": [
						"ICall"
					]
				},
				"name": "call"
			}
		],
		"meta": {
			"lineno": 685,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 44
	},
	{
		"id": "event:WEBHOOKS_UPDATE",
		"longname": "event:WEBHOOKS_UPDATE",
		"name": "WEBHOOKS_UPDATE",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when a webhook is updated.",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IGuild"
					]
				},
				"name": "guild"
			},
			{
				"type": {
					"names": [
						"IChannel"
					]
				},
				"name": "channel"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"description": "Raw object received from server",
				"name": "data"
			}
		],
		"meta": {
			"lineno": 693,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 45
	},
	{
		"id": "event:MESSAGE_REACTION_ADD",
		"longname": "event:MESSAGE_REACTION_ADD",
		"name": "MESSAGE_REACTION_ADD",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when a reaction is added to a message.",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IUser",
						"null"
					]
				},
				"name": "user"
			},
			{
				"type": {
					"names": [
						"IChannel",
						"null"
					]
				},
				"name": "channel"
			},
			{
				"type": {
					"names": [
						"IMessage",
						"null"
					]
				},
				"name": "message"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"description": "Partial emoji `{id: String|null, name: String}`",
				"name": "emoji"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"description": "Raw object received from server",
				"name": "data"
			}
		],
		"meta": {
			"lineno": 703,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 46
	},
	{
		"id": "event:MESSAGE_REACTION_REMOVE",
		"longname": "event:MESSAGE_REACTION_REMOVE",
		"name": "MESSAGE_REACTION_REMOVE",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when a reaction is removed from a message.",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IUser",
						"null"
					]
				},
				"name": "user"
			},
			{
				"type": {
					"names": [
						"IChannel",
						"null"
					]
				},
				"name": "channel"
			},
			{
				"type": {
					"names": [
						"IMessage",
						"null"
					]
				},
				"name": "message"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"description": "Partial emoji `{id: String|null, name: String}`",
				"name": "emoji"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"description": "Raw object received from server",
				"name": "data"
			}
		],
		"meta": {
			"lineno": 715,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 47
	},
	{
		"id": "event:MESSAGE_REACTION_REMOVE_ALL",
		"longname": "event:MESSAGE_REACTION_REMOVE_ALL",
		"name": "MESSAGE_REACTION_REMOVE_ALL",
		"scope": "global",
		"kind": "event",
		"description": "Emitted when message reactions are cleared.",
		"properties": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				},
				"name": "socket"
			},
			{
				"type": {
					"names": [
						"IChannel",
						"null"
					]
				},
				"name": "channel"
			},
			{
				"type": {
					"names": [
						"IMessage",
						"null"
					]
				},
				"name": "message"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"description": "Raw object received from server",
				"name": "data"
			},
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function returning an array of removed reactions or null.",
				"name": "getCachedData"
			}
		],
		"meta": {
			"lineno": 727,
			"filename": "Constants.js",
			"path": "/lib"
		},
		"order": 48
	},
	{
		"id": "VoiceConnectionInfo#gatewaySocket",
		"longname": "VoiceConnectionInfo#gatewaySocket",
		"name": "gatewaySocket",
		"scope": "instance",
		"kind": "member",
		"memberof": "VoiceConnectionInfo",
		"returns": [
			{
				"type": {
					"names": [
						"GatewaySocket"
					]
				}
			}
		],
		"meta": {
			"lineno": 15,
			"filename": "VoiceConnectionCollection.js",
			"path": "/lib/collections"
		},
		"order": 1
	},
	{
		"id": "VoiceConnectionInfo#voiceSocket",
		"longname": "VoiceConnectionInfo#voiceSocket",
		"name": "voiceSocket",
		"scope": "instance",
		"kind": "member",
		"memberof": "VoiceConnectionInfo",
		"returns": [
			{
				"type": {
					"names": [
						"VoiceSocket"
					]
				}
			}
		],
		"meta": {
			"lineno": 23,
			"filename": "VoiceConnectionCollection.js",
			"path": "/lib/collections"
		},
		"order": 2
	},
	{
		"id": "VoiceConnectionInfo#voiceConnection",
		"longname": "VoiceConnectionInfo#voiceConnection",
		"name": "voiceConnection",
		"scope": "instance",
		"kind": "member",
		"memberof": "VoiceConnectionInfo",
		"returns": [
			{
				"type": {
					"names": [
						"IVoiceConnection"
					]
				}
			}
		],
		"meta": {
			"lineno": 31,
			"filename": "VoiceConnectionCollection.js",
			"path": "/lib/collections"
		},
		"order": 3
	},
	{
		"id": "GatewayReconnectHandler#enabled",
		"longname": "GatewayReconnectHandler#enabled",
		"name": "enabled",
		"scope": "instance",
		"kind": "member",
		"description": "Boolean indicating whether auto-reconnect is enabled.",
		"memberof": "GatewayReconnectHandler",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 42,
			"filename": "GatewayReconnectHandler.js",
			"path": "/lib/core"
		},
		"order": 52
	},
	{
		"id": "GatewayReconnectHandler#min",
		"longname": "GatewayReconnectHandler#min",
		"name": "min",
		"scope": "instance",
		"kind": "member",
		"description": "Gets/sets minimum delay in milliseconds. Must be >= 0.\r\rDefault is 1000.",
		"memberof": "GatewayReconnectHandler",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Number"
					]
				}
			}
		],
		"meta": {
			"lineno": 50,
			"filename": "GatewayReconnectHandler.js",
			"path": "/lib/core"
		},
		"order": 53
	},
	{
		"id": "GatewayReconnectHandler#max",
		"longname": "GatewayReconnectHandler#max",
		"name": "max",
		"scope": "instance",
		"kind": "member",
		"description": "Gets/sets maximum delay in milliseconds. Must be >= 5000.\r\rDefault is 60000.",
		"memberof": "GatewayReconnectHandler",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Number"
					]
				}
			}
		],
		"meta": {
			"lineno": 63,
			"filename": "GatewayReconnectHandler.js",
			"path": "/lib/core"
		},
		"order": 55
	},
	{
		"id": "Discordie#Dispatcher",
		"longname": "Discordie#Dispatcher",
		"name": "Dispatcher",
		"scope": "instance",
		"kind": "member",
		"description": "Primary event bus.",
		"memberof": "Discordie",
		"examples": [
			"client.Dispatcher.on(\"GATEWAY_READY\", e => {\r  console.log(\"Connected as: \" + client.User.username);\r});"
		],
		"returns": [
			{
				"type": {
					"names": [
						"EventEmitter"
					]
				}
			}
		],
		"meta": {
			"lineno": 171,
			"filename": "index.js",
			"path": "/lib"
		},
		"order": 58
	},
	{
		"id": "Discordie#User",
		"longname": "Discordie#User",
		"name": "User",
		"scope": "instance",
		"kind": "member",
		"description": "Represents current user.",
		"memberof": "Discordie",
		"returns": [
			{
				"type": {
					"names": [
						"IAuthenticatedUser"
					]
				}
			}
		],
		"meta": {
			"lineno": 204,
			"filename": "index.js",
			"path": "/lib"
		},
		"order": 59
	},
	{
		"id": "Discordie#Guilds",
		"longname": "Discordie#Guilds",
		"name": "Guilds",
		"scope": "instance",
		"kind": "member",
		"description": "Interface to a collection containing all \"Discord Servers\"\r(internally called guilds) current session is connected\rto. Does not contain unavailable guilds.",
		"memberof": "Discordie",
		"returns": [
			{
				"type": {
					"names": [
						"IGuildCollection"
					]
				}
			}
		],
		"meta": {
			"lineno": 212,
			"filename": "index.js",
			"path": "/lib"
		},
		"order": 60
	},
	{
		"id": "Discordie#Channels",
		"longname": "Discordie#Channels",
		"name": "Channels",
		"scope": "instance",
		"kind": "member",
		"description": "Interface to a collection containing all public channels current session\ris connected to.",
		"memberof": "Discordie",
		"returns": [
			{
				"type": {
					"names": [
						"IChannelCollection"
					]
				}
			}
		],
		"meta": {
			"lineno": 221,
			"filename": "index.js",
			"path": "/lib"
		},
		"order": 61
	},
	{
		"id": "Discordie#Users",
		"longname": "Discordie#Users",
		"name": "Users",
		"scope": "instance",
		"kind": "member",
		"description": "Interface to a collection containing all users current session has\rbeen exposed to.\r\rContains only online users after `READY`.\rSee documentation for `IUserCollection.fetchMembers(guilds)` if you\rwant to load offline members too.",
		"memberof": "Discordie",
		"returns": [
			{
				"type": {
					"names": [
						"IUserCollection"
					]
				}
			}
		],
		"meta": {
			"lineno": 234,
			"filename": "index.js",
			"path": "/lib"
		},
		"order": 62
	},
	{
		"id": "Discordie#DirectMessageChannels",
		"longname": "Discordie#DirectMessageChannels",
		"name": "DirectMessageChannels",
		"scope": "instance",
		"kind": "member",
		"description": "Interface to a collection containing all private (direct message)\rchannels current session is connected to.",
		"memberof": "Discordie",
		"returns": [
			{
				"type": {
					"names": [
						"IDirectMessageChannelCollection"
					]
				}
			}
		],
		"meta": {
			"lineno": 243,
			"filename": "index.js",
			"path": "/lib"
		},
		"order": 63
	},
	{
		"id": "Discordie#Messages",
		"longname": "Discordie#Messages",
		"name": "Messages",
		"scope": "instance",
		"kind": "member",
		"description": "Interface to a collection containing all cached messages.",
		"memberof": "Discordie",
		"returns": [
			{
				"type": {
					"names": [
						"IMessageCollection"
					]
				}
			}
		],
		"meta": {
			"lineno": 251,
			"filename": "index.js",
			"path": "/lib"
		},
		"order": 64
	},
	{
		"id": "Discordie#Invites",
		"longname": "Discordie#Invites",
		"name": "Invites",
		"scope": "instance",
		"kind": "member",
		"description": "An instance of IInviteManager.",
		"memberof": "Discordie",
		"returns": [
			{
				"type": {
					"names": [
						"IInviteManager"
					]
				}
			}
		],
		"meta": {
			"lineno": 259,
			"filename": "index.js",
			"path": "/lib"
		},
		"order": 65
	},
	{
		"id": "Discordie#Webhooks",
		"longname": "Discordie#Webhooks",
		"name": "Webhooks",
		"scope": "instance",
		"kind": "member",
		"description": "An instance of IWebhookManager.",
		"memberof": "Discordie",
		"returns": [
			{
				"type": {
					"names": [
						"IWebhookManager"
					]
				}
			}
		],
		"meta": {
			"lineno": 265,
			"filename": "index.js",
			"path": "/lib"
		},
		"order": 66
	},
	{
		"id": "Discordie#VoiceConnections",
		"longname": "Discordie#VoiceConnections",
		"name": "VoiceConnections",
		"scope": "instance",
		"kind": "member",
		"description": "An array of VoiceConnectionInfo.",
		"memberof": "Discordie",
		"returns": [
			{
				"type": {
					"names": [
						"Array.<VoiceConnectionInfo>"
					]
				}
			}
		],
		"meta": {
			"lineno": 271,
			"filename": "index.js",
			"path": "/lib"
		},
		"order": 67
	},
	{
		"id": "Discordie#UnavailableGuilds",
		"longname": "Discordie#UnavailableGuilds",
		"name": "UnavailableGuilds",
		"scope": "instance",
		"kind": "member",
		"description": "An array of unavailable guild's ids.",
		"memberof": "Discordie",
		"returns": [
			{
				"type": {
					"names": [
						"Array.<String>"
					]
				}
			}
		],
		"meta": {
			"lineno": 277,
			"filename": "index.js",
			"path": "/lib"
		},
		"order": 68
	},
	{
		"id": "Discordie#autoReconnect",
		"longname": "Discordie#autoReconnect",
		"name": "autoReconnect",
		"scope": "instance",
		"kind": "member",
		"description": "Auto-reconnect handler.",
		"memberof": "Discordie",
		"returns": [
			{
				"type": {
					"names": [
						"GatewayReconnectHandler"
					]
				}
			}
		],
		"meta": {
			"lineno": 296,
			"filename": "index.js",
			"path": "/lib"
		},
		"order": 69
	},
	{
		"id": "Discordie#state",
		"longname": "Discordie#state",
		"name": "state",
		"scope": "instance",
		"kind": "member",
		"description": "Current state.\r\rPossible return values:\r\r - **`DISCONNECTED`**: Initial state. Returned if token is not available.\r - **`LOGGING_IN`**\r - **`LOGGED_IN`**: Returned if token is set, but gateway websocket is\r not connected.\r - **`CONNECTING`**\r - **`CONNECTED`**\r\rState `CONNECTED` only indicates state of gateway websocket connection,\rreturns both before and after `READY`.",
		"memberof": "Discordie",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 323,
			"filename": "index.js",
			"path": "/lib"
		},
		"order": 70
	},
	{
		"id": "Discordie#connected",
		"longname": "Discordie#connected",
		"name": "connected",
		"scope": "instance",
		"kind": "member",
		"description": "Gets a value indicating whether the gateway websocket connection is\restablished.",
		"memberof": "Discordie",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 346,
			"filename": "index.js",
			"path": "/lib"
		},
		"order": 71
	},
	{
		"id": "IAuthenticatedUser#registeredAt",
		"longname": "IAuthenticatedUser#registeredAt",
		"name": "registeredAt",
		"scope": "instance",
		"kind": "member",
		"description": "Gets date and time the account was registered (created) at.",
		"memberof": "IAuthenticatedUser",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Date"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 29,
			"filename": "IAuthenticatedUser.js",
			"path": "/lib/interfaces"
		},
		"order": 75
	},
	{
		"id": "IAuthenticatedUser#avatarURL",
		"longname": "IAuthenticatedUser#avatarURL",
		"name": "avatarURL",
		"scope": "instance",
		"kind": "member",
		"description": "Gets current JPG or GIF avatar URL.",
		"memberof": "IAuthenticatedUser",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 38,
			"filename": "IAuthenticatedUser.js",
			"path": "/lib/interfaces"
		},
		"order": 76
	},
	{
		"id": "IAuthenticatedUser#staticAvatarURL",
		"longname": "IAuthenticatedUser#staticAvatarURL",
		"name": "staticAvatarURL",
		"scope": "instance",
		"kind": "member",
		"description": "Gets current JPG avatar URL.",
		"memberof": "IAuthenticatedUser",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 48,
			"filename": "IAuthenticatedUser.js",
			"path": "/lib/interfaces"
		},
		"order": 77
	},
	{
		"id": "IAuthenticatedUser#isClaimedAccount",
		"longname": "IAuthenticatedUser#isClaimedAccount",
		"name": "isClaimedAccount",
		"scope": "instance",
		"kind": "member",
		"description": "Gets a value indicating whether the account is claimed.",
		"memberof": "IAuthenticatedUser",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 58,
			"filename": "IAuthenticatedUser.js",
			"path": "/lib/interfaces"
		},
		"order": 78
	},
	{
		"id": "IAuthenticatedUser#gameName",
		"longname": "IAuthenticatedUser#gameName",
		"name": "gameName",
		"scope": "instance",
		"kind": "member",
		"description": "Name of the game current user is playing.",
		"memberof": "IAuthenticatedUser",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 256,
			"filename": "IAuthenticatedUser.js",
			"path": "/lib/interfaces"
		},
		"order": 86
	},
	{
		"id": "IAuthenticatedUser#mention",
		"longname": "IAuthenticatedUser#mention",
		"name": "mention",
		"scope": "instance",
		"kind": "member",
		"description": "Creates a mention from this user's id.",
		"memberof": "IAuthenticatedUser",
		"params": [],
		"examples": [
			"channel.sendMessage(user.mention + \", example mention\");"
		],
		"returns": [
			{
				"type": {
					"names": [
						"String"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 309,
			"filename": "IAuthenticatedUser.js",
			"path": "/lib/interfaces"
		},
		"order": 91
	},
	{
		"id": "IAuthenticatedUser#nickMention",
		"longname": "IAuthenticatedUser#nickMention",
		"name": "nickMention",
		"scope": "instance",
		"kind": "member",
		"description": "Creates a nickname mention from this user's id.",
		"memberof": "IAuthenticatedUser",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 318,
			"filename": "IAuthenticatedUser.js",
			"path": "/lib/interfaces"
		},
		"order": 92
	},
	{
		"id": "IBase#createdAt",
		"longname": "IBase#createdAt",
		"name": "createdAt",
		"scope": "instance",
		"kind": "member",
		"description": "Gets date and time this object was created at.",
		"memberof": "IBase",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Date"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 152,
			"filename": "IBase.js",
			"path": "/lib/interfaces"
		},
		"order": 93
	},
	{
		"id": "ICall#createdAt",
		"longname": "ICall#createdAt",
		"name": "createdAt",
		"scope": "instance",
		"kind": "member",
		"overrides": "IBase#createdAt",
		"description": "Gets date and time this call was created at.",
		"memberof": "ICall",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Date"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 31,
			"filename": "ICall.js",
			"path": "/lib/interfaces"
		},
		"order": 95
	},
	{
		"id": "ICall#isRinging",
		"longname": "ICall#isRinging",
		"name": "isRinging",
		"scope": "instance",
		"kind": "member",
		"description": "Checks if the call is ringing for current user.",
		"memberof": "ICall",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 43,
			"filename": "ICall.js",
			"path": "/lib/interfaces"
		},
		"order": 96
	},
	{
		"id": "ICall#ringing",
		"longname": "ICall#ringing",
		"name": "ringing",
		"scope": "instance",
		"kind": "member",
		"memberof": "ICall",
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IUser>",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 58,
			"filename": "ICall.js",
			"path": "/lib/interfaces"
		},
		"order": 97
	},
	{
		"id": "IChannel#is_private",
		"longname": "IChannel#is_private",
		"name": "is_private",
		"scope": "instance",
		"kind": "member",
		"description": "**Deprecated**: Removed in API v6. Use `isPrivate` instead.",
		"memberof": "IChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 53,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 99
	},
	{
		"id": "IChannel#isPrivate",
		"longname": "IChannel#isPrivate",
		"name": "isPrivate",
		"scope": "instance",
		"kind": "member",
		"description": "Checks whether this channel is a direct message channel or a group.",
		"memberof": "IChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 62,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 100
	},
	{
		"id": "IChannel#isGuildVoice",
		"longname": "IChannel#isGuildVoice",
		"name": "isGuildVoice",
		"scope": "instance",
		"kind": "member",
		"description": "Checks whether this channel is a voice channel in a guild.",
		"memberof": "IChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 72,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 101
	},
	{
		"id": "IChannel#isGuildText",
		"longname": "IChannel#isGuildText",
		"name": "isGuildText",
		"scope": "instance",
		"kind": "member",
		"description": "Checks whether this channel is a text channel in a guild.",
		"memberof": "IChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 81,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 102
	},
	{
		"id": "IChannel#isDM",
		"longname": "IChannel#isDM",
		"name": "isDM",
		"scope": "instance",
		"kind": "member",
		"description": "Checks whether this channel is a direct message channel (non-group).",
		"memberof": "IChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 90,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 103
	},
	{
		"id": "IChannel#isGroupDM",
		"longname": "IChannel#isGroupDM",
		"name": "isGroupDM",
		"scope": "instance",
		"kind": "member",
		"description": "Checks whether this channel is a group direct message channel.",
		"memberof": "IChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 99,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 104
	},
	{
		"id": "IChannel#guild",
		"longname": "IChannel#guild",
		"name": "guild",
		"scope": "instance",
		"kind": "member",
		"description": "Gets guild of this channel.",
		"memberof": "IChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"IGuild",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 108,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 105
	},
	{
		"id": "IChannel#permission_overwrites",
		"longname": "IChannel#permission_overwrites",
		"name": "permission_overwrites",
		"scope": "instance",
		"kind": "member",
		"memberof": "IChannel",
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IPermissionOverwrite>"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 289,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 113
	},
	{
		"id": "ICollectionBase#length",
		"longname": "ICollectionBase#length",
		"name": "length",
		"scope": "instance",
		"kind": "member",
		"description": "Number of elements in this collection.",
		"memberof": "ICollectionBase",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Number"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 178,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 125
	},
	{
		"id": "ICollectionBase#size",
		"longname": "ICollectionBase#size",
		"name": "size",
		"scope": "instance",
		"kind": "member",
		"description": "Number of elements in this collection. Alias for `.length`.",
		"memberof": "ICollectionBase",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Number"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 189,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 126
	},
	{
		"id": "IDirectMessageChannel#is_private",
		"longname": "IDirectMessageChannel#is_private",
		"name": "is_private",
		"scope": "instance",
		"kind": "member",
		"description": "**Deprecated**: Removed in API v6. Use `isPrivate` instead.",
		"memberof": "IDirectMessageChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 37,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 128
	},
	{
		"id": "IDirectMessageChannel#isPrivate",
		"longname": "IDirectMessageChannel#isPrivate",
		"name": "isPrivate",
		"scope": "instance",
		"kind": "member",
		"description": "Checks whether this channel is a direct message channel or a group.",
		"memberof": "IDirectMessageChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 46,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 129
	},
	{
		"id": "IDirectMessageChannel#isGuildVoice",
		"longname": "IDirectMessageChannel#isGuildVoice",
		"name": "isGuildVoice",
		"scope": "instance",
		"kind": "member",
		"description": "Checks whether this channel is a voice channel in a guild.",
		"memberof": "IDirectMessageChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 56,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 130
	},
	{
		"id": "IDirectMessageChannel#isGuildText",
		"longname": "IDirectMessageChannel#isGuildText",
		"name": "isGuildText",
		"scope": "instance",
		"kind": "member",
		"description": "Checks whether this channel is a text channel in a guild.",
		"memberof": "IDirectMessageChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 65,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 131
	},
	{
		"id": "IDirectMessageChannel#isDM",
		"longname": "IDirectMessageChannel#isDM",
		"name": "isDM",
		"scope": "instance",
		"kind": "member",
		"description": "Checks whether this channel is a direct message channel (non-group).",
		"memberof": "IDirectMessageChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 74,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 132
	},
	{
		"id": "IDirectMessageChannel#isGroupDM",
		"longname": "IDirectMessageChannel#isGroupDM",
		"name": "isGroupDM",
		"scope": "instance",
		"kind": "member",
		"description": "Checks whether this channel is a group direct message channel.",
		"memberof": "IDirectMessageChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 83,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 133
	},
	{
		"id": "IDirectMessageChannel#owner",
		"longname": "IDirectMessageChannel#owner",
		"name": "owner",
		"scope": "instance",
		"kind": "member",
		"description": "Returns the owner of the private channel.\r\rReturns null if the owner user is not in cache or there is no owner.",
		"memberof": "IDirectMessageChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"IAuthenticatedUser",
						"IUser",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 94,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 134
	},
	{
		"id": "IDirectMessageChannel#iconURL",
		"longname": "IDirectMessageChannel#iconURL",
		"name": "iconURL",
		"scope": "instance",
		"kind": "member",
		"description": "Creates a string URL of image icon of this channel.",
		"memberof": "IDirectMessageChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 119,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 136
	},
	{
		"id": "IDirectMessageChannel#recipient",
		"longname": "IDirectMessageChannel#recipient",
		"name": "recipient",
		"scope": "instance",
		"kind": "member",
		"description": "Gets first recipient of this channel.\r\rReturns null if this channel is invalid or has no recipients.\r\r**Deprecated**: Use `recipients` instead.",
		"memberof": "IDirectMessageChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"IUser",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 133,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 137
	},
	{
		"id": "IDirectMessageChannel#allMessagesLoaded",
		"longname": "IDirectMessageChannel#allMessagesLoaded",
		"name": "allMessagesLoaded",
		"scope": "instance",
		"kind": "member",
		"description": "Gets a value indicating whether all messages were loaded.",
		"memberof": "IDirectMessageChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 143,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 138
	},
	{
		"id": "IDirectMessageChannel#messages",
		"longname": "IDirectMessageChannel#messages",
		"name": "messages",
		"scope": "instance",
		"kind": "member",
		"description": "Creates an array of cached messages in this channel, sorted in order of\rarrival (message cache is sorted on message insertion, not when this\rgetter is invoked).\r\rReturns an empty array if channel no longer exists.",
		"memberof": "IDirectMessageChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IMessage>"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 156,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 139
	},
	{
		"id": "IDirectMessageChannel#pinnedMessages",
		"longname": "IDirectMessageChannel#pinnedMessages",
		"name": "pinnedMessages",
		"scope": "instance",
		"kind": "member",
		"description": "Creates an array of cached pinned messages in this channel.\r\rPinned message cache is updated only if all pinned messages have been\rloaded with `IDirectMessageChannel.fetchPinned()`.\r\rReturns an empty array if channel no longer exists or if pinned messages\rhave not been fetched yet.",
		"memberof": "IDirectMessageChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IMessage>"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 223,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 141
	},
	{
		"id": "IDirectMessageChannel#joinedCall",
		"longname": "IDirectMessageChannel#joinedCall",
		"name": "joinedCall",
		"scope": "instance",
		"kind": "member",
		"description": "Checks whether current user is in the call.",
		"memberof": "IDirectMessageChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 487,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 157
	},
	{
		"id": "IDirectMessageChannel#usersInCall",
		"longname": "IDirectMessageChannel#usersInCall",
		"name": "usersInCall",
		"scope": "instance",
		"kind": "member",
		"description": "Creates an array of users in the call.\r\rReturns null if call does not exist in cache or has not started yet.",
		"memberof": "IDirectMessageChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IUser>",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 501,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 158
	},
	{
		"id": "IDirectMessageChannel#call",
		"longname": "IDirectMessageChannel#call",
		"name": "call",
		"scope": "instance",
		"kind": "member",
		"description": "Gets call from cache.\r\rReturns null if call does not exist in cache or has not started yet.",
		"memberof": "IDirectMessageChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"ICall",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 513,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 159
	},
	{
		"id": "IDirectMessageChannel#name",
		"longname": "IDirectMessageChannel#name",
		"name": "name",
		"scope": "instance",
		"kind": "member",
		"memberof": "IDirectMessageChannel",
		"returns": [
			{
				"type": {
					"names": [
						"String"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 547,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 161
	},
	{
		"id": "IDirectMessageChannel#recipients",
		"longname": "IDirectMessageChannel#recipients",
		"name": "recipients",
		"scope": "instance",
		"kind": "member",
		"description": "Gets recipients of this channel.",
		"memberof": "IDirectMessageChannel",
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IUser>",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 570,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 162
	},
	{
		"id": "IGuild#acronym",
		"longname": "IGuild#acronym",
		"name": "acronym",
		"scope": "instance",
		"kind": "member",
		"description": "Creates an acronym string for this guild.\r(Text that shows up as guild icon in the client if there is no image icon.)",
		"memberof": "IGuild",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 38,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 168
	},
	{
		"id": "IGuild#iconURL",
		"longname": "IGuild#iconURL",
		"name": "iconURL",
		"scope": "instance",
		"kind": "member",
		"description": "Creates a string URL of image icon of this guild.",
		"memberof": "IGuild",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 48,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 169
	},
	{
		"id": "IGuild#splashURL",
		"longname": "IGuild#splashURL",
		"name": "splashURL",
		"scope": "instance",
		"kind": "member",
		"description": "Creates a string URL of invite splash image of this guild.",
		"memberof": "IGuild",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 59,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 170
	},
	{
		"id": "IGuild#afk_channel",
		"longname": "IGuild#afk_channel",
		"name": "afk_channel",
		"scope": "instance",
		"kind": "member",
		"description": "Returns afk channel of this guild.",
		"memberof": "IGuild",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"IChannel",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 81,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 172
	},
	{
		"id": "IGuild#owner",
		"longname": "IGuild#owner",
		"name": "owner",
		"scope": "instance",
		"kind": "member",
		"description": "Returns the owner of this guild.\r\rReturns null if the owner user is not in cache.\r\rSee `.isOwner(user)` if you want to safely check if the `user` is owner.",
		"memberof": "IGuild",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"IAuthenticatedUser",
						"IUser",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 96,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 173
	},
	{
		"id": "IGuild#channels",
		"longname": "IGuild#channels",
		"name": "channels",
		"scope": "instance",
		"kind": "member",
		"description": "Creates an array of text and voice channels of this guild.",
		"memberof": "IGuild",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IChannel>"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 110,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 174
	},
	{
		"id": "IGuild#textChannels",
		"longname": "IGuild#textChannels",
		"name": "textChannels",
		"scope": "instance",
		"kind": "member",
		"description": "Creates an array of text channels of this guild.",
		"memberof": "IGuild",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<ITextChannel>"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 119,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 175
	},
	{
		"id": "IGuild#voiceChannels",
		"longname": "IGuild#voiceChannels",
		"name": "voiceChannels",
		"scope": "instance",
		"kind": "member",
		"description": "Creates an array of voice channels of this guild.",
		"memberof": "IGuild",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IVoiceChannel>"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 128,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 176
	},
	{
		"id": "IGuild#generalChannel",
		"longname": "IGuild#generalChannel",
		"name": "generalChannel",
		"scope": "instance",
		"kind": "member",
		"description": "Returns general channel of this guild.",
		"memberof": "IGuild",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"ITextChannel"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 137,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 177
	},
	{
		"id": "IGuild#members",
		"longname": "IGuild#members",
		"name": "members",
		"scope": "instance",
		"kind": "member",
		"description": "Creates an array containing members of this guild.",
		"memberof": "IGuild",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IGuildMember>"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 254,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 182
	},
	{
		"id": "IGuild#roles",
		"longname": "IGuild#roles",
		"name": "roles",
		"scope": "instance",
		"kind": "member",
		"description": "Creates an array of roles of this guild.",
		"memberof": "IGuild",
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IRole>"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 525,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 200
	},
	{
		"id": "IGuildMember#status",
		"longname": "IGuildMember#status",
		"name": "status",
		"scope": "instance",
		"kind": "member",
		"overrides": "IUser#status",
		"description": "Current status of the member.",
		"memberof": "IGuildMember",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 29,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 205
	},
	{
		"id": "IGuildMember#game",
		"longname": "IGuildMember#game",
		"name": "game",
		"scope": "instance",
		"kind": "member",
		"overrides": "IUser#game",
		"description": "Current game the member is playing.",
		"memberof": "IGuildMember",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Object",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 38,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 206
	},
	{
		"id": "IGuildMember#gameName",
		"longname": "IGuildMember#gameName",
		"name": "gameName",
		"scope": "instance",
		"kind": "member",
		"overrides": "IUser#gameName",
		"description": "Name of the current game the member is playing.",
		"memberof": "IGuildMember",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 47,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 207
	},
	{
		"id": "IGuildMember#previousStatus",
		"longname": "IGuildMember#previousStatus",
		"name": "previousStatus",
		"scope": "instance",
		"kind": "member",
		"overrides": "IUser#previousStatus",
		"description": "Previous status of the member.",
		"memberof": "IGuildMember",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 56,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 208
	},
	{
		"id": "IGuildMember#previousGame",
		"longname": "IGuildMember#previousGame",
		"name": "previousGame",
		"scope": "instance",
		"kind": "member",
		"overrides": "IUser#previousGame",
		"description": "Previous game the member was playing.",
		"memberof": "IGuildMember",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Object",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 65,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 209
	},
	{
		"id": "IGuildMember#previousGameName",
		"longname": "IGuildMember#previousGameName",
		"name": "previousGameName",
		"scope": "instance",
		"kind": "member",
		"overrides": "IUser#previousGameName",
		"description": "Name of the previous game the member was playing.",
		"memberof": "IGuildMember",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 74,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 210
	},
	{
		"id": "IGuildMember#guild",
		"longname": "IGuildMember#guild",
		"name": "guild",
		"scope": "instance",
		"kind": "member",
		"description": "Gets guild of this member.",
		"memberof": "IGuildMember",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"IGuild",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 83,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 211
	},
	{
		"id": "IGuildMember#name",
		"longname": "IGuildMember#name",
		"name": "name",
		"scope": "instance",
		"kind": "member",
		"description": "Gets `nick` of this member if set, otherwise returns `username`.",
		"memberof": "IGuildMember",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 92,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 212
	},
	{
		"id": "IGuildMember#roles",
		"longname": "IGuildMember#roles",
		"name": "roles",
		"scope": "instance",
		"kind": "member",
		"description": "Creates an array of roles assigned to this member.",
		"memberof": "IGuildMember",
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IRole>"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 274,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 227
	},
	{
		"id": "IMessage#isCached",
		"longname": "IMessage#isCached",
		"name": "isCached",
		"scope": "instance",
		"kind": "member",
		"description": "Checks whether this message is cached.",
		"memberof": "IMessage",
		"params": [
			{
				"type": {
					"names": [
						"IMessage"
					]
				},
				"name": "message"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 50,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 235
	},
	{
		"id": "IMessage#isEdited",
		"longname": "IMessage#isEdited",
		"name": "isEdited",
		"scope": "instance",
		"kind": "member",
		"description": "Checks whether this message was edited by the author.\r\rReturns null if message does not exist in cache.",
		"memberof": "IMessage",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 61,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 236
	},
	{
		"id": "IMessage#isPrivate",
		"longname": "IMessage#isPrivate",
		"name": "isPrivate",
		"scope": "instance",
		"kind": "member",
		"description": "Checks whether this message is from a private channel (direct message).\r\rReturns null if message/channel does not exist in cache.",
		"memberof": "IMessage",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 72,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 237
	},
	{
		"id": "IMessage#isSystem",
		"longname": "IMessage#isSystem",
		"name": "isSystem",
		"scope": "instance",
		"kind": "member",
		"description": "Checks whether the message is a system message.",
		"memberof": "IMessage",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 81,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 238
	},
	{
		"id": "IMessage#systemMessage",
		"longname": "IMessage#systemMessage",
		"name": "systemMessage",
		"scope": "instance",
		"kind": "member",
		"description": "Generates a system message string depending on message `type`.",
		"memberof": "IMessage",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 90,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 239
	},
	{
		"id": "IMessage#displayUsername",
		"longname": "IMessage#displayUsername",
		"name": "displayUsername",
		"scope": "instance",
		"kind": "member",
		"description": "Resolves username that should be displayed with this message.",
		"memberof": "IMessage",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 149,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 240
	},
	{
		"id": "IMessage#channel",
		"longname": "IMessage#channel",
		"name": "channel",
		"scope": "instance",
		"kind": "member",
		"description": "Gets channel of this message.\r\rReturns null if message does not exist in cache.",
		"memberof": "IMessage",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"ITextChannel",
						"IDirectMessageChannel",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 165,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 241
	},
	{
		"id": "IMessage#guild",
		"longname": "IMessage#guild",
		"name": "guild",
		"scope": "instance",
		"kind": "member",
		"description": "Gets guild of this message.\r\rReturns null if message does not exist in cache or from a private\rchannel (direct message).",
		"memberof": "IMessage",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"IGuild",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 180,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 242
	},
	{
		"id": "IMessage#member",
		"longname": "IMessage#member",
		"name": "member",
		"scope": "instance",
		"kind": "member",
		"description": "Gets member instance of author.\r\rReturns null for private channels, if message does not exist in cache,\rthe author is no longer a member of the guild, or it is a webhook message.",
		"memberof": "IMessage",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"IGuildMember",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 193,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 243
	},
	{
		"id": "IMessage#edits",
		"longname": "IMessage#edits",
		"name": "edits",
		"scope": "instance",
		"kind": "member",
		"description": "Creates an array of all known (cached) versions of this message (including\rthe latest).\rSorted from latest (first) to oldest (last).\rDoes not include embeds.",
		"memberof": "IMessage",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<Object>"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 206,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 244
	},
	{
		"id": "IMessage#author",
		"longname": "IMessage#author",
		"name": "author",
		"scope": "instance",
		"kind": "member",
		"memberof": "IMessage",
		"returns": [
			{
				"type": {
					"names": [
						"IUser"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 391,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 255
	},
	{
		"id": "IMessage#mentions",
		"longname": "IMessage#mentions",
		"name": "mentions",
		"scope": "instance",
		"kind": "member",
		"memberof": "IMessage",
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IUser>"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 406,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 256
	},
	{
		"id": "IMessage#mention_roles",
		"longname": "IMessage#mention_roles",
		"name": "mention_roles",
		"scope": "instance",
		"kind": "member",
		"memberof": "IMessage",
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IRole>"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 417,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 257
	},
	{
		"id": "IPermissionOverwrite#allow",
		"longname": "IPermissionOverwrite#allow",
		"name": "allow",
		"scope": "instance",
		"kind": "member",
		"memberof": "IPermissionOverwrite",
		"returns": [
			{
				"type": {
					"names": [
						"IPermissions"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 99,
			"filename": "IPermissionOverwrite.js",
			"path": "/lib/interfaces"
		},
		"order": 283
	},
	{
		"id": "IPermissionOverwrite#deny",
		"longname": "IPermissionOverwrite#deny",
		"name": "deny",
		"scope": "instance",
		"kind": "member",
		"memberof": "IPermissionOverwrite",
		"returns": [
			{
				"type": {
					"names": [
						"IPermissions"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 110,
			"filename": "IPermissionOverwrite.js",
			"path": "/lib/interfaces"
		},
		"order": 284
	},
	{
		"id": "IRole#mention",
		"longname": "IRole#mention",
		"name": "mention",
		"scope": "instance",
		"kind": "member",
		"description": "Creates a mention from this role's id.",
		"memberof": "IRole",
		"params": [],
		"examples": [
			"channel.sendMessage(role.mention + \", example mention\");"
		],
		"returns": [
			{
				"type": {
					"names": [
						"String"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 43,
			"filename": "IRole.js",
			"path": "/lib/interfaces"
		},
		"order": 287
	},
	{
		"id": "IRole#permissions",
		"longname": "IRole#permissions",
		"name": "permissions",
		"scope": "instance",
		"kind": "member",
		"memberof": "IRole",
		"returns": [
			{
				"type": {
					"names": [
						"IPermissions"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 121,
			"filename": "IRole.js",
			"path": "/lib/interfaces"
		},
		"order": 292
	},
	{
		"id": "ITextChannel#mention",
		"longname": "ITextChannel#mention",
		"name": "mention",
		"scope": "instance",
		"kind": "member",
		"description": "Creates a mention from this channel's id.",
		"memberof": "ITextChannel",
		"params": [],
		"examples": [
			"channel.sendMessage(channel.mention + \", example mention\");"
		],
		"returns": [
			{
				"type": {
					"names": [
						"String"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 30,
			"filename": "ITextChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 294
	},
	{
		"id": "ITextChannel#members",
		"longname": "ITextChannel#members",
		"name": "members",
		"scope": "instance",
		"kind": "member",
		"description": "Creates an array of IGuildMember that\rhave permissions to read this channel.",
		"memberof": "ITextChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IGuildMember>"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 40,
			"filename": "ITextChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 295
	},
	{
		"id": "ITextChannel#isDefaultChannel",
		"longname": "ITextChannel#isDefaultChannel",
		"name": "isDefaultChannel",
		"scope": "instance",
		"kind": "member",
		"description": "Gets a value indicating whether it is a default (general) channel.",
		"memberof": "ITextChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 49,
			"filename": "ITextChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 296
	},
	{
		"id": "ITextChannel#allMessagesLoaded",
		"longname": "ITextChannel#allMessagesLoaded",
		"name": "allMessagesLoaded",
		"scope": "instance",
		"kind": "member",
		"description": "Gets a value indicating whether all messages were loaded.",
		"memberof": "ITextChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 58,
			"filename": "ITextChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 297
	},
	{
		"id": "ITextChannel#messages",
		"longname": "ITextChannel#messages",
		"name": "messages",
		"scope": "instance",
		"kind": "member",
		"description": "Creates an array of cached messages in this channel, sorted in order of\rarrival (message cache is sorted on message insertion, not when this\rgetter is invoked).\r\rReturns an empty array if channel no longer exists.\r\r> **Note:** Message cache also includes deleted messages.\r>           You can filter them by checking `IMessage.deleted` boolean.",
		"memberof": "ITextChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IMessage>"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 74,
			"filename": "ITextChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 298
	},
	{
		"id": "ITextChannel#pinnedMessages",
		"longname": "ITextChannel#pinnedMessages",
		"name": "pinnedMessages",
		"scope": "instance",
		"kind": "member",
		"description": "Creates an array of cached pinned messages in this channel.\r\rPinned message cache is updated only if all pinned messages have been\rloaded with `ITextChannel.fetchPinned()`.\r\rReturns an empty array if channel no longer exists or if pinned messages\rhave not been fetched yet.",
		"memberof": "ITextChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IMessage>"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 152,
			"filename": "ITextChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 300
	},
	{
		"id": "IUser#registeredAt",
		"longname": "IUser#registeredAt",
		"name": "registeredAt",
		"scope": "instance",
		"kind": "member",
		"description": "Gets date and time the account was registered (created) at.",
		"memberof": "IUser",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Date"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 42,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 306
	},
	{
		"id": "IUser#avatarURL",
		"longname": "IUser#avatarURL",
		"name": "avatarURL",
		"scope": "instance",
		"kind": "member",
		"description": "Gets current JPG or GIF avatar URL.",
		"memberof": "IUser",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 51,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 307
	},
	{
		"id": "IUser#staticAvatarURL",
		"longname": "IUser#staticAvatarURL",
		"name": "staticAvatarURL",
		"scope": "instance",
		"kind": "member",
		"description": "Gets current JPG avatar URL.",
		"memberof": "IUser",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 68,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 308
	},
	{
		"id": "IUser#status",
		"longname": "IUser#status",
		"name": "status",
		"scope": "instance",
		"kind": "member",
		"description": "Current status of the user.",
		"memberof": "IUser",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 79,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 309
	},
	{
		"id": "IUser#game",
		"longname": "IUser#game",
		"name": "game",
		"scope": "instance",
		"kind": "member",
		"description": "Current game the user is playing.",
		"memberof": "IUser",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Object",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 88,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 310
	},
	{
		"id": "IUser#gameName",
		"longname": "IUser#gameName",
		"name": "gameName",
		"scope": "instance",
		"kind": "member",
		"description": "Name of the current game the user is playing.",
		"memberof": "IUser",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 97,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 311
	},
	{
		"id": "IUser#previousStatus",
		"longname": "IUser#previousStatus",
		"name": "previousStatus",
		"scope": "instance",
		"kind": "member",
		"description": "Previous status of the user.",
		"memberof": "IUser",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 106,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 312
	},
	{
		"id": "IUser#previousGame",
		"longname": "IUser#previousGame",
		"name": "previousGame",
		"scope": "instance",
		"kind": "member",
		"description": "Previous game the user was playing.",
		"memberof": "IUser",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Object",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 115,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 313
	},
	{
		"id": "IUser#previousGameName",
		"longname": "IUser#previousGameName",
		"name": "previousGameName",
		"scope": "instance",
		"kind": "member",
		"description": "Name of the previous game the user was playing.",
		"memberof": "IUser",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 124,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 314
	},
	{
		"id": "IUser#mention",
		"longname": "IUser#mention",
		"name": "mention",
		"scope": "instance",
		"kind": "member",
		"description": "Creates a mention from this user's id.",
		"memberof": "IUser",
		"params": [],
		"examples": [
			"channel.sendMessage(user.mention + \", example mention\");"
		],
		"returns": [
			{
				"type": {
					"names": [
						"String"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 256,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 321
	},
	{
		"id": "IUser#nickMention",
		"longname": "IUser#nickMention",
		"name": "nickMention",
		"scope": "instance",
		"kind": "member",
		"description": "Creates a nickname mention from this user's id.",
		"memberof": "IUser",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 265,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 322
	},
	{
		"id": "IUser#isWebhook",
		"longname": "IUser#isWebhook",
		"name": "isWebhook",
		"scope": "instance",
		"kind": "member",
		"description": "Returns true if this is a non-user bot object such as webhook-bot.",
		"memberof": "IUser",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"meta": {
			"lineno": 273,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 323
	},
	{
		"id": "IVoiceChannel#members",
		"longname": "IVoiceChannel#members",
		"name": "members",
		"scope": "instance",
		"kind": "member",
		"description": "Creates an array of members joined in this voice channels.",
		"memberof": "IVoiceChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IGuildMember>"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 22,
			"filename": "IVoiceChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 336
	},
	{
		"id": "IVoiceChannel#joined",
		"longname": "IVoiceChannel#joined",
		"name": "joined",
		"scope": "instance",
		"kind": "member",
		"description": "Checks whether current user is in this voice channel.",
		"memberof": "IVoiceChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 31,
			"filename": "IVoiceChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 337
	},
	{
		"id": "IVoiceConnection#disposed",
		"longname": "IVoiceConnection#disposed",
		"name": "disposed",
		"scope": "instance",
		"kind": "member",
		"description": "Checks whether this voice connection is no longer valid.",
		"memberof": "IVoiceConnection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 43,
			"filename": "IVoiceConnection.js",
			"path": "/lib/interfaces"
		},
		"order": 342
	},
	{
		"id": "IVoiceConnection#canStream",
		"longname": "IVoiceConnection#canStream",
		"name": "canStream",
		"scope": "instance",
		"kind": "member",
		"description": "Checks whether this voice connection is fully initialized.",
		"memberof": "IVoiceConnection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 52,
			"filename": "IVoiceConnection.js",
			"path": "/lib/interfaces"
		},
		"order": 343
	},
	{
		"id": "IVoiceConnection#channel",
		"longname": "IVoiceConnection#channel",
		"name": "channel",
		"scope": "instance",
		"kind": "member",
		"description": "Gets channel of this voice connection.\r\rReturns last channel it was connected to if voice connection has been\rdisposed.\rReturns null if guild became unavailable or channel doesn't exist in cache.",
		"memberof": "IVoiceConnection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"IChannel",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 65,
			"filename": "IVoiceConnection.js",
			"path": "/lib/interfaces"
		},
		"order": 344
	},
	{
		"id": "IVoiceConnection#channelId",
		"longname": "IVoiceConnection#channelId",
		"name": "channelId",
		"scope": "instance",
		"kind": "member",
		"description": "Gets channel id of this voice connection.\r\rReturns last channel id it was connected to if voice connection has been\rdisposed.",
		"memberof": "IVoiceConnection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 79,
			"filename": "IVoiceConnection.js",
			"path": "/lib/interfaces"
		},
		"order": 345
	},
	{
		"id": "IVoiceConnection#guild",
		"longname": "IVoiceConnection#guild",
		"name": "guild",
		"scope": "instance",
		"kind": "member",
		"description": "Gets guild of this voice connection.\r\rReturns null if this is a private call, or guild became unavailable or\rdoesn't exist in cache.",
		"memberof": "IVoiceConnection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"IGuild",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 99,
			"filename": "IVoiceConnection.js",
			"path": "/lib/interfaces"
		},
		"order": 346
	},
	{
		"id": "IVoiceConnection#guildId",
		"longname": "IVoiceConnection#guildId",
		"name": "guildId",
		"scope": "instance",
		"kind": "member",
		"description": "Gets guild id of this voice connection.\r\rReturns null if this is a private call.",
		"memberof": "IVoiceConnection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 112,
			"filename": "IVoiceConnection.js",
			"path": "/lib/interfaces"
		},
		"order": 347
	},
	{
		"id": "AudioEncoder#onNeedBuffer",
		"longname": "AudioEncoder#onNeedBuffer",
		"name": "onNeedBuffer",
		"scope": "instance",
		"kind": "member",
		"description": "Override this function to be called when encoder needs data.\r\r> **Note:** This function **WILL NOT** be called if an\r> `AudioEncoderStream` instance is piping data into the encoder on the\r> same voice connection to avoid buffer interleaving.",
		"memberof": "AudioEncoder",
		"examples": [
			"var bitDepth = 16;\r\rvar options = {\r  frameDuration: 60,\r  sampleRate: 48000,\r  channels: 2\r};\rvar encoder = voiceConnection.getEncoder(options);\r\rvar readSize =\r  options.sampleRate / 1000 *\r  options.frameDuration *\r  bitDepth / 8 *\r  channels;\r\r// [sampleRate]    48000 / 1000 *\r// [frameDuration] 60 *\r// [bitDepth]      16 / 8 *\r// [channels]      2\r//               = 11520 bytes\r\rencoder.onNeedBuffer = function() {\r  var chunk = reader.read(readSize);\r\r  if (!chunk) return;\r  // return will stop onNeedBuffer calls until you call .enqueue again\r\r  var sampleCount = options.sampleRate / 1000 * options.frameDuration;\r\r  // [sampleRate]    48000 / 1000 *\r  // [frameDuration] 60\r  //               = 2880 samples\r\r  encoder.enqueue(chunk, sampleCount);\r};\rencoder.onNeedBuffer();"
		],
		"returns": [
			{
				"type": {
					"names": [
						"function",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 30,
			"filename": "AudioEncoder.js",
			"path": "/lib/voice"
		},
		"order": 465
	},
	{
		"id": "AudioEncoder#disposed",
		"longname": "AudioEncoder#disposed",
		"name": "disposed",
		"scope": "instance",
		"kind": "member",
		"description": "Checks worker state: returns true if not initialized.",
		"memberof": "AudioEncoder",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"meta": {
			"lineno": 91,
			"filename": "AudioEncoder.js",
			"path": "/lib/voice"
		},
		"order": 466
	},
	{
		"id": "ExternalEncoderBase#voiceConnection",
		"longname": "ExternalEncoderBase#voiceConnection",
		"name": "voiceConnection",
		"scope": "instance",
		"kind": "member",
		"description": "Gets the voice connection this instance is bound to.",
		"memberof": "ExternalEncoderBase",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"IVoiceConnection"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 50,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 474
	},
	{
		"id": "FFmpegEncoder#stdin",
		"longname": "FFmpegEncoder#stdin",
		"name": "stdin",
		"scope": "instance",
		"kind": "member",
		"description": "Gets stdin.",
		"memberof": "FFmpegEncoder",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"WritableStream",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 216,
			"filename": "FFmpegEncoder.js",
			"path": "/lib/voice/players"
		},
		"order": 481
	},
	{
		"id": "AudioEncoderStream#timestamp",
		"longname": "AudioEncoderStream#timestamp",
		"name": "timestamp",
		"scope": "instance",
		"kind": "member",
		"description": "Current timestamp in seconds.\r\rIncrements when a chunk is processed.",
		"memberof": "AudioEncoderStream",
		"type": {
			"names": [
				"Number"
			]
		},
		"meta": {
			"lineno": 84,
			"filename": "AudioEncoderStream.js",
			"path": "/lib/voice/streams"
		},
		"order": 485
	},
	{
		"id": "IGuildCollection#length",
		"longname": "IGuildCollection#length",
		"name": "length",
		"scope": "instance",
		"kind": "member",
		"inherits": "ICollectionBase#length",
		"inherited": true,
		"description": "Number of elements in this collection.",
		"memberof": "IGuildCollection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Number"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 178,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 495
	},
	{
		"id": "IGuildCollection#size",
		"longname": "IGuildCollection#size",
		"name": "size",
		"scope": "instance",
		"kind": "member",
		"inherits": "ICollectionBase#size",
		"inherited": true,
		"description": "Number of elements in this collection. Alias for `.length`.",
		"memberof": "IGuildCollection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Number"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 189,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 496
	},
	{
		"id": "IChannelCollection#length",
		"longname": "IChannelCollection#length",
		"name": "length",
		"scope": "instance",
		"kind": "member",
		"inherits": "ICollectionBase#length",
		"inherited": true,
		"description": "Number of elements in this collection.",
		"memberof": "IChannelCollection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Number"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 178,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 504
	},
	{
		"id": "IChannelCollection#size",
		"longname": "IChannelCollection#size",
		"name": "size",
		"scope": "instance",
		"kind": "member",
		"inherits": "ICollectionBase#size",
		"inherited": true,
		"description": "Number of elements in this collection. Alias for `.length`.",
		"memberof": "IChannelCollection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Number"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 189,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 505
	},
	{
		"id": "IAuthenticatedUser#createdAt",
		"longname": "IAuthenticatedUser#createdAt",
		"name": "createdAt",
		"scope": "instance",
		"kind": "member",
		"inherits": "IBase#createdAt",
		"inherited": true,
		"description": "Gets date and time this object was created at.",
		"memberof": "IAuthenticatedUser",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Date"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 152,
			"filename": "IBase.js",
			"path": "/lib/interfaces"
		},
		"order": 506
	},
	{
		"id": "IUserCollection#length",
		"longname": "IUserCollection#length",
		"name": "length",
		"scope": "instance",
		"kind": "member",
		"inherits": "ICollectionBase#length",
		"inherited": true,
		"description": "Number of elements in this collection.",
		"memberof": "IUserCollection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Number"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 178,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 514
	},
	{
		"id": "IUserCollection#size",
		"longname": "IUserCollection#size",
		"name": "size",
		"scope": "instance",
		"kind": "member",
		"inherits": "ICollectionBase#size",
		"inherited": true,
		"description": "Number of elements in this collection. Alias for `.length`.",
		"memberof": "IUserCollection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Number"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 189,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 515
	},
	{
		"id": "IMessageCollection#length",
		"longname": "IMessageCollection#length",
		"name": "length",
		"scope": "instance",
		"kind": "member",
		"inherits": "ICollectionBase#length",
		"inherited": true,
		"description": "Number of elements in this collection.",
		"memberof": "IMessageCollection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Number"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 178,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 523
	},
	{
		"id": "IMessageCollection#size",
		"longname": "IMessageCollection#size",
		"name": "size",
		"scope": "instance",
		"kind": "member",
		"inherits": "ICollectionBase#size",
		"inherited": true,
		"description": "Number of elements in this collection. Alias for `.length`.",
		"memberof": "IMessageCollection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Number"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 189,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 524
	},
	{
		"id": "IDirectMessageChannelCollection#length",
		"longname": "IDirectMessageChannelCollection#length",
		"name": "length",
		"scope": "instance",
		"kind": "member",
		"inherits": "ICollectionBase#length",
		"inherited": true,
		"description": "Number of elements in this collection.",
		"memberof": "IDirectMessageChannelCollection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Number"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 178,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 532
	},
	{
		"id": "IDirectMessageChannelCollection#size",
		"longname": "IDirectMessageChannelCollection#size",
		"name": "size",
		"scope": "instance",
		"kind": "member",
		"inherits": "ICollectionBase#size",
		"inherited": true,
		"description": "Number of elements in this collection. Alias for `.length`.",
		"memberof": "IDirectMessageChannelCollection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Number"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 189,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 533
	},
	{
		"id": "IUser#createdAt",
		"longname": "IUser#createdAt",
		"name": "createdAt",
		"scope": "instance",
		"kind": "member",
		"inherits": "IBase#createdAt",
		"inherited": true,
		"description": "Gets date and time this object was created at.",
		"memberof": "IUser",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Date"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 152,
			"filename": "IBase.js",
			"path": "/lib/interfaces"
		},
		"order": 534
	},
	{
		"id": "IRole#createdAt",
		"longname": "IRole#createdAt",
		"name": "createdAt",
		"scope": "instance",
		"kind": "member",
		"inherits": "IBase#createdAt",
		"inherited": true,
		"description": "Gets date and time this object was created at.",
		"memberof": "IRole",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Date"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 152,
			"filename": "IBase.js",
			"path": "/lib/interfaces"
		},
		"order": 535
	},
	{
		"id": "IGuildMember#registeredAt",
		"longname": "IGuildMember#registeredAt",
		"name": "registeredAt",
		"scope": "instance",
		"kind": "member",
		"inherits": "IUser#registeredAt",
		"inherited": true,
		"description": "Gets date and time the account was registered (created) at.",
		"memberof": "IGuildMember",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Date"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 42,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 536
	},
	{
		"id": "IGuildMember#avatarURL",
		"longname": "IGuildMember#avatarURL",
		"name": "avatarURL",
		"scope": "instance",
		"kind": "member",
		"inherits": "IUser#avatarURL",
		"inherited": true,
		"description": "Gets current JPG or GIF avatar URL.",
		"memberof": "IGuildMember",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 51,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 537
	},
	{
		"id": "IGuildMember#staticAvatarURL",
		"longname": "IGuildMember#staticAvatarURL",
		"name": "staticAvatarURL",
		"scope": "instance",
		"kind": "member",
		"inherits": "IUser#staticAvatarURL",
		"inherited": true,
		"description": "Gets current JPG avatar URL.",
		"memberof": "IGuildMember",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 68,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 538
	},
	{
		"id": "IGuildMember#mention",
		"longname": "IGuildMember#mention",
		"name": "mention",
		"scope": "instance",
		"kind": "member",
		"inherits": "IUser#mention",
		"inherited": true,
		"description": "Creates a mention from this user's id.",
		"memberof": "IGuildMember",
		"params": [],
		"examples": [
			"channel.sendMessage(user.mention + \", example mention\");"
		],
		"returns": [
			{
				"type": {
					"names": [
						"String"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 256,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 544
	},
	{
		"id": "IGuildMember#nickMention",
		"longname": "IGuildMember#nickMention",
		"name": "nickMention",
		"scope": "instance",
		"kind": "member",
		"inherits": "IUser#nickMention",
		"inherited": true,
		"description": "Creates a nickname mention from this user's id.",
		"memberof": "IGuildMember",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 265,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 545
	},
	{
		"id": "IGuildMember#isWebhook",
		"longname": "IGuildMember#isWebhook",
		"name": "isWebhook",
		"scope": "instance",
		"kind": "member",
		"inherits": "IUser#isWebhook",
		"inherited": true,
		"description": "Returns true if this is a non-user bot object such as webhook-bot.",
		"memberof": "IGuildMember",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"meta": {
			"lineno": 273,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 546
	},
	{
		"id": "IGuildMember#createdAt",
		"longname": "IGuildMember#createdAt",
		"name": "createdAt",
		"scope": "instance",
		"kind": "member",
		"inherits": "IBase#createdAt",
		"inherited": true,
		"description": "Gets date and time this object was created at.",
		"memberof": "IGuildMember",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Date"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 152,
			"filename": "IBase.js",
			"path": "/lib/interfaces"
		},
		"order": 547
	},
	{
		"id": "IChannel#createdAt",
		"longname": "IChannel#createdAt",
		"name": "createdAt",
		"scope": "instance",
		"kind": "member",
		"inherits": "IBase#createdAt",
		"inherited": true,
		"description": "Gets date and time this object was created at.",
		"memberof": "IChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Date"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 152,
			"filename": "IBase.js",
			"path": "/lib/interfaces"
		},
		"order": 548
	},
	{
		"id": "ITextChannel#is_private",
		"longname": "ITextChannel#is_private",
		"name": "is_private",
		"scope": "instance",
		"kind": "member",
		"inherits": "IChannel#is_private",
		"inherited": true,
		"description": "**Deprecated**: Removed in API v6. Use `isPrivate` instead.",
		"memberof": "ITextChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 53,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 549
	},
	{
		"id": "ITextChannel#isPrivate",
		"longname": "ITextChannel#isPrivate",
		"name": "isPrivate",
		"scope": "instance",
		"kind": "member",
		"inherits": "IChannel#isPrivate",
		"inherited": true,
		"description": "Checks whether this channel is a direct message channel or a group.",
		"memberof": "ITextChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 62,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 550
	},
	{
		"id": "ITextChannel#isGuildVoice",
		"longname": "ITextChannel#isGuildVoice",
		"name": "isGuildVoice",
		"scope": "instance",
		"kind": "member",
		"inherits": "IChannel#isGuildVoice",
		"inherited": true,
		"description": "Checks whether this channel is a voice channel in a guild.",
		"memberof": "ITextChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 72,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 551
	},
	{
		"id": "ITextChannel#isGuildText",
		"longname": "ITextChannel#isGuildText",
		"name": "isGuildText",
		"scope": "instance",
		"kind": "member",
		"inherits": "IChannel#isGuildText",
		"inherited": true,
		"description": "Checks whether this channel is a text channel in a guild.",
		"memberof": "ITextChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 81,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 552
	},
	{
		"id": "ITextChannel#isDM",
		"longname": "ITextChannel#isDM",
		"name": "isDM",
		"scope": "instance",
		"kind": "member",
		"inherits": "IChannel#isDM",
		"inherited": true,
		"description": "Checks whether this channel is a direct message channel (non-group).",
		"memberof": "ITextChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 90,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 553
	},
	{
		"id": "ITextChannel#isGroupDM",
		"longname": "ITextChannel#isGroupDM",
		"name": "isGroupDM",
		"scope": "instance",
		"kind": "member",
		"inherits": "IChannel#isGroupDM",
		"inherited": true,
		"description": "Checks whether this channel is a group direct message channel.",
		"memberof": "ITextChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 99,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 554
	},
	{
		"id": "ITextChannel#guild",
		"longname": "ITextChannel#guild",
		"name": "guild",
		"scope": "instance",
		"kind": "member",
		"inherits": "IChannel#guild",
		"inherited": true,
		"description": "Gets guild of this channel.",
		"memberof": "ITextChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"IGuild",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 108,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 555
	},
	{
		"id": "ITextChannel#permission_overwrites",
		"longname": "ITextChannel#permission_overwrites",
		"name": "permission_overwrites",
		"scope": "instance",
		"kind": "member",
		"inherits": "IChannel#permission_overwrites",
		"inherited": true,
		"memberof": "ITextChannel",
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IPermissionOverwrite>"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 289,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 563
	},
	{
		"id": "ITextChannel#createdAt",
		"longname": "ITextChannel#createdAt",
		"name": "createdAt",
		"scope": "instance",
		"kind": "member",
		"inherits": "IBase#createdAt",
		"inherited": true,
		"description": "Gets date and time this object was created at.",
		"memberof": "ITextChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Date"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 152,
			"filename": "IBase.js",
			"path": "/lib/interfaces"
		},
		"order": 564
	},
	{
		"id": "IVoiceChannel#is_private",
		"longname": "IVoiceChannel#is_private",
		"name": "is_private",
		"scope": "instance",
		"kind": "member",
		"inherits": "IChannel#is_private",
		"inherited": true,
		"description": "**Deprecated**: Removed in API v6. Use `isPrivate` instead.",
		"memberof": "IVoiceChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 53,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 565
	},
	{
		"id": "IVoiceChannel#isPrivate",
		"longname": "IVoiceChannel#isPrivate",
		"name": "isPrivate",
		"scope": "instance",
		"kind": "member",
		"inherits": "IChannel#isPrivate",
		"inherited": true,
		"description": "Checks whether this channel is a direct message channel or a group.",
		"memberof": "IVoiceChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 62,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 566
	},
	{
		"id": "IVoiceChannel#isGuildVoice",
		"longname": "IVoiceChannel#isGuildVoice",
		"name": "isGuildVoice",
		"scope": "instance",
		"kind": "member",
		"inherits": "IChannel#isGuildVoice",
		"inherited": true,
		"description": "Checks whether this channel is a voice channel in a guild.",
		"memberof": "IVoiceChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 72,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 567
	},
	{
		"id": "IVoiceChannel#isGuildText",
		"longname": "IVoiceChannel#isGuildText",
		"name": "isGuildText",
		"scope": "instance",
		"kind": "member",
		"inherits": "IChannel#isGuildText",
		"inherited": true,
		"description": "Checks whether this channel is a text channel in a guild.",
		"memberof": "IVoiceChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 81,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 568
	},
	{
		"id": "IVoiceChannel#isDM",
		"longname": "IVoiceChannel#isDM",
		"name": "isDM",
		"scope": "instance",
		"kind": "member",
		"inherits": "IChannel#isDM",
		"inherited": true,
		"description": "Checks whether this channel is a direct message channel (non-group).",
		"memberof": "IVoiceChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 90,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 569
	},
	{
		"id": "IVoiceChannel#isGroupDM",
		"longname": "IVoiceChannel#isGroupDM",
		"name": "isGroupDM",
		"scope": "instance",
		"kind": "member",
		"inherits": "IChannel#isGroupDM",
		"inherited": true,
		"description": "Checks whether this channel is a group direct message channel.",
		"memberof": "IVoiceChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 99,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 570
	},
	{
		"id": "IVoiceChannel#guild",
		"longname": "IVoiceChannel#guild",
		"name": "guild",
		"scope": "instance",
		"kind": "member",
		"inherits": "IChannel#guild",
		"inherited": true,
		"description": "Gets guild of this channel.",
		"memberof": "IVoiceChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"IGuild",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 108,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 571
	},
	{
		"id": "IVoiceChannel#permission_overwrites",
		"longname": "IVoiceChannel#permission_overwrites",
		"name": "permission_overwrites",
		"scope": "instance",
		"kind": "member",
		"inherits": "IChannel#permission_overwrites",
		"inherited": true,
		"memberof": "IVoiceChannel",
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IPermissionOverwrite>"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 289,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 579
	},
	{
		"id": "IVoiceChannel#createdAt",
		"longname": "IVoiceChannel#createdAt",
		"name": "createdAt",
		"scope": "instance",
		"kind": "member",
		"inherits": "IBase#createdAt",
		"inherited": true,
		"description": "Gets date and time this object was created at.",
		"memberof": "IVoiceChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Date"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 152,
			"filename": "IBase.js",
			"path": "/lib/interfaces"
		},
		"order": 580
	},
	{
		"id": "IGuild#createdAt",
		"longname": "IGuild#createdAt",
		"name": "createdAt",
		"scope": "instance",
		"kind": "member",
		"inherits": "IBase#createdAt",
		"inherited": true,
		"description": "Gets date and time this object was created at.",
		"memberof": "IGuild",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Date"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 152,
			"filename": "IBase.js",
			"path": "/lib/interfaces"
		},
		"order": 581
	},
	{
		"id": "IDirectMessageChannel#createdAt",
		"longname": "IDirectMessageChannel#createdAt",
		"name": "createdAt",
		"scope": "instance",
		"kind": "member",
		"inherits": "IBase#createdAt",
		"inherited": true,
		"description": "Gets date and time this object was created at.",
		"memberof": "IDirectMessageChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Date"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 152,
			"filename": "IBase.js",
			"path": "/lib/interfaces"
		},
		"order": 582
	},
	{
		"id": "IMessage#createdAt",
		"longname": "IMessage#createdAt",
		"name": "createdAt",
		"scope": "instance",
		"kind": "member",
		"inherits": "IBase#createdAt",
		"inherited": true,
		"description": "Gets date and time this object was created at.",
		"memberof": "IMessage",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Date"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 152,
			"filename": "IBase.js",
			"path": "/lib/interfaces"
		},
		"order": 583
	},
	{
		"id": "FFmpegEncoder#voiceConnection",
		"longname": "FFmpegEncoder#voiceConnection",
		"name": "voiceConnection",
		"scope": "instance",
		"kind": "member",
		"inherits": "ExternalEncoderBase#voiceConnection",
		"inherited": true,
		"description": "Gets the voice connection this instance is bound to.",
		"memberof": "FFmpegEncoder",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"IVoiceConnection"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 50,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 584
	},
	{
		"id": "OggOpusPlayer#voiceConnection",
		"longname": "OggOpusPlayer#voiceConnection",
		"name": "voiceConnection",
		"scope": "instance",
		"kind": "member",
		"inherits": "ExternalEncoderBase#voiceConnection",
		"inherited": true,
		"description": "Gets the voice connection this instance is bound to.",
		"memberof": "OggOpusPlayer",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"IVoiceConnection"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 50,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 590
	},
	{
		"id": "WebmOpusPlayer#voiceConnection",
		"longname": "WebmOpusPlayer#voiceConnection",
		"name": "voiceConnection",
		"scope": "instance",
		"kind": "member",
		"inherits": "ExternalEncoderBase#voiceConnection",
		"inherited": true,
		"description": "Gets the voice connection this instance is bound to.",
		"memberof": "WebmOpusPlayer",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"IVoiceConnection"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 50,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 596
	},
	{
		"id": "GatewayReconnectHandler#enable",
		"longname": "GatewayReconnectHandler#enable",
		"name": "enable",
		"scope": "instance",
		"kind": "function",
		"description": "Enables auto-reconnect.",
		"memberof": "GatewayReconnectHandler",
		"params": [],
		"meta": {
			"lineno": 30,
			"filename": "GatewayReconnectHandler.js",
			"path": "/lib/core"
		},
		"order": 50
	},
	{
		"id": "GatewayReconnectHandler#disable",
		"longname": "GatewayReconnectHandler#disable",
		"name": "disable",
		"scope": "instance",
		"kind": "function",
		"description": "Disables auto-reconnect.",
		"memberof": "GatewayReconnectHandler",
		"params": [],
		"meta": {
			"lineno": 35,
			"filename": "GatewayReconnectHandler.js",
			"path": "/lib/core"
		},
		"order": 51
	},
	{
		"id": "Discordie#connect",
		"longname": "Discordie#connect",
		"name": "connect",
		"scope": "instance",
		"kind": "function",
		"memberof": "Discordie",
		"params": [
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"description": "Can contain `email`, `password` or `token`",
				"name": "credentials"
			}
		],
		"meta": {
			"lineno": 353,
			"filename": "index.js",
			"path": "/lib"
		},
		"order": 72
	},
	{
		"id": "Discordie#disconnect",
		"longname": "Discordie#disconnect",
		"name": "disconnect",
		"scope": "instance",
		"kind": "function",
		"description": "Disconnects primary gateway websocket.",
		"memberof": "Discordie",
		"params": [],
		"meta": {
			"lineno": 381,
			"filename": "index.js",
			"path": "/lib"
		},
		"order": 73
	},
	{
		"id": "IAuthenticatedUser#isMentioned",
		"longname": "IAuthenticatedUser#isMentioned",
		"name": "isMentioned",
		"scope": "instance",
		"kind": "function",
		"description": "Checks whether the user is mentioned in a `message`.",
		"memberof": "IAuthenticatedUser",
		"params": [
			{
				"type": {
					"names": [
						"IMessage"
					]
				},
				"name": "message"
			},
			{
				"type": {
					"names": [
						"boolean"
					]
				},
				"name": "ignoreImplicitMentions"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"meta": {
			"lineno": 68,
			"filename": "IAuthenticatedUser.js",
			"path": "/lib/interfaces"
		},
		"order": 79
	},
	{
		"id": "IAuthenticatedUser#getApplication",
		"longname": "IAuthenticatedUser#getApplication",
		"name": "getApplication",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to get the bot's OAuth2 application info.\r\rWorks only with bot accounts.\r\rExample response object:\r```js\r{\r  \"description\": \"Test\",\r  \"icon\": null,\r  \"id\": \"179527948411052118\",\r  \"name\": \"app name or something\",\r  \"rpc_origins\": [],\r  \"flags\": 0,\r  \"owner\": {\r    \"username\": \"bot owner\",\r    \"discriminator\": \"4937\",\r    \"id\": \"169454786183781631\",\r    \"avatar\": null\r  }\r}\r```",
		"memberof": "IAuthenticatedUser",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 96,
			"filename": "IAuthenticatedUser.js",
			"path": "/lib/interfaces"
		},
		"order": 80
	},
	{
		"id": "IAuthenticatedUser#edit",
		"longname": "IAuthenticatedUser#edit",
		"name": "edit",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to edit user profile,\rsubstituting `undefined` or `null` properties with current values.\r\rPassing `null` in `avatar` will remove current avatar. Use `undefined`\rinstead of `null` in this case.",
		"memberof": "IAuthenticatedUser",
		"params": [
			{
				"type": {
					"names": [
						"String"
					]
				},
				"description": "Use null as password on bot accounts",
				"name": "currentPassword"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"optional": true,
				"name": "username"
			},
			{
				"type": {
					"names": [
						"String",
						"Buffer",
						"null"
					]
				},
				"optional": true,
				"description": "Buffer or base64 data URL",
				"name": "avatar"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"optional": true,
				"name": "email"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"optional": true,
				"name": "newPassword"
			}
		],
		"examples": [
			"// avatar from file\rclient.User.edit(currentPassword, null, fs.readFileSync(\"test.png\"));\rclient.User.edit(currentPassword, null, fs.readFileSync(\"test.jpg\"));\r// avatar unchanged\rclient.User.edit(currentPassword, \"test\", undefined, \"new@example.com\");\rclient.User.edit(currentPassword, \"test\", client.User.avatar);\r// no avatar / default avatar\rclient.User.edit(currentPassword, \"test\", null);"
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IUser, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 122,
			"filename": "IAuthenticatedUser.js",
			"path": "/lib/interfaces"
		},
		"order": 81
	},
	{
		"id": "IAuthenticatedUser#setAvatar",
		"longname": "IAuthenticatedUser#setAvatar",
		"name": "setAvatar",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to edit avatar.\r\rSetting avatar to `null` will remove current avatar.",
		"memberof": "IAuthenticatedUser",
		"params": [
			{
				"type": {
					"names": [
						"String",
						"Buffer",
						"null"
					]
				},
				"description": "Buffer or base64 data URL",
				"name": "avatar"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"optional": true,
				"description": "Not applicable for bot accounts",
				"name": "currentPassword"
			}
		],
		"examples": [
			"// avatar from file\rclient.User.setAvatar(fs.readFileSync(\"test.png\"));\r// remove avatar\rclient.User.setAvatar(null);"
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IUser, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 155,
			"filename": "IAuthenticatedUser.js",
			"path": "/lib/interfaces"
		},
		"order": 82
	},
	{
		"id": "IAuthenticatedUser#setUsername",
		"longname": "IAuthenticatedUser#setUsername",
		"name": "setUsername",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to edit username.",
		"memberof": "IAuthenticatedUser",
		"params": [
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "username"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"optional": true,
				"description": "Not applicable for bot accounts",
				"name": "currentPassword"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IUser, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 165,
			"filename": "IAuthenticatedUser.js",
			"path": "/lib/interfaces"
		},
		"order": 83
	},
	{
		"id": "IAuthenticatedUser#setStatus",
		"longname": "IAuthenticatedUser#setStatus",
		"name": "setStatus",
		"scope": "instance",
		"kind": "function",
		"description": "Sets current user status via websocket.\r\rWith multiple sessions status from last connected will override statuses\rfrom previous sessions.\r\r> Note: By default Discord client does not display game/status updates for\r> the user it's logged in into. It will be visible for other users.",
		"memberof": "IAuthenticatedUser",
		"params": [
			{
				"type": {
					"names": [
						"Object",
						"String"
					]
				},
				"description": "Object `{status: String, afk: boolean}` or string.\rField `afk` changes how Discord handles push notifications.",
				"name": "status"
			},
			{
				"type": {
					"names": [
						"Object",
						"String",
						"null"
					]
				},
				"optional": true,
				"description": "Object `{name: String}` or string",
				"name": "game"
			}
		],
		"examples": [
			"var game = {name: \"with code\"}; // sets status as \"Playing with code\"\rvar streamingGame = {type: 1, name: \"something\", url: \"\"}; // \"Streaming\"\r// note: streaming status requires a valid twitch url:\r//       ex. \"http://twitch.tv/channel\"\rclient.User.setStatus(\"idle\", game); // idle, playing\rclient.User.setStatus(null, game); // no status change, playing\rclient.User.setStatus(null, \"with code\"); // no status change, playing\rclient.User.setStatus(null, streamingGame); // no status change, streaming\rclient.User.setStatus(\"online\", game); // online, playing\rclient.User.setStatus(\"idle\", null); // idle, not playing\rclient.User.setStatus(\"dnd\"); // \"do not disturb\"\rclient.User.setStatus(\"invisible\");\rclient.User.setStatus({status: \"idle\", afk: true});"
		],
		"meta": {
			"lineno": 196,
			"filename": "IAuthenticatedUser.js",
			"path": "/lib/interfaces"
		},
		"order": 84
	},
	{
		"id": "IAuthenticatedUser#setGame",
		"longname": "IAuthenticatedUser#setGame",
		"name": "setGame",
		"scope": "instance",
		"kind": "function",
		"description": "Sets playing game for current user via websocket.\r\rWith multiple sessions status from last connected will override statuses\rfrom previous sessions.\r\r> Note: By default Discord client does not display game/status updates for\r> the user it's logged in into. It will be visible for other users.",
		"memberof": "IAuthenticatedUser",
		"params": [
			{
				"type": {
					"names": [
						"Object",
						"String",
						"null"
					]
				},
				"description": "Object `{name: String}` or string",
				"name": "game"
			}
		],
		"examples": [
			"var game = {name: \"with code\"}; // sets game as \"Playing with code\"\rvar streamingGame = {type: 1, name: \"something\", url: \"\"}; // \"Streaming\"\r// note: streaming status requires a valid twitch url:\r//       ex. \"http://twitch.tv/channel\"\rclient.User.setGame(game); // playing\rclient.User.setGame(\"with code\"); // playing\rclient.User.setGame(streamingGame); // streaming\rclient.User.setGame(null); // not playing"
		],
		"meta": {
			"lineno": 246,
			"filename": "IAuthenticatedUser.js",
			"path": "/lib/interfaces"
		},
		"order": 85
	},
	{
		"id": "IAuthenticatedUser#memberOf",
		"longname": "IAuthenticatedUser#memberOf",
		"name": "memberOf",
		"scope": "instance",
		"kind": "function",
		"description": "Attempts to get a guild member interface, returns null if this user is not\ra member of the `guild` or `guild` is not in cache.",
		"memberof": "IAuthenticatedUser",
		"params": [
			{
				"type": {
					"names": [
						"IGuild",
						"String"
					]
				},
				"name": "guild"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"IGuildMember",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 267,
			"filename": "IAuthenticatedUser.js",
			"path": "/lib/interfaces"
		},
		"order": 87
	},
	{
		"id": "IAuthenticatedUser#permissionsFor",
		"longname": "IAuthenticatedUser#permissionsFor",
		"name": "permissionsFor",
		"scope": "instance",
		"kind": "function",
		"description": "See `IUser.permissionsFor`.",
		"memberof": "IAuthenticatedUser",
		"params": [
			{
				"type": {
					"names": [
						"IChannel",
						"IGuild"
					]
				},
				"name": "context"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"IPermissions"
					]
				}
			}
		],
		"see": [
			"IUser.permissionsFor"
		],
		"meta": {
			"lineno": 277,
			"filename": "IAuthenticatedUser.js",
			"path": "/lib/interfaces"
		},
		"order": 88
	},
	{
		"id": "IAuthenticatedUser#can",
		"longname": "IAuthenticatedUser#can",
		"name": "can",
		"scope": "instance",
		"kind": "function",
		"description": "See `IUser.can`.",
		"memberof": "IAuthenticatedUser",
		"params": [
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"description": "One or multiple permission bits",
				"name": "permission"
			},
			{
				"type": {
					"names": [
						"IChannel",
						"IGuild"
					]
				},
				"name": "context"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"see": [
			"IUser.can"
		],
		"meta": {
			"lineno": 288,
			"filename": "IAuthenticatedUser.js",
			"path": "/lib/interfaces"
		},
		"order": 89
	},
	{
		"id": "IAuthenticatedUser#getVoiceChannel",
		"longname": "IAuthenticatedUser#getVoiceChannel",
		"name": "getVoiceChannel",
		"scope": "instance",
		"kind": "function",
		"description": "See `IUser.getVoiceChannel`.",
		"memberof": "IAuthenticatedUser",
		"params": [
			{
				"type": {
					"names": [
						"IGuild",
						"String"
					]
				},
				"description": "Guild or an id string",
				"name": "guild"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"IVoiceChannel",
						"null"
					]
				}
			}
		],
		"see": [
			"IUser.getVoiceChannel"
		],
		"meta": {
			"lineno": 298,
			"filename": "IAuthenticatedUser.js",
			"path": "/lib/interfaces"
		},
		"order": 90
	},
	{
		"id": "IChannel#createInvite",
		"longname": "IChannel#createInvite",
		"name": "createInvite",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to create an invite for this channel.",
		"memberof": "IChannel",
		"params": [
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"name": "options"
			}
		],
		"examples": [
			"channel.createInvite({\r  max_age: 60 * 60 * 24, // value in seconds\r  max_uses: 0, // pretty obvious\r  temporary: false\r  // temporary membership, kicks members without roles on disconnect\r});\r// Example response:\r{\r  \"max_age\": 86400,\r  \"code\": \"AAAAAAAAAAAAAAAA\",\r  \"guild\": {\r    \"splash_hash\": null,\r    \"id\": \"00000000000000000\",\r    \"name\": \"test\"\r  },\r  \"revoked\": false,\r  \"created_at\": \"2015-10-16T10:45:38.566978+00:00\",\r  \"temporary\": false,\r  \"uses\": 0,\r  \"max_uses\": 0,\r  \"inviter\": {\r    \"username\": \"testuser\",\r    \"discriminator\": \"3273\",\r    \"bot\": true,\r    \"id\": \"00000000000000000\",\r    \"avatar\": null\r  },\r  \"channel\": {\r    \"type\": \"text\",\r    \"id\": \"000000000000000000\",\r    \"name\": \"testchannel\"\r  }\r}"
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 151,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 106
	},
	{
		"id": "IChannel#createPermissionOverwrite",
		"longname": "IChannel#createPermissionOverwrite",
		"name": "createPermissionOverwrite",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to create a permission overwrite for this channel.",
		"memberof": "IChannel",
		"params": [
			{
				"type": {
					"names": [
						"IAuthenticatedUser",
						"IRole",
						"IGuildMember"
					]
				},
				"name": "roleOrMember"
			},
			{
				"type": {
					"names": [
						"IPermissions",
						"Number"
					]
				},
				"optional": true,
				"name": "allow"
			},
			{
				"type": {
					"names": [
						"IPermissions",
						"Number"
					]
				},
				"optional": true,
				"name": "deny"
			}
		],
		"examples": [
			"channel.createPermissionOverwrite(this.User);\rchannel.createPermissionOverwrite(\r  channel.guild.members.find(m => m.username == \"testuser\")\r);\rchannel.createPermissionOverwrite(\r  channel.guild.roles.find(r => r.name == \"new role\")\r)\r.then(overwrite => console.log(overwrite))\r.catch(error => console.log(error));"
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IPermissionOverwrite, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 172,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 107
	},
	{
		"id": "IChannel#update",
		"longname": "IChannel#update",
		"name": "update",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to update this channel.",
		"memberof": "IChannel",
		"params": [
			{
				"type": {
					"names": [
						"String"
					]
				},
				"optional": true,
				"name": "name"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"optional": true,
				"name": "topic"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "Only for voice channels",
				"name": "bitrate"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "Only for voice channels",
				"name": "userLimit"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IChannel, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 214,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 108
	},
	{
		"id": "IChannel#clone",
		"longname": "IChannel#clone",
		"name": "clone",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to create a new channel with permission overwrites of\rthis channel.",
		"memberof": "IChannel",
		"params": [
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "name"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "See IChannel / Discordie.ChannelTypes",
				"name": "type"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "Only for voice channels",
				"name": "bitrate"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "Only for voice channels",
				"name": "userLimit"
			}
		],
		"meta": {
			"lineno": 237,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 109
	},
	{
		"id": "IChannel#setPosition",
		"longname": "IChannel#setPosition",
		"name": "setPosition",
		"scope": "instance",
		"kind": "function",
		"description": "Moves this channel to `position` and makes a batch channel update request.",
		"memberof": "IChannel",
		"params": [
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"name": "position"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 256,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 110
	},
	{
		"id": "IChannel#delete",
		"longname": "IChannel#delete",
		"name": "delete",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to delete this channel.",
		"memberof": "IChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 272,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 111
	},
	{
		"id": "IChannel#getInvites",
		"longname": "IChannel#getInvites",
		"name": "getInvites",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to get a list of invites for this channel.",
		"memberof": "IChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Array.<Object>, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 280,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 112
	},
	{
		"id": "IChannelCollection#forGuild",
		"longname": "IChannelCollection#forGuild",
		"name": "forGuild",
		"scope": "instance",
		"kind": "function",
		"description": "Creates an array of `IChannel` (`ITextChannel` and `IVoiceChannel`)\rfor `guild`.",
		"memberof": "IChannelCollection",
		"params": [
			{
				"type": {
					"names": [
						"IGuild",
						"String"
					]
				},
				"name": "guild"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IChannel>"
					]
				}
			}
		],
		"meta": {
			"lineno": 38,
			"filename": "IChannelCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 115
	},
	{
		"id": "IChannelCollection#textForGuild",
		"longname": "IChannelCollection#textForGuild",
		"name": "textForGuild",
		"scope": "instance",
		"kind": "function",
		"description": "Creates an array of `ITextChannel` for `guild`.",
		"memberof": "IChannelCollection",
		"params": [
			{
				"type": {
					"names": [
						"IGuild",
						"String"
					]
				},
				"name": "guild"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<ITextChannel>"
					]
				}
			}
		],
		"meta": {
			"lineno": 47,
			"filename": "IChannelCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 116
	},
	{
		"id": "IChannelCollection#voiceForGuild",
		"longname": "IChannelCollection#voiceForGuild",
		"name": "voiceForGuild",
		"scope": "instance",
		"kind": "function",
		"description": "Creates an array of `IVoiceChannel` for `guild`.",
		"memberof": "IChannelCollection",
		"params": [
			{
				"type": {
					"names": [
						"IGuild",
						"String"
					]
				},
				"name": "guild"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IVoiceChannel>"
					]
				}
			}
		],
		"meta": {
			"lineno": 58,
			"filename": "IChannelCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 117
	},
	{
		"id": "ICollectionBase#getBy",
		"longname": "ICollectionBase#getBy",
		"name": "getBy",
		"scope": "instance",
		"kind": "function",
		"description": "Returns an an element, if `key` of an element in the collection\rwith exact `value` can be found.\rOtherwise null is returned.",
		"memberof": "ICollectionBase",
		"params": [
			{
				"name": "key"
			},
			{
				"name": "value"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"*"
					]
				}
			}
		],
		"meta": {
			"lineno": 34,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 118
	},
	{
		"id": "ICollectionBase#get",
		"longname": "ICollectionBase#get",
		"name": "get",
		"scope": "instance",
		"kind": "function",
		"description": "Returns an element with requested `id`, if exists in the collection.\rOtherwise null is returned.",
		"memberof": "ICollectionBase",
		"params": [
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "id"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"*"
					]
				}
			}
		],
		"meta": {
			"lineno": 55,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 119
	},
	{
		"id": "ICollectionBase#filter",
		"longname": "ICollectionBase#filter",
		"name": "filter",
		"scope": "instance",
		"kind": "function",
		"description": "Creates a new array with all elements that pass the test implemented\rby the provided function.",
		"memberof": "ICollectionBase",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array"
					]
				}
			}
		],
		"meta": {
			"lineno": 82,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 120
	},
	{
		"id": "ICollectionBase#find",
		"longname": "ICollectionBase#find",
		"name": "find",
		"scope": "instance",
		"kind": "function",
		"description": "Returns a value in the collection, if an element in the collection\rsatisfies the provided testing function. Otherwise null is returned.",
		"memberof": "ICollectionBase",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Object",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 110,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 121
	},
	{
		"id": "ICollectionBase#forEach",
		"longname": "ICollectionBase#forEach",
		"name": "forEach",
		"scope": "instance",
		"kind": "function",
		"description": "Executes a provided function once per element.",
		"memberof": "ICollectionBase",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"meta": {
			"lineno": 125,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 122
	},
	{
		"id": "ICollectionBase#map",
		"longname": "ICollectionBase#map",
		"name": "map",
		"scope": "instance",
		"kind": "function",
		"description": "Creates a new array with the results of calling a provided function on\revery element in this collection.",
		"memberof": "ICollectionBase",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array"
					]
				}
			}
		],
		"meta": {
			"lineno": 140,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 123
	},
	{
		"id": "ICollectionBase#toArray",
		"longname": "ICollectionBase#toArray",
		"name": "toArray",
		"scope": "instance",
		"kind": "function",
		"description": "Creates a new array with elements of this collection.",
		"memberof": "ICollectionBase",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Array"
					]
				}
			}
		],
		"meta": {
			"lineno": 164,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 124
	},
	{
		"id": "IDirectMessageChannel#isOwner",
		"longname": "IDirectMessageChannel#isOwner",
		"name": "isOwner",
		"scope": "instance",
		"kind": "function",
		"description": "Checks whether the `user` is the owner of the private channel.",
		"memberof": "IDirectMessageChannel",
		"params": [
			{
				"type": {
					"names": [
						"IGuildMember",
						"IUser",
						"IAuthenticatedUser",
						"String"
					]
				},
				"name": "user"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"meta": {
			"lineno": 108,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 135
	},
	{
		"id": "IDirectMessageChannel#fetchMessages",
		"longname": "IDirectMessageChannel#fetchMessages",
		"name": "fetchMessages",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to fetch messages for this channel.\r\rDiscord API does not allow fetching more than 100 messages at once.\r\rPromise resolves with an Object with following structure:\r```js\r{\r  messages: Array<IMessage>,\r  limit: Number, // same as parameter passed or default value\r  before: String | null, // message id\r  after: String | null // message id\r}\r```",
		"memberof": "IDirectMessageChannel",
		"params": [
			{
				"type": {
					"names": [
						"Number",
						"null"
					]
				},
				"optional": true,
				"description": "Default is 100",
				"name": "limit"
			},
			{
				"type": {
					"names": [
						"IMessage",
						"String",
						"null"
					]
				},
				"optional": true,
				"description": "Message or message id",
				"name": "before"
			},
			{
				"type": {
					"names": [
						"IMessage",
						"String",
						"null"
					]
				},
				"optional": true,
				"description": "Message or message id",
				"name": "after"
			}
		],
		"examples": [
			"var guild = client.Guilds.find(g => g.name == \"test\");\rvar channel = guild.generalChannel;\r\r// simple fetch:\rchannel.fetchMessages().then(() => {\r  console.log(\"[simple] messages in cache: \" + channel.messages.length);\r});\r\r// fetching more than 100 messages into cache sequentially:\rfetchMessagesEx(channel, 420).then(() => {\r  console.log(\"[extended] messages in cache: \" + channel.messages.length);\r});\r\r// fetch more messages just like Discord client does\rfunction fetchMessagesEx(channel, left) {\r  // message cache is sorted on insertion\r  // channel.messages[0] will get oldest message\r  var before = channel.messages[0];\r  return channel.fetchMessages(Math.min(left, 100), before)\r         .then(e => onFetch(e, channel, left));\r}\rfunction onFetch(e, channel, left) {\r  if (!e.messages.length) return Promise.resolve();\r  left -= e.messages.length;\r  console.log(`Received ${e.messages.length}, left: ${left}`);\r  if (left <= 0) return Promise.resolve();\r  return fetchMessagesEx(channel, left);\r}"
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 208,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 140
	},
	{
		"id": "IDirectMessageChannel#fetchPinned",
		"longname": "IDirectMessageChannel#fetchPinned",
		"name": "fetchPinned",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to fetch pinned messages for this channel.\r\rPromise resolves with an Object with following structure:\r```js\r{\r  channelId: String,\r  messages: Array<IMessage>\r}\r```",
		"memberof": "IDirectMessageChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 239,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 142
	},
	{
		"id": "IDirectMessageChannel#sendMessage",
		"longname": "IDirectMessageChannel#sendMessage",
		"name": "sendMessage",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to send a message to this channel. Messages over 2000\rcharacters will be rejected by the server.\r\rUse `uploadFile` if you want to send a message with an attachment.",
		"memberof": "IDirectMessageChannel",
		"params": [
			{
				"type": {
					"names": [
						"String",
						"Array.<String>"
					]
				},
				"description": "Strings will be sent as is, arrays - joined with a newline character.",
				"name": "content"
			},
			{
				"type": {
					"names": [
						"IUser",
						"IGuildMember",
						"Array.<IUser>",
						"Array.<IGuildMember>"
					]
				},
				"optional": true,
				"description": "Deprecated: left for backward compatibility.",
				"name": "mentions"
			},
			{
				"type": {
					"names": [
						"boolean"
					]
				},
				"optional": true,
				"name": "tts"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"optional": true,
				"description": "Refer to [official API documentation](https://discordapp.com/developers/docs/resources/channel#embed-object)\rfor embed structure description.",
				"name": "embed"
			}
		],
		"examples": [
			"var guild = client.Guilds.find(g => g.name == \"test\");\rif (!guild) return console.log(\"invalid guild\");\r\rvar channel = guild.generalChannel;\r\rchannel.sendMessage(\"regular message\");\rchannel.sendMessage(\"test with tts\", true);\r\rvar user = client.Users.find(u => u.username == \"test\");\rif (!user) return console.log(\"invalid user\");\r\rchannel.sendMessage(\"mentioning user \" + user.mention);\rchannel.sendMessage(\"@everyone or @here mention if you have permissions\");\r\rchannel.sendMessage(\"message with an embed\", false, {\r  color: 0x3498db,\r  author: {name: \"author name\"},\r  title: \"This is an embed\",\r  url: \"http://google.com\",\r  timestamp: \"2016-11-13T03:43:32.127Z\",\r  fields: [{name: \"some field\", value: \"some value\"}],\r  footer: {text: \"footer text\"}\r});"
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IMessage, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 290,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 143
	},
	{
		"id": "IDirectMessageChannel#uploadFile",
		"longname": "IDirectMessageChannel#uploadFile",
		"name": "uploadFile",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to upload data to this channel.\rImages require a `filename` with a valid extension to actually be uploaded.",
		"memberof": "IDirectMessageChannel",
		"params": [
			{
				"type": {
					"names": [
						"Buffer",
						"ReadableStream",
						"String"
					]
				},
				"description": "Data to upload or filename as a string",
				"name": "readableStream"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"description": "Actual filename to show, required for non-string `readableStream`",
				"name": "filename"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"optional": true,
				"description": "Additional comment message for attachment",
				"name": "content"
			},
			{
				"type": {
					"names": [
						"boolean"
					]
				},
				"optional": true,
				"name": "tts"
			}
		],
		"examples": [
			"channel.uploadFile(fs.readFileSync(\"test.png\"), \"test.png\"); // Buffer\rchannel.uploadFile(fs.createReadStream(\"test.png\"), \"test.png\"); // Stream\rchannel.uploadFile(\"test.png\"); // File\rchannel.uploadFile(\"test.png\", null, \"file with message\");\rchannel.uploadFile(\"test.png\", null, \"file with message and tts\", true);"
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IMessage, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 311,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 144
	},
	{
		"id": "IDirectMessageChannel#sendTyping",
		"longname": "IDirectMessageChannel#sendTyping",
		"name": "sendTyping",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to send typing status for this channel.\r\rDiscord client displays it for 10 seconds, sends every 5 seconds.\rStops showing typing status if receives a message from the user.",
		"memberof": "IDirectMessageChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 322,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 145
	},
	{
		"id": "IDirectMessageChannel#close",
		"longname": "IDirectMessageChannel#close",
		"name": "close",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to close this channel (direct message channels only).",
		"memberof": "IDirectMessageChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 330,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 146
	},
	{
		"id": "IDirectMessageChannel#ring",
		"longname": "IDirectMessageChannel#ring",
		"name": "ring",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to ring specified recipients.\rHas no effect if call has not started yet.\r\rBot accounts cannot use this endpoint.",
		"memberof": "IDirectMessageChannel",
		"params": [
			{
				"type": {
					"names": [
						"Array.<(IUser|String)>"
					]
				},
				"optional": true,
				"name": "recipients"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 342,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 147
	},
	{
		"id": "IDirectMessageChannel#stopRinging",
		"longname": "IDirectMessageChannel#stopRinging",
		"name": "stopRinging",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to decline an incoming call (if no arguments passed) or\rstop ringing for specified recipients.\r\rBot accounts cannot use this endpoint.",
		"memberof": "IDirectMessageChannel",
		"params": [
			{
				"type": {
					"names": [
						"Array.<(IUser|String)>"
					]
				},
				"optional": true,
				"name": "recipients"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 359,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 148
	},
	{
		"id": "IDirectMessageChannel#changeCallRegion",
		"longname": "IDirectMessageChannel#changeCallRegion",
		"name": "changeCallRegion",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to change the server region hosting the call.\r\rBot accounts cannot use this endpoint.",
		"memberof": "IDirectMessageChannel",
		"params": [
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "region"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 375,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 149
	},
	{
		"id": "IDirectMessageChannel#addRecipient",
		"longname": "IDirectMessageChannel#addRecipient",
		"name": "addRecipient",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to add a user to this private channel.\r\rBot accounts cannot use this endpoint.",
		"memberof": "IDirectMessageChannel",
		"params": [
			{
				"type": {
					"names": [
						"IUser",
						"IGuildMember"
					]
				},
				"name": "user"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 386,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 150
	},
	{
		"id": "IDirectMessageChannel#removeRecipient",
		"longname": "IDirectMessageChannel#removeRecipient",
		"name": "removeRecipient",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to remove a user from this private channel.\r\rBot accounts cannot use this endpoint.",
		"memberof": "IDirectMessageChannel",
		"params": [
			{
				"type": {
					"names": [
						"IUser",
						"IGuildMember"
					]
				},
				"name": "user"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 398,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 151
	},
	{
		"id": "IDirectMessageChannel#setName",
		"longname": "IDirectMessageChannel#setName",
		"name": "setName",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to set a name for this private channel.",
		"memberof": "IDirectMessageChannel",
		"params": [
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "name"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IDirectMessageChannel, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 408,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 152
	},
	{
		"id": "IDirectMessageChannel#setIcon",
		"longname": "IDirectMessageChannel#setIcon",
		"name": "setIcon",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to set an icon for this private channel.",
		"memberof": "IDirectMessageChannel",
		"params": [
			{
				"type": {
					"names": [
						"String",
						"Buffer",
						"null"
					]
				},
				"name": "icon"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IDirectMessageChannel, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 421,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 153
	},
	{
		"id": "IDirectMessageChannel#joinCall",
		"longname": "IDirectMessageChannel#joinCall",
		"name": "joinCall",
		"scope": "instance",
		"kind": "function",
		"description": "Creates or joins a call.\rOnly one call can be connected at the same time.\r\rJoining calls with bot accounts is not supported.",
		"memberof": "IDirectMessageChannel",
		"params": [
			{
				"type": {
					"names": [
						"boolean"
					]
				},
				"optional": true,
				"name": "selfMute"
			},
			{
				"type": {
					"names": [
						"boolean"
					]
				},
				"optional": true,
				"name": "selfDeaf"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<VoiceConnectionInfo, (Error|Number)>"
					]
				}
			}
		],
		"meta": {
			"lineno": 444,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 154
	},
	{
		"id": "IDirectMessageChannel#leaveCall",
		"longname": "IDirectMessageChannel#leaveCall",
		"name": "leaveCall",
		"scope": "instance",
		"kind": "function",
		"description": "Leaves call if joined.",
		"memberof": "IDirectMessageChannel",
		"params": [],
		"meta": {
			"lineno": 465,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 155
	},
	{
		"id": "IDirectMessageChannel#getVoiceConnectionInfo",
		"longname": "IDirectMessageChannel#getVoiceConnectionInfo",
		"name": "getVoiceConnectionInfo",
		"scope": "instance",
		"kind": "function",
		"description": "Retrieves `VoiceConnectionInfo` for the call of this channel.",
		"memberof": "IDirectMessageChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"VoiceConnectionInfo",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 477,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 156
	},
	{
		"id": "IDirectMessageChannel#fetchCall",
		"longname": "IDirectMessageChannel#fetchCall",
		"name": "fetchCall",
		"scope": "instance",
		"kind": "function",
		"description": "Fetches call info through gateway socket.\r\rCurrently there are no ways to fetch call info for all channels at once.",
		"memberof": "IDirectMessageChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<(ICall|null), Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 524,
			"filename": "IDirectMessageChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 160
	},
	{
		"id": "IDirectMessageChannelCollection#getOrOpen",
		"longname": "IDirectMessageChannelCollection#getOrOpen",
		"name": "getOrOpen",
		"scope": "instance",
		"kind": "function",
		"description": "Gets a DM channel from cache or makes a request to create one.",
		"memberof": "IDirectMessageChannelCollection",
		"params": [
			{
				"type": {
					"names": [
						"IUser",
						"IGuildMember",
						"String"
					]
				},
				"name": "recipient"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IDirectMessageChannel, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 31,
			"filename": "IDirectMessageChannelCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 164
	},
	{
		"id": "IDirectMessageChannelCollection#open",
		"longname": "IDirectMessageChannelCollection#open",
		"name": "open",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to create a DM channel.",
		"memberof": "IDirectMessageChannelCollection",
		"params": [
			{
				"type": {
					"names": [
						"IUser",
						"IGuildMember",
						"String"
					]
				},
				"name": "recipient"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IDirectMessageChannel, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 47,
			"filename": "IDirectMessageChannelCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 165
	},
	{
		"id": "IDirectMessageChannelCollection#createGroupDM",
		"longname": "IDirectMessageChannelCollection#createGroupDM",
		"name": "createGroupDM",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to create a group DM channel.\r\rBot accounts cannot use this endpoint.",
		"memberof": "IDirectMessageChannelCollection",
		"params": [
			{
				"type": {
					"names": [
						"Array.<(IUser|IGuildMember|String)>"
					]
				},
				"optional": true,
				"name": "recipients"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IDirectMessageChannel, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 59,
			"filename": "IDirectMessageChannelCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 166
	},
	{
		"id": "IGuild#isOwner",
		"longname": "IGuild#isOwner",
		"name": "isOwner",
		"scope": "instance",
		"kind": "function",
		"description": "Checks whether the `user` is the owner of this guild.",
		"memberof": "IGuild",
		"params": [
			{
				"type": {
					"names": [
						"IGuildMember",
						"IUser",
						"IAuthenticatedUser",
						"String"
					]
				},
				"name": "user"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"meta": {
			"lineno": 70,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 171
	},
	{
		"id": "IGuild#edit",
		"longname": "IGuild#edit",
		"name": "edit",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to edit this guild,\rsubstituting `undefined` or `null` properties with current values.\r\rPassing `null` in `icon` or `afkChannelId` will remove current\ricon/channel. Use `undefined` instead of `null` in this case.",
		"memberof": "IGuild",
		"params": [
			{
				"type": {
					"names": [
						"String"
					]
				},
				"optional": true,
				"name": "name"
			},
			{
				"type": {
					"names": [
						"String",
						"Buffer",
						"null"
					]
				},
				"optional": true,
				"name": "icon"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"optional": true,
				"name": "region"
			},
			{
				"type": {
					"names": [
						"IChannel",
						"String",
						"null"
					]
				},
				"optional": true,
				"description": "Channel or an id string",
				"name": "afkChannelId"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "60, 300, 900, 1800 or 3600 seconds",
				"name": "afkTimeout"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "See Discordie.VerificationLevel",
				"name": "verificationLevel"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "See Discordie.UserNotificationSettings",
				"name": "defaultMessageNotifications"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IGuild, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 158,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 178
	},
	{
		"id": "IGuild#createChannel",
		"longname": "IGuild#createChannel",
		"name": "createChannel",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to create a channel in this guild.",
		"memberof": "IGuild",
		"params": [
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"description": "See IChannel / Discordie.ChannelTypes",
				"name": "type"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "name"
			},
			{
				"type": {
					"names": [
						"Array.<IPermissionOverwrite>"
					]
				},
				"optional": true,
				"name": "permissionOverwrites"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "Only for voice channels",
				"name": "bitrate"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "Only for voice channels",
				"name": "userLimit"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<(ITextChannel|IVoiceChannel), Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 206,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 179
	},
	{
		"id": "IGuild#createRole",
		"longname": "IGuild#createRole",
		"name": "createRole",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to create a role in this guild.",
		"memberof": "IGuild",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IRole, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 229,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 180
	},
	{
		"id": "IGuild#createInvite",
		"longname": "IGuild#createInvite",
		"name": "createInvite",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to create an invite for general channel in this guild.\r\rSee `IChannel.createInvite` for more info.",
		"memberof": "IGuild",
		"params": [
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"name": "options"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"see": [
			"IChannel.createInvite"
		],
		"meta": {
			"lineno": 245,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 181
	},
	{
		"id": "IGuild#delete",
		"longname": "IGuild#delete",
		"name": "delete",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to delete this guild.\r\rReturns a rejected promise if the user **is not** owner.",
		"memberof": "IGuild",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 264,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 183
	},
	{
		"id": "IGuild#leave",
		"longname": "IGuild#leave",
		"name": "leave",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to delete this guild.\r\rReturns a rejected promise if the user **is** owner.",
		"memberof": "IGuild",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 276,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 184
	},
	{
		"id": "IGuild#ban",
		"longname": "IGuild#ban",
		"name": "ban",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to ban a user (does not have to be a member of the guild).\r\rAdditionally delete `deleteMessageForDays` number of days worth of their\rmessages from all channels of the guild.",
		"memberof": "IGuild",
		"params": [
			{
				"type": {
					"names": [
						"IUser",
						"String"
					]
				},
				"description": "User or an id string",
				"name": "user"
			},
			{
				"description": "Number of days worth of messages to delete\r                              (min 0, max 7)",
				"name": "deleteMessageForDays"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 292,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 185
	},
	{
		"id": "IGuild#unban",
		"longname": "IGuild#unban",
		"name": "unban",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to unban a user.",
		"memberof": "IGuild",
		"params": [
			{
				"type": {
					"names": [
						"IUser",
						"String"
					]
				},
				"description": "User or an id string",
				"name": "user"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 303,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 186
	},
	{
		"id": "IGuild#getBans",
		"longname": "IGuild#getBans",
		"name": "getBans",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to get ban list of this guild.",
		"memberof": "IGuild",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Array.<IUser>, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 312,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 187
	},
	{
		"id": "IGuild#getPruneEstimate",
		"longname": "IGuild#getPruneEstimate",
		"name": "getPruneEstimate",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to get estimate of members affected by prune request.\r\rPromise resolves with an Object with following structure:\r```js\r{\r  guildId: String,\r  days: Number, // same as parameter passed\r  estimate: Number\r}\r```",
		"memberof": "IGuild",
		"params": [
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"description": "Number of days from 1 to 7, default 1",
				"name": "days"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 339,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 188
	},
	{
		"id": "IGuild#pruneMembers",
		"longname": "IGuild#pruneMembers",
		"name": "pruneMembers",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to prune members.\r\rPromise resolves with an Object with following structure:\r```js\r{\r  guildId: String,\r  days: Number, // same as parameter passed\r  pruned: Number\r}\r```",
		"memberof": "IGuild",
		"params": [
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"description": "Number of days from 1 to 7, default 1",
				"name": "days"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 357,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 189
	},
	{
		"id": "IGuild#getInvites",
		"longname": "IGuild#getInvites",
		"name": "getInvites",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to get a list of invites of this guild.",
		"memberof": "IGuild",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Array.<Object>, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 369,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 190
	},
	{
		"id": "IGuild#fetchRegions",
		"longname": "IGuild#fetchRegions",
		"name": "fetchRegions",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to get a list of voice regions available for this guild.",
		"memberof": "IGuild",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Array.<Object>, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 377,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 191
	},
	{
		"id": "IGuild#transferOwnership",
		"longname": "IGuild#transferOwnership",
		"name": "transferOwnership",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to transfer ownership of this guild to `user`.",
		"memberof": "IGuild",
		"params": [
			{
				"type": {
					"names": [
						"IGuildMember",
						"IUser",
						"String"
					]
				},
				"description": "User or an id string",
				"name": "user"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IGuild, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 386,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 192
	},
	{
		"id": "IGuild#getWidget",
		"longname": "IGuild#getWidget",
		"name": "getWidget",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to get widget (external embed) settings.\r\rPromise resolves with an Object with following structure:\r```js\r{\r  enabled: boolean,\r  channel_id: String|null\r}\r```",
		"memberof": "IGuild",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 407,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 193
	},
	{
		"id": "IGuild#editWidget",
		"longname": "IGuild#editWidget",
		"name": "editWidget",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to set widget (external embed) settings.",
		"memberof": "IGuild",
		"params": [
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"description": "Object `{enabled: boolean, channelId or channel_id: String}`.\rBoth options are optional.",
				"name": "options"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 418,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 194
	},
	{
		"id": "IGuild#fetchEmoji",
		"longname": "IGuild#fetchEmoji",
		"name": "fetchEmoji",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to fetch emojis for this guild.\r\rOnly user and whitelisted bot accounts can use this endpoint.\r\rPromise resolves with an array of Objects with following structure:\r```js\r{\r  \"managed\": false,\r  \"name\": 'abc',\r  \"roles\": [],\r  \"user\": {\r    \"username\": \"testuser\",\r    \"discriminator\": \"3273\",\r    \"id\": \"000000000000000000\",\r    \"avatar\": null\r  },\r  \"require_colons\": true,\r  \"id\": \"000000000000000000\"\r}\r```",
		"memberof": "IGuild",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Array.<Object>, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 445,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 195
	},
	{
		"id": "IGuild#uploadEmoji",
		"longname": "IGuild#uploadEmoji",
		"name": "uploadEmoji",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to create an emoji.\r\rReturned object does not contain `user` property.\r\rOnly user and whitelisted bot accounts can use this endpoint.",
		"memberof": "IGuild",
		"params": [
			{
				"type": {
					"names": [
						"Buffer",
						"String"
					]
				},
				"description": "Buffer or base64 image string",
				"name": "image"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "name"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 459,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 196
	},
	{
		"id": "IGuild#deleteEmoji",
		"longname": "IGuild#deleteEmoji",
		"name": "deleteEmoji",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to delete the specified emoji.\r\rOnly user and whitelisted bot accounts can use this endpoint.",
		"memberof": "IGuild",
		"params": [
			{
				"type": {
					"names": [
						"Object",
						"String"
					]
				},
				"description": "Emoji object or an id string",
				"name": "emoji"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 474,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 197
	},
	{
		"id": "IGuild#editEmoji",
		"longname": "IGuild#editEmoji",
		"name": "editEmoji",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to edit the specified emoji.\r\rReturned object does not contain `user` property.\r\rOnly user and whitelisted bot accounts can use this endpoint.",
		"memberof": "IGuild",
		"params": [
			{
				"type": {
					"names": [
						"Object",
						"String"
					]
				},
				"description": "Emoji object or an id string",
				"name": "emoji"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"description": "Optional properties to edit:\r`{name: String, roles: Array<IRole>|Array<String>}`",
				"name": "options"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 492,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 198
	},
	{
		"id": "IGuild#getEmojiURL",
		"longname": "IGuild#getEmojiURL",
		"name": "getEmojiURL",
		"scope": "instance",
		"kind": "function",
		"description": "Creates a string URL of an emoji.",
		"memberof": "IGuild",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 514,
			"filename": "IGuild.js",
			"path": "/lib/interfaces"
		},
		"order": 199
	},
	{
		"id": "IGuildCollection#create",
		"longname": "IGuildCollection#create",
		"name": "create",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to create a guild.",
		"memberof": "IGuildCollection",
		"params": [
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "name"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "region"
			},
			{
				"type": {
					"names": [
						"Buffer",
						"null"
					]
				},
				"optional": true,
				"name": "icon"
			},
			{
				"type": {
					"names": [
						"Array.<(IRole|Object)>"
					]
				},
				"optional": true,
				"name": "roles"
			},
			{
				"type": {
					"names": [
						"Array.<(IChannel|Object)>"
					]
				},
				"optional": true,
				"name": "channels"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "See Discordie.VerificationLevel",
				"name": "verificationLevel"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "See Discordie.UserNotificationSettings",
				"name": "defaultMessageNotifications"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IGuild, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 37,
			"filename": "IGuildCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 202
	},
	{
		"id": "IGuildCollection#fetchRegions",
		"longname": "IGuildCollection#fetchRegions",
		"name": "fetchRegions",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to get a default list of voice regions.\rUse IGuild.fetchRegions for getting guild-specific list.",
		"memberof": "IGuildCollection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Array.<Object>, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 73,
			"filename": "IGuildCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 203
	},
	{
		"id": "IGuildMember#getVoiceChannel",
		"longname": "IGuildMember#getVoiceChannel",
		"name": "getVoiceChannel",
		"scope": "instance",
		"kind": "function",
		"overrides": "IUser#getVoiceChannel",
		"description": "Gets the first voice channel that this member is currently in.",
		"memberof": "IGuildMember",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"IVoiceChannel",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 100,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 213
	},
	{
		"id": "IGuildMember#kick",
		"longname": "IGuildMember#kick",
		"name": "kick",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to kick this member (from the guild they belong to).",
		"memberof": "IGuildMember",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 108,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 214
	},
	{
		"id": "IGuildMember#ban",
		"longname": "IGuildMember#ban",
		"name": "ban",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to ban this member (from the guild they belong to).\r\rAdditionally delete `deleteMessageForDays` number of days worth of their\rmessages from all channels of the guild.",
		"memberof": "IGuildMember",
		"params": [
			{
				"description": "Number of days worth of messages to delete\r                              (min 0, max 7)",
				"name": "deleteMessageForDays"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 122,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 215
	},
	{
		"id": "IGuildMember#unban",
		"longname": "IGuildMember#unban",
		"name": "unban",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to unban this member (from the guild they belonged to).",
		"memberof": "IGuildMember",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 131,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 216
	},
	{
		"id": "IGuildMember#serverMute",
		"longname": "IGuildMember#serverMute",
		"name": "serverMute",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to mute this member globally in the guild.\r\rReturns a resolved promise if the member is already muted.",
		"memberof": "IGuildMember",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 142,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 217
	},
	{
		"id": "IGuildMember#serverUnmute",
		"longname": "IGuildMember#serverUnmute",
		"name": "serverUnmute",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to unmute this member globally in the guild.\r\rReturns a resolved promise if the member is already unmuted.",
		"memberof": "IGuildMember",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 155,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 218
	},
	{
		"id": "IGuildMember#serverDeafen",
		"longname": "IGuildMember#serverDeafen",
		"name": "serverDeafen",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to deafen this member globally in the guild.\r\rReturns a resolved promise if the member is already deafened.",
		"memberof": "IGuildMember",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 165,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 219
	},
	{
		"id": "IGuildMember#serverUndeafen",
		"longname": "IGuildMember#serverUndeafen",
		"name": "serverUndeafen",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to undeafen this member globally in the guild.\r\rReturns a resolved promise if the member is already undeafened.",
		"memberof": "IGuildMember",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 178,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 220
	},
	{
		"id": "IGuildMember#hasRole",
		"longname": "IGuildMember#hasRole",
		"name": "hasRole",
		"scope": "instance",
		"kind": "function",
		"description": "Checks if this member has the specified role.",
		"memberof": "IGuildMember",
		"params": [
			{
				"type": {
					"names": [
						"IRole",
						"String"
					]
				},
				"description": "Role or an id string",
				"name": "role"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 187,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 221
	},
	{
		"id": "IGuildMember#assignRole",
		"longname": "IGuildMember#assignRole",
		"name": "assignRole",
		"scope": "instance",
		"kind": "function",
		"description": "Assigns (adds) the specified role to this member.",
		"memberof": "IGuildMember",
		"params": [
			{
				"type": {
					"names": [
						"IRole",
						"String"
					]
				},
				"description": "Role or an id string",
				"name": "role"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 197,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 222
	},
	{
		"id": "IGuildMember#unassignRole",
		"longname": "IGuildMember#unassignRole",
		"name": "unassignRole",
		"scope": "instance",
		"kind": "function",
		"description": "Unassigns (removes) the specified role from this member.",
		"memberof": "IGuildMember",
		"params": [
			{
				"type": {
					"names": [
						"IRole",
						"String"
					]
				},
				"description": "Role or an id string",
				"name": "role"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 218,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 223
	},
	{
		"id": "IGuildMember#setRoles",
		"longname": "IGuildMember#setRoles",
		"name": "setRoles",
		"scope": "instance",
		"kind": "function",
		"description": "Sets specified roles for this member: overwrites all existing roles\rwith a new set of roles.",
		"memberof": "IGuildMember",
		"params": [
			{
				"type": {
					"names": [
						"Array.<(IRole|String)>"
					]
				},
				"description": "Array of roles or id strings",
				"name": "roles"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 240,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 224
	},
	{
		"id": "IGuildMember#setChannel",
		"longname": "IGuildMember#setChannel",
		"name": "setChannel",
		"scope": "instance",
		"kind": "function",
		"description": "Moves this member to the specified voice channel.",
		"memberof": "IGuildMember",
		"params": [
			{
				"type": {
					"names": [
						"IChannel",
						"String"
					]
				},
				"description": "Channel or an id string",
				"name": "channel"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 251,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 225
	},
	{
		"id": "IGuildMember#setNickname",
		"longname": "IGuildMember#setNickname",
		"name": "setNickname",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to set a nickname for this member.\r\rRequires permission `MANAGE_NICKNAMES`.",
		"memberof": "IGuildMember",
		"params": [
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "nick"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 264,
			"filename": "IGuildMember.js",
			"path": "/lib/interfaces"
		},
		"order": 226
	},
	{
		"id": "IInviteManager#create",
		"longname": "IInviteManager#create",
		"name": "create",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to create an invite.\rSee `IChannel.createInvite` for more info.",
		"memberof": "IInviteManager",
		"params": [
			{
				"type": {
					"names": [
						"IChannel",
						"String"
					]
				},
				"name": "channel"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"name": "options"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"see": [
			"IChannel.createInvite"
		],
		"meta": {
			"lineno": 25,
			"filename": "IInviteManager.js",
			"path": "/lib/interfaces"
		},
		"order": 229
	},
	{
		"id": "IInviteManager#regenerate",
		"longname": "IInviteManager#regenerate",
		"name": "regenerate",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to regenerate existing invite.",
		"memberof": "IInviteManager",
		"params": [
			{
				"type": {
					"names": [
						"Object",
						"String"
					]
				},
				"name": "code"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 43,
			"filename": "IInviteManager.js",
			"path": "/lib/interfaces"
		},
		"order": 230
	},
	{
		"id": "IInviteManager#revoke",
		"longname": "IInviteManager#revoke",
		"name": "revoke",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to revoke existing invite.",
		"memberof": "IInviteManager",
		"params": [
			{
				"type": {
					"names": [
						"Object",
						"String"
					]
				},
				"name": "code"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 54,
			"filename": "IInviteManager.js",
			"path": "/lib/interfaces"
		},
		"order": 231
	},
	{
		"id": "IInviteManager#resolve",
		"longname": "IInviteManager#resolve",
		"name": "resolve",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to resolve existing invite.",
		"memberof": "IInviteManager",
		"params": [
			{
				"type": {
					"names": [
						"Object",
						"String"
					]
				},
				"name": "code"
			}
		],
		"examples": [
			"client.Invites.resolve(\"Zt5yW\").then(console.log).catch(console.log);\r// Example response:\r{\r  \"code\": \"Zt5yW\",\r  \"guild\": {\r    \"splash_hash\": null,\r    \"id\": \"00000000000000000\",\r    \"name\": \"test\"\r  },\r  \"channel\": {\r    \"type\": \"text\",\r    \"id\": \"000000000000000000\",\r    \"name\": \"testchannel\"\r  }\r}"
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 80,
			"filename": "IInviteManager.js",
			"path": "/lib/interfaces"
		},
		"order": 232
	},
	{
		"id": "IInviteManager#accept",
		"longname": "IInviteManager#accept",
		"name": "accept",
		"scope": "instance",
		"kind": "function",
		"description": "**Deprecated**: Only works with user accounts.\rBot accounts can be invited by users with Manage Server permission using\rthe `https://discordapp.com/oauth2/authorize?client_id=%APP_ID%&scope=bot`\rpage. See official Discord API documentation for more info.\r\rMakes a request to accept existing invite.",
		"memberof": "IInviteManager",
		"params": [
			{
				"type": {
					"names": [
						"Object",
						"String"
					]
				},
				"name": "code"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 95,
			"filename": "IInviteManager.js",
			"path": "/lib/interfaces"
		},
		"order": 233
	},
	{
		"id": "IMessage#resolveContent",
		"longname": "IMessage#resolveContent",
		"name": "resolveContent",
		"scope": "instance",
		"kind": "function",
		"description": "Resolves user and channel references in `content` property to proper names.\rReferences that are not found in cache will be left as is and not resolved.\r\rReturns null if this message is not cached.",
		"memberof": "IMessage",
		"params": [],
		"examples": [
			"var content = message.content;\r// 'just a message for <@157838423632817262> in <#78826383786329613>'\rvar resolvedContent = message.resolveContent();\r// 'just a message for @testie in #general'\rvar resolvedContent = client.Messages.resolveContent(message.content);\r// 'just a message for @testie in #general'"
		],
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 224,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 245
	},
	{
		"id": "IMessage#edit",
		"longname": "IMessage#edit",
		"name": "edit",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to edit this message.\r\rEditing of other users' messages is not allowed, server will send an\r`Error` `Forbidden` and returned promise will be rejected if you attempt\rto do so.\r\rSee `IMessageCollection.editMessage` if you are looking for a method\rthat can operate on JSON or raw message id.",
		"memberof": "IMessage",
		"params": [
			{
				"type": {
					"names": [
						"String"
					]
				},
				"optional": true,
				"name": "content"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"optional": true,
				"description": "Refer to [official API documentation](https://discordapp.com/developers/docs/resources/channel#embed-object)\rfor embed structure description.",
				"name": "embed"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IMessage, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 244,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 246
	},
	{
		"id": "IMessage#delete",
		"longname": "IMessage#delete",
		"name": "delete",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to delete this message.\r\rSee `IMessageCollection.deleteMessage` if you are looking for a method\rthat can operate on JSON or raw message id.",
		"memberof": "IMessage",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 263,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 247
	},
	{
		"id": "IMessage#pin",
		"longname": "IMessage#pin",
		"name": "pin",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to pin this message.\r\rSee `IMessageCollection.pinMessage` if you are looking for a method\rthat can operate on JSON or raw message id.",
		"memberof": "IMessage",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IMessage, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 275,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 248
	},
	{
		"id": "IMessage#unpin",
		"longname": "IMessage#unpin",
		"name": "unpin",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to unpin this message.\r\rSee `IMessageCollection.unpinMessage` if you are looking for a method\rthat can operate on JSON or raw message id.",
		"memberof": "IMessage",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IMessage, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 291,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 249
	},
	{
		"id": "IMessage#fetchReactions",
		"longname": "IMessage#fetchReactions",
		"name": "fetchReactions",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to fetch users who reacted to this message with the\rspecified emoji.",
		"memberof": "IMessage",
		"params": [
			{
				"type": {
					"names": [
						"Object",
						"String"
					]
				},
				"description": "Partial emoji `{id: String|null, name: String}` or a unicode emoji",
				"name": "emoji"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "Max 100 users per fetch",
				"name": "limit"
			},
			{
				"type": {
					"names": [
						"IUser",
						"String"
					]
				},
				"optional": true,
				"description": "Start list from specified user id",
				"name": "after"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Array.<IUser>, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 309,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 250
	},
	{
		"id": "IMessage#addReaction",
		"longname": "IMessage#addReaction",
		"name": "addReaction",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to add a reaction to this message with the specified\remoji.",
		"memberof": "IMessage",
		"params": [
			{
				"type": {
					"names": [
						"Object",
						"String"
					]
				},
				"description": "Partial emoji `{id: String|null, name: String}` or a unicode emoji",
				"name": "emoji"
			}
		],
		"examples": [
			"message.addReaction(message.reactions[0].emoji);\rmessage.addReaction(\"\\uD83D\\uDE2C\");"
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 332,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 251
	},
	{
		"id": "IMessage#removeReaction",
		"longname": "IMessage#removeReaction",
		"name": "removeReaction",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to remove a reaction to this message with the specified\remoji.",
		"memberof": "IMessage",
		"params": [
			{
				"type": {
					"names": [
						"Object",
						"String"
					]
				},
				"description": "Partial emoji `{id: String|null, name: String}` or a unicode emoji",
				"name": "emoji"
			},
			{
				"type": {
					"names": [
						"IUser",
						"String"
					]
				},
				"optional": true,
				"description": "Remove reaction of another user",
				"name": "user"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 347,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 252
	},
	{
		"id": "IMessage#clearReactions",
		"longname": "IMessage#clearReactions",
		"name": "clearReactions",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to remove all reactions from this message.",
		"memberof": "IMessage",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 359,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 253
	},
	{
		"id": "IMessage#reply",
		"longname": "IMessage#reply",
		"name": "reply",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to send a reply to channel the message was from, prefixing\rcontent with author's mention in non-private channels.",
		"memberof": "IMessage",
		"params": [
			{
				"type": {
					"names": [
						"String",
						"Array.<String>"
					]
				},
				"description": "Strings will be sent as is, arrays - joined with a newline character.",
				"name": "content"
			},
			{
				"type": {
					"names": [
						"IUser",
						"IGuildMember",
						"Array.<IUser>",
						"Array.<IGuildMember>"
					]
				},
				"optional": true,
				"description": "Deprecated: left for backward compatibility.",
				"name": "mentions"
			},
			{
				"type": {
					"names": [
						"boolean"
					]
				},
				"optional": true,
				"name": "tts"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"optional": true,
				"description": "Refer to [official API documentation](https://discordapp.com/developers/docs/resources/channel#embed-object)\rfor embed structure description.",
				"name": "embed"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IMessage, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 377,
			"filename": "IMessage.js",
			"path": "/lib/interfaces"
		},
		"order": 254
	},
	{
		"id": "IMessageCollection#forChannel",
		"longname": "IMessageCollection#forChannel",
		"name": "forChannel",
		"scope": "instance",
		"kind": "function",
		"description": "Creates an array of cached messages in `channel`, sorted in order of\rarrival (message cache is sorted on message insertion, not when this\rgetter is invoked).\r\rReturns an empty array if channel no longer exists.\r\r> **Note:** Message cache also includes deleted messages.\r>           You can filter them by checking `IMessage.deleted` boolean.",
		"memberof": "IMessageCollection",
		"params": [
			{
				"type": {
					"names": [
						"IChannel",
						"String"
					]
				},
				"name": "channel"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IMessage>"
					]
				}
			}
		],
		"meta": {
			"lineno": 42,
			"filename": "IMessageCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 259
	},
	{
		"id": "IMessageCollection#purgeChannelCache",
		"longname": "IMessageCollection#purgeChannelCache",
		"name": "purgeChannelCache",
		"scope": "instance",
		"kind": "function",
		"description": "Purges channel cache.",
		"memberof": "IMessageCollection",
		"params": [
			{
				"type": {
					"names": [
						"IChannel",
						"String"
					]
				},
				"name": "channel"
			}
		],
		"meta": {
			"lineno": 52,
			"filename": "IMessageCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 260
	},
	{
		"id": "IMessageCollection#forChannelPinned",
		"longname": "IMessageCollection#forChannelPinned",
		"name": "forChannelPinned",
		"scope": "instance",
		"kind": "function",
		"description": "Creates an array of cached pinned messages in `channel`.\r\rPinned message cache is updated only if all pinned messages have been\rloaded with `ITextChannel.fetchPinned()`.\r\rReturns an empty array if channel no longer exists or if pinned messages\rhave not been fetched yet.",
		"memberof": "IMessageCollection",
		"params": [
			{
				"type": {
					"names": [
						"IChannel",
						"String"
					]
				},
				"name": "channel"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IMessage>"
					]
				}
			}
		],
		"meta": {
			"lineno": 68,
			"filename": "IMessageCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 261
	},
	{
		"id": "IMessageCollection#purgeChannelPinned",
		"longname": "IMessageCollection#purgeChannelPinned",
		"name": "purgeChannelPinned",
		"scope": "instance",
		"kind": "function",
		"description": "Purges pinned message cache for `channel`.",
		"memberof": "IMessageCollection",
		"params": [
			{
				"type": {
					"names": [
						"IChannel",
						"String"
					]
				},
				"name": "channel"
			}
		],
		"meta": {
			"lineno": 78,
			"filename": "IMessageCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 262
	},
	{
		"id": "IMessageCollection#purgePinned",
		"longname": "IMessageCollection#purgePinned",
		"name": "purgePinned",
		"scope": "instance",
		"kind": "function",
		"description": "Purges pinned message cache globally.",
		"memberof": "IMessageCollection",
		"params": [],
		"meta": {
			"lineno": 86,
			"filename": "IMessageCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 263
	},
	{
		"id": "IMessageCollection#purgeEdits",
		"longname": "IMessageCollection#purgeEdits",
		"name": "purgeEdits",
		"scope": "instance",
		"kind": "function",
		"description": "Purges edits cache globally.",
		"memberof": "IMessageCollection",
		"params": [],
		"meta": {
			"lineno": 93,
			"filename": "IMessageCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 264
	},
	{
		"id": "IMessageCollection#purgeAllCache",
		"longname": "IMessageCollection#purgeAllCache",
		"name": "purgeAllCache",
		"scope": "instance",
		"kind": "function",
		"description": "Purges message cache globally.",
		"memberof": "IMessageCollection",
		"params": [],
		"meta": {
			"lineno": 100,
			"filename": "IMessageCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 265
	},
	{
		"id": "IMessageCollection#getChannelMessageLimit",
		"longname": "IMessageCollection#getChannelMessageLimit",
		"name": "getChannelMessageLimit",
		"scope": "instance",
		"kind": "function",
		"description": "Gets channel message cache limit.",
		"memberof": "IMessageCollection",
		"params": [
			{
				"type": {
					"names": [
						"IChannel",
						"String"
					]
				},
				"name": "channel"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Number"
					]
				}
			}
		],
		"meta": {
			"lineno": 109,
			"filename": "IMessageCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 266
	},
	{
		"id": "IMessageCollection#setChannelMessageLimit",
		"longname": "IMessageCollection#setChannelMessageLimit",
		"name": "setChannelMessageLimit",
		"scope": "instance",
		"kind": "function",
		"description": "Sets channel message cache limit (with a minimum of 1).\rLimit reverts to default when channel (or cache) is destroyed.\rReturns false if limit is invalid or channel does not exist.",
		"memberof": "IMessageCollection",
		"params": [
			{
				"type": {
					"names": [
						"IChannel",
						"String"
					]
				},
				"name": "channel"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"name": "limit"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Boolean"
					]
				}
			}
		],
		"meta": {
			"lineno": 122,
			"filename": "IMessageCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 267
	},
	{
		"id": "IMessageCollection#getMessageLimit",
		"longname": "IMessageCollection#getMessageLimit",
		"name": "getMessageLimit",
		"scope": "instance",
		"kind": "function",
		"description": "Gets global message cache limit per channel.",
		"memberof": "IMessageCollection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Number"
					]
				}
			}
		],
		"meta": {
			"lineno": 131,
			"filename": "IMessageCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 268
	},
	{
		"id": "IMessageCollection#setMessageLimit",
		"longname": "IMessageCollection#setMessageLimit",
		"name": "setMessageLimit",
		"scope": "instance",
		"kind": "function",
		"description": "Sets global message cache limit per channel (with a minimum of 1).\rDoes not affect channels with custom limits if new is lower than current.",
		"memberof": "IMessageCollection",
		"params": [
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"name": "limit"
			}
		],
		"meta": {
			"lineno": 140,
			"filename": "IMessageCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 269
	},
	{
		"id": "IMessageCollection#getEditsLimit",
		"longname": "IMessageCollection#getEditsLimit",
		"name": "getEditsLimit",
		"scope": "instance",
		"kind": "function",
		"description": "Gets global edits cache limit per message.",
		"memberof": "IMessageCollection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Number"
					]
				}
			}
		],
		"meta": {
			"lineno": 148,
			"filename": "IMessageCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 270
	},
	{
		"id": "IMessageCollection#setEditsLimit",
		"longname": "IMessageCollection#setEditsLimit",
		"name": "setEditsLimit",
		"scope": "instance",
		"kind": "function",
		"description": "Sets global edits cache limit per message.",
		"memberof": "IMessageCollection",
		"params": [
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"name": "limit"
			}
		],
		"meta": {
			"lineno": 156,
			"filename": "IMessageCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 271
	},
	{
		"id": "IMessageCollection#editMessage",
		"longname": "IMessageCollection#editMessage",
		"name": "editMessage",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to edit a message.\rAlternative method for editing messages that are not in cache.\r\rEditing of other users' messages is not allowed, server will send an\r`Error` `Forbidden` and returned promise will be rejected if you attempt\rto do so.\r\rParameter `messageId` can be an object with fields `{channel_id, id}`,\rwhere `id` is a String message id, `channel_id` is a String channel id.\r\rParameter `channelId` is ignored when `messageId` is an object or\ran instance of `IMessage`.\r\rReturns a promise that resolves to a JSON object of the edited message.",
		"memberof": "IMessageCollection",
		"params": [
			{
				"type": {
					"names": [
						"String",
						"Object"
					]
				},
				"optional": true,
				"name": "content"
			},
			{
				"type": {
					"names": [
						"IMessage",
						"Object",
						"String"
					]
				},
				"name": "messageId"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"description": "Ignored if `messageId` is an object with `id`",
				"name": "channelId"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"optional": true,
				"description": "Refer to [official API documentation](https://discordapp.com/developers/docs/resources/channel#embed-object)\rfor embed structure description.",
				"name": "embed"
			}
		],
		"examples": [
			"var message = client.Messages.find(m => true); // get any message\rclient.Messages.editMessage(\"new content\", message);\r\rvar jsonMessage = {id: message.id, channel_id: message.channel_id};\rclient.Messages.editMessage(\"new content\", jsonMessage);\r\rclient.Messages.editMessage(\"new content\", message.id, message.channel_id);"
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 192,
			"filename": "IMessageCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 272
	},
	{
		"id": "IMessageCollection#deleteMessage",
		"longname": "IMessageCollection#deleteMessage",
		"name": "deleteMessage",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to delete a message.\rAlternative method for deleting messages that are not in cache.\r\rParameter `messageId` can be an object with fields `{channel_id, id}`,\rwhere `id` is a String message id, `channel_id` is a String channel id.\r\rParameter `channelId` is ignored when `messageId` is an object or\ran instance of `IMessage`.",
		"memberof": "IMessageCollection",
		"params": [
			{
				"type": {
					"names": [
						"IMessage",
						"Object",
						"String"
					]
				},
				"name": "messageId"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"description": "Ignored if `messageId` is an object with `id`",
				"name": "channelId"
			}
		],
		"examples": [
			"var message = client.Messages.find(m => true); // get any message\rclient.Messages.deleteMessage(message);\r\rvar jsonMessage = {id: message.id, channel_id: message.channel_id};\rclient.Messages.deleteMessage(jsonMessage);\r\rclient.Messages.deleteMessage(message.id, message.channel_id);"
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 229,
			"filename": "IMessageCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 273
	},
	{
		"id": "IMessageCollection#pinMessage",
		"longname": "IMessageCollection#pinMessage",
		"name": "pinMessage",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to pin a message.\rAlternative method for pinning messages that are not in cache.\r\rAccepts same parameters as `IMessageCollection.deleteMessage`.",
		"memberof": "IMessageCollection",
		"params": [
			{
				"type": {
					"names": [
						"IMessage",
						"Object",
						"String"
					]
				},
				"name": "messageId"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"description": "Ignored if `messageId` is an object with `id`",
				"name": "channelId"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 251,
			"filename": "IMessageCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 274
	},
	{
		"id": "IMessageCollection#unpinMessage",
		"longname": "IMessageCollection#unpinMessage",
		"name": "unpinMessage",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to unpin a message.\rAlternative method for unpinning messages that are not in cache.\r\rAccepts same parameters as `IMessageCollection.deleteMessage`.",
		"memberof": "IMessageCollection",
		"params": [
			{
				"type": {
					"names": [
						"IMessage",
						"Object",
						"String"
					]
				},
				"name": "messageId"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"description": "Ignored if `messageId` is an object with `id`",
				"name": "channelId"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 273,
			"filename": "IMessageCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 275
	},
	{
		"id": "IMessageCollection#deleteMessages",
		"longname": "IMessageCollection#deleteMessages",
		"name": "deleteMessages",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to delete multiple messages.\r\rIf `messages` array contains instances of `IMessage`, parameter `channel`\ris not required as it will be determined from the first message instance.\rAlso deleted messages will be omitted from the request.\r\rIf `messages` array is empty, returned promise resolves instantly\rwithout sending a request.",
		"memberof": "IMessageCollection",
		"params": [
			{
				"type": {
					"names": [
						"Array.<(IMessage|String)>"
					]
				},
				"name": "messages"
			},
			{
				"type": {
					"names": [
						"IChannel",
						"String"
					]
				},
				"optional": true,
				"description": "Channel or channel id, required is `messages` is an array of string ids",
				"name": "channel"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 299,
			"filename": "IMessageCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 276
	},
	{
		"id": "IMessageCollection#resolveContent",
		"longname": "IMessageCollection#resolveContent",
		"name": "resolveContent",
		"scope": "instance",
		"kind": "function",
		"description": "Resolves user and channel references to proper names.\rReferences that are not found in cache will be left as is and not resolved.",
		"memberof": "IMessageCollection",
		"params": [
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "content"
			},
			{
				"type": {
					"names": [
						"IGuild",
						"String"
					]
				},
				"optional": true,
				"description": "Optional guild to resolve roles and nicknames from",
				"name": "guild"
			}
		],
		"examples": [
			"var content = message.content;\r// 'just a message for <@157838423632817262> in <#78826383786329613>'\rvar resolvedContent = message.resolveContent();\r// 'just a message for @testie in #general'\rvar resolvedContent = client.Messages.resolveContent(message.content);\r// 'just a message for @testie in #general'"
		],
		"returns": [
			{
				"type": {
					"names": [
						"String"
					]
				}
			}
		],
		"meta": {
			"lineno": 344,
			"filename": "IMessageCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 277
	},
	{
		"id": "IPermissionOverwrite#reload",
		"longname": "IPermissionOverwrite#reload",
		"name": "reload",
		"scope": "instance",
		"kind": "function",
		"description": "Loads original permissions from cache and updates this object.",
		"memberof": "IPermissionOverwrite",
		"params": [],
		"meta": {
			"lineno": 53,
			"filename": "IPermissionOverwrite.js",
			"path": "/lib/interfaces"
		},
		"order": 280
	},
	{
		"id": "IPermissionOverwrite#commit",
		"longname": "IPermissionOverwrite#commit",
		"name": "commit",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to commit changes made to this permission overwrite object.",
		"memberof": "IPermissionOverwrite",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IPermissionOverwrite, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 64,
			"filename": "IPermissionOverwrite.js",
			"path": "/lib/interfaces"
		},
		"order": 281
	},
	{
		"id": "IPermissionOverwrite#delete",
		"longname": "IPermissionOverwrite#delete",
		"name": "delete",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to delete this permission overwrite.",
		"memberof": "IPermissionOverwrite",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 84,
			"filename": "IPermissionOverwrite.js",
			"path": "/lib/interfaces"
		},
		"order": 282
	},
	{
		"id": "IRole#reload",
		"longname": "IRole#reload",
		"name": "reload",
		"scope": "instance",
		"kind": "function",
		"description": "Loads original permissions from cache and updates this object.",
		"memberof": "IRole",
		"params": [],
		"meta": {
			"lineno": 50,
			"filename": "IRole.js",
			"path": "/lib/interfaces"
		},
		"order": 288
	},
	{
		"id": "IRole#commit",
		"longname": "IRole#commit",
		"name": "commit",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to commit changes made to this role object.",
		"memberof": "IRole",
		"params": [
			{
				"type": {
					"names": [
						"String"
					]
				},
				"optional": true,
				"name": "name"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "RGB color number",
				"name": "color"
			},
			{
				"type": {
					"names": [
						"boolean"
					]
				},
				"optional": true,
				"description": "true if role should be displayed separately",
				"name": "hoist"
			},
			{
				"type": {
					"names": [
						"boolean"
					]
				},
				"optional": true,
				"name": "mentionable"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 64,
			"filename": "IRole.js",
			"path": "/lib/interfaces"
		},
		"order": 289
	},
	{
		"id": "IRole#setPosition",
		"longname": "IRole#setPosition",
		"name": "setPosition",
		"scope": "instance",
		"kind": "function",
		"description": "Moves this role to `position` and makes a batch role update request.",
		"memberof": "IRole",
		"params": [
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"name": "position"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 91,
			"filename": "IRole.js",
			"path": "/lib/interfaces"
		},
		"order": 290
	},
	{
		"id": "IRole#delete",
		"longname": "IRole#delete",
		"name": "delete",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to delete this role.",
		"memberof": "IRole",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 107,
			"filename": "IRole.js",
			"path": "/lib/interfaces"
		},
		"order": 291
	},
	{
		"id": "ITextChannel#fetchMessages",
		"longname": "ITextChannel#fetchMessages",
		"name": "fetchMessages",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to fetch messages for this channel.\r\rDiscord API does not allow fetching more than 100 messages at once.\r\rPromise resolves with an Object with following structure:\r```js\r{\r  messages: Array<IMessage>,\r  limit: Number, // same as parameter passed or default value\r  before: String | null, // message id\r  after: String | null // message id\r}\r```",
		"memberof": "ITextChannel",
		"params": [
			{
				"type": {
					"names": [
						"Number",
						"null"
					]
				},
				"optional": true,
				"description": "Default is 100",
				"name": "limit"
			},
			{
				"type": {
					"names": [
						"IMessage",
						"String",
						"null"
					]
				},
				"optional": true,
				"description": "Message or message id",
				"name": "before"
			},
			{
				"type": {
					"names": [
						"IMessage",
						"String",
						"null"
					]
				},
				"optional": true,
				"description": "Message or message id",
				"name": "after"
			}
		],
		"examples": [
			"var guild = client.Guilds.find(g => g.name == \"test\");\rvar channel = guild.generalChannel;\r\r// simple fetch:\rchannel.fetchMessages().then(() => {\r  console.log(\"[simple] messages in cache: \" + channel.messages.length);\r});\r\r// fetching more than 100 messages into cache sequentially:\rfetchMessagesEx(channel, 420).then(() => {\r  console.log(\"[extended] messages in cache: \" + channel.messages.length);\r});\r\r// fetch more messages just like Discord client does\rfunction fetchMessagesEx(channel, left) {\r  // message cache is sorted on insertion\r  // channel.messages[0] will get oldest message\r  var before = channel.messages[0];\r  return channel.fetchMessages(Math.min(left, 100), before)\r         .then(e => onFetch(e, channel, left));\r}\rfunction onFetch(e, channel, left) {\r  if (!e.messages.length) return Promise.resolve();\r  left -= e.messages.length;\r  console.log(`Received ${e.messages.length}, left: ${left}`);\r  if (left <= 0) return Promise.resolve();\r  return fetchMessagesEx(channel, left);\r}"
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 126,
			"filename": "ITextChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 299
	},
	{
		"id": "ITextChannel#fetchPinned",
		"longname": "ITextChannel#fetchPinned",
		"name": "fetchPinned",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to fetch pinned messages for this channel.\r\rPromise resolves with an Object with following structure:\r```js\r{\r  channelId: String,\r  messages: Array<IMessage>\r}\r```",
		"memberof": "ITextChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 168,
			"filename": "ITextChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 301
	},
	{
		"id": "ITextChannel#sendMessage",
		"longname": "ITextChannel#sendMessage",
		"name": "sendMessage",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to send a message to this channel. Messages over 2000\rcharacters will be rejected by the server.\r\rUse `uploadFile` if you want to send a message with an attachment.",
		"memberof": "ITextChannel",
		"params": [
			{
				"type": {
					"names": [
						"String",
						"Array.<String>"
					]
				},
				"description": "Strings will be sent as is, arrays - joined with a newline character.",
				"name": "content"
			},
			{
				"type": {
					"names": [
						"IUser",
						"IGuildMember",
						"Array.<IUser>",
						"Array.<IGuildMember>"
					]
				},
				"optional": true,
				"description": "Deprecated: left for backward compatibility.",
				"name": "mentions"
			},
			{
				"type": {
					"names": [
						"boolean"
					]
				},
				"optional": true,
				"name": "tts"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"optional": true,
				"description": "Refer to [official API documentation](https://discordapp.com/developers/docs/resources/channel#embed-object)\rfor embed structure description.",
				"name": "embed"
			}
		],
		"examples": [
			"var guild = client.Guilds.find(g => g.name == \"test\");\rif (!guild) return console.log(\"invalid guild\");\r\rvar channel = guild.generalChannel;\r\rchannel.sendMessage(\"regular message\");\rchannel.sendMessage(\"test with tts\", true);\r\rvar user = client.Users.find(u => u.username == \"test\");\rif (!user) return console.log(\"invalid user\");\r\rchannel.sendMessage(\"mentioning user \" + user.mention);\rchannel.sendMessage(\"@everyone or @here mention if you have permissions\");\r\rchannel.sendMessage(\"message with an embed\", false, {\r  color: 0x3498db,\r  author: {name: \"author name\"},\r  title: \"This is an embed\",\r  url: \"http://google.com\",\r  timestamp: \"2016-11-13T03:43:32.127Z\",\r  fields: [{name: \"some field\", value: \"some value\"}],\r  footer: {text: \"footer text\"}\r});"
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IMessage, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 219,
			"filename": "ITextChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 302
	},
	{
		"id": "ITextChannel#sendTyping",
		"longname": "ITextChannel#sendTyping",
		"name": "sendTyping",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to send typing status for this channel.\r\rDiscord client displays it for 10 seconds, sends every 5 seconds.\rStops showing typing status if receives a message from the user.",
		"memberof": "ITextChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 244,
			"filename": "ITextChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 303
	},
	{
		"id": "ITextChannel#uploadFile",
		"longname": "ITextChannel#uploadFile",
		"name": "uploadFile",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to upload data to this channel.\rImages require a `filename` with a valid extension to actually be uploaded.",
		"memberof": "ITextChannel",
		"params": [
			{
				"type": {
					"names": [
						"Buffer",
						"ReadableStream",
						"String"
					]
				},
				"description": "Data to upload or filename as a string",
				"name": "readableStream"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"description": "Actual filename to show, required for non-string `readableStream`",
				"name": "filename"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"optional": true,
				"description": "Additional comment message for attachment",
				"name": "content"
			},
			{
				"type": {
					"names": [
						"boolean"
					]
				},
				"optional": true,
				"name": "tts"
			}
		],
		"examples": [
			"channel.uploadFile(fs.readFileSync(\"test.png\"), \"test.png\"); // Buffer\rchannel.uploadFile(fs.createReadStream(\"test.png\"), \"test.png\"); // Stream\rchannel.uploadFile(\"test.png\"); // File\rchannel.uploadFile(\"test.png\", null, \"file with message\");\rchannel.uploadFile(\"test.png\", null, \"file with message and tts\", true);"
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IMessage, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 265,
			"filename": "ITextChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 304
	},
	{
		"id": "IUser#isMentioned",
		"longname": "IUser#isMentioned",
		"name": "isMentioned",
		"scope": "instance",
		"kind": "function",
		"description": "Checks whether the user is mentioned in a `message`.",
		"memberof": "IUser",
		"params": [
			{
				"type": {
					"names": [
						"IMessage"
					]
				},
				"name": "message"
			},
			{
				"type": {
					"names": [
						"boolean"
					]
				},
				"name": "ignoreImplicitMentions"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"meta": {
			"lineno": 135,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 315
	},
	{
		"id": "IUser#openDM",
		"longname": "IUser#openDM",
		"name": "openDM",
		"scope": "instance",
		"kind": "function",
		"description": "Opens or gets existing Direct Message channel.",
		"memberof": "IUser",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IDirectMessageChannel, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 153,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 316
	},
	{
		"id": "IUser#memberOf",
		"longname": "IUser#memberOf",
		"name": "memberOf",
		"scope": "instance",
		"kind": "function",
		"description": "Attempts to get a guild member interface, returns null if this user is not\ra member of the `guild` or `guild` is not in cache.",
		"memberof": "IUser",
		"params": [
			{
				"type": {
					"names": [
						"IGuild",
						"String"
					]
				},
				"name": "guild"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"IGuildMember",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 163,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 317
	},
	{
		"id": "IUser#permissionsFor",
		"longname": "IUser#permissionsFor",
		"name": "permissionsFor",
		"scope": "instance",
		"kind": "function",
		"description": "Resolves permissions for user in `context`.\r\rReturns a helper object with getter boolean properties.\r\rThrows:\r\r- ** `\"user must be an instance of IUser\"` **\r\r  If the method was called without binding to a `IUser` object\r  (as a function).\r\r- ** `\"context must be an instance of IChannel or IGuild\"` **\r\r  If context type is invalid.\r\r- ** `\"Invalid context\"` **\r\r  If context object no longer exists in cache.\r\r- ** `\"User is not a member of the context\"` **\r\r  If this user is not a member of the guild or\r  guild the channel belongs to.\r\rSee documentation of `IPermissions` for list of possible permissions.",
		"memberof": "IUser",
		"params": [
			{
				"type": {
					"names": [
						"IChannel",
						"IGuild"
					]
				},
				"name": "context"
			}
		],
		"examples": [
			"const guild = client.Guilds.find(g => g.name == \"test\");\rconst channel = guild.channels.find(c => c.name == \"restricted\");\rconst user = guild.members.find(m => m.username == \"testuser\");\r\rconst guildPerms = user.permissionsFor(guild); // resolves to role permissions\rconst channelPerms = user.permissionsFor(channel); // resolves to channel permissions\r\rconsole.log(guildPerms.General.MANAGE_ROLES); // false\rconsole.log(guildPerms.Text.READ_MESSAGES); // true\r// The `restricted` channel has `READ_MESSAGES` denied\rconsole.log(channelPerms.Text.READ_MESSAGES); // false"
		],
		"returns": [
			{
				"type": {
					"names": [
						"IPermissions"
					]
				}
			}
		],
		"meta": {
			"lineno": 209,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 318
	},
	{
		"id": "IUser#can",
		"longname": "IUser#can",
		"name": "can",
		"scope": "instance",
		"kind": "function",
		"description": "Resolves permissions for user in `context` and checks if\ruser has `permission`.\r\rSee `IUser.permissionsFor` method for list of throwable errors.\r\rSee documentation of `IPermissions` for full list of possible permissions.",
		"memberof": "IUser",
		"params": [
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"description": "One or multiple permission bits",
				"name": "permission"
			},
			{
				"type": {
					"names": [
						"IChannel",
						"IGuild"
					]
				},
				"name": "context"
			}
		],
		"examples": [
			"const guild = client.Guilds.find(g => g.name == \"test\");\rconst channel = guild.channels.find(c => c.name == \"node_discordie\");\rconst user = guild.members.find(m => m.username == \"testuser\");\ruser.can(Discordie.Permissions.General.KICK_MEMBERS, guild); // resolves to role permissions\ruser.can(Discordie.Permissions.Text.READ_MESSAGES, channel); // resolves to channel permissions"
		],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"meta": {
			"lineno": 230,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 319
	},
	{
		"id": "IUser#getVoiceChannel",
		"longname": "IUser#getVoiceChannel",
		"name": "getVoiceChannel",
		"scope": "instance",
		"kind": "function",
		"description": "Gets the first voice channel that member of `guild` currently in.",
		"memberof": "IUser",
		"params": [
			{
				"type": {
					"names": [
						"IGuild",
						"String",
						"null"
					]
				},
				"description": "Guild or an id string, null for private call\r(call channel is only available if recipient is in call with current user)",
				"name": "guild"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"IVoiceChannel",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 241,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 320
	},
	{
		"id": "IUserCollection#fetchMembers",
		"longname": "IUserCollection#fetchMembers",
		"name": "fetchMembers",
		"scope": "instance",
		"kind": "function",
		"description": "Request members and wait until cache populates for all guilds or\ran array of guilds.\rRequest is made over gateway websocket.\r\rWill request members for all guilds if no arguments passed.\r\rBy default Discord sends only online members if there are more than 250\r(offline and online total) joined in a guild.\r\rReturned promise will resolve when all members have been fetched.\rReturned promise will reject if all or some members have not been received\rwithin 60 seconds or primary gateway websocket disconnected.\r\rIf all members for chosen guilds are already in cache - returns a\rresolved promise.\r\r> **Note:** When guilds become unavailable or deleted\r>           (events `GUILD_UNAVAILABLE` and `GUILD_DELETE`)\r>           all members will also be deleted from cache.",
		"memberof": "IUserCollection",
		"params": [
			{
				"type": {
					"names": [
						"IGuild",
						"String",
						"Array.<(IGuild|String)>"
					]
				},
				"optional": true,
				"name": "guilds"
			}
		],
		"examples": [
			"client.Users.fetchMembers()\r  .then(() => console.log(\"Received members for all guilds\"));\r\rclient.Users.fetchMembers([guild1, guild2, guild3])\r  .then(() => console.log(\"Received members for 3 guilds\"));\r\rvar p1 = client.Users.fetchMembers(guild1);\rp1.catch(err => console.log(\"Failed to receive guild1 members: \" + err));\rvar p2 = client.Users.fetchMembers(guild2);\rvar p3 = client.Users.fetchMembers(guild3);\rPromise.all([p1, p2, p3])\r  .then(() => console.log(\"Received members for 3 guilds\"));\r  .catch(err => console.log(\"Failed to receive some members: \" + err));"
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 65,
			"filename": "IUserCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 325
	},
	{
		"id": "IUserCollection#getMember",
		"longname": "IUserCollection#getMember",
		"name": "getMember",
		"scope": "instance",
		"kind": "function",
		"description": "Gets a `IGuildMember` for specified `user` of `guild`.\r\rReturns null if the user is not a member of the guild.",
		"memberof": "IUserCollection",
		"params": [
			{
				"type": {
					"names": [
						"IGuild",
						"String"
					]
				},
				"description": "Guild or an id string",
				"name": "guild"
			},
			{
				"type": {
					"names": [
						"IUser",
						"String"
					]
				},
				"description": "User or an id string",
				"name": "user"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"IGuildMember",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 81,
			"filename": "IUserCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 326
	},
	{
		"id": "IUserCollection#membersForGuild",
		"longname": "IUserCollection#membersForGuild",
		"name": "membersForGuild",
		"scope": "instance",
		"kind": "function",
		"description": "Creates an array of `IGuildMember` for `guild`.",
		"memberof": "IUserCollection",
		"params": [
			{
				"type": {
					"names": [
						"IGuild",
						"String"
					]
				},
				"description": "Guild or an id string",
				"name": "guild"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IGuildMember>"
					]
				}
			}
		],
		"meta": {
			"lineno": 95,
			"filename": "IUserCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 327
	},
	{
		"id": "IUserCollection#membersForChannel",
		"longname": "IUserCollection#membersForChannel",
		"name": "membersForChannel",
		"scope": "instance",
		"kind": "function",
		"description": "Creates an array of `IGuildMember` that have permissions to read `channel`.\r\r> **Note:** This method computes permissions for all members and may be CPU\r>           intensive for large guilds.",
		"memberof": "IUserCollection",
		"params": [
			{
				"type": {
					"names": [
						"ITextChannel",
						"String"
					]
				},
				"description": "Channel or an id string",
				"name": "channel"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IGuildMember>"
					]
				}
			}
		],
		"meta": {
			"lineno": 116,
			"filename": "IUserCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 328
	},
	{
		"id": "IUserCollection#membersInVoiceChannel",
		"longname": "IUserCollection#membersInVoiceChannel",
		"name": "membersInVoiceChannel",
		"scope": "instance",
		"kind": "function",
		"description": "Creates an array of `IGuildMember` containing\ractive members in a voice `channel`.",
		"memberof": "IUserCollection",
		"params": [
			{
				"type": {
					"names": [
						"IVoiceChannel",
						"String"
					]
				},
				"description": "Channel or an id string",
				"name": "channel"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IGuildMember>"
					]
				}
			}
		],
		"meta": {
			"lineno": 137,
			"filename": "IUserCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 329
	},
	{
		"id": "IUserCollection#usersInCall",
		"longname": "IUserCollection#usersInCall",
		"name": "usersInCall",
		"scope": "instance",
		"kind": "function",
		"description": "Creates an array of `IUser` containing users in a private voice channel.",
		"memberof": "IUserCollection",
		"params": [
			{
				"type": {
					"names": [
						"IDirectMessageChannel",
						"String"
					]
				},
				"description": "Channel or an id string",
				"name": "channel"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IUser>"
					]
				}
			}
		],
		"meta": {
			"lineno": 162,
			"filename": "IUserCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 330
	},
	{
		"id": "IUserCollection#onlineMembersForGuild",
		"longname": "IUserCollection#onlineMembersForGuild",
		"name": "onlineMembersForGuild",
		"scope": "instance",
		"kind": "function",
		"description": "Creates an array of `IGuildMember` for `guild` that are currently online.",
		"memberof": "IUserCollection",
		"params": [
			{
				"type": {
					"names": [
						"IGuild",
						"String"
					]
				},
				"description": "Guild or an id string",
				"name": "guild"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IGuildMember>"
					]
				}
			}
		],
		"meta": {
			"lineno": 181,
			"filename": "IUserCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 331
	},
	{
		"id": "IUserCollection#onlineMembersForChannel",
		"longname": "IUserCollection#onlineMembersForChannel",
		"name": "onlineMembersForChannel",
		"scope": "instance",
		"kind": "function",
		"description": "Creates an array of `IGuildMember` that\rhave permissions to read `channel` and currently online.\r\r> **Note:** This method computes permissions for all members and may be CPU\r>           intensive for large guilds.",
		"memberof": "IUserCollection",
		"params": [
			{
				"type": {
					"names": [
						"ITextChannel",
						"String"
					]
				},
				"description": "Channel or an id string",
				"name": "channel"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IGuildMember>"
					]
				}
			}
		],
		"meta": {
			"lineno": 206,
			"filename": "IUserCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 332
	},
	{
		"id": "IUserCollection#offlineMembersForGuild",
		"longname": "IUserCollection#offlineMembersForGuild",
		"name": "offlineMembersForGuild",
		"scope": "instance",
		"kind": "function",
		"description": "Creates an array of `IGuildMember` for `guild` that are currently offline.\r\rDoes not guarantee every offline member unless\r`IUserCollection.fetchMembers` has been called for the `guild`.",
		"memberof": "IUserCollection",
		"params": [
			{
				"type": {
					"names": [
						"IGuild",
						"String"
					]
				},
				"description": "Guild or an id string",
				"name": "guild"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IGuildMember>"
					]
				}
			}
		],
		"meta": {
			"lineno": 220,
			"filename": "IUserCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 333
	},
	{
		"id": "IUserCollection#offlineMembersForChannel",
		"longname": "IUserCollection#offlineMembersForChannel",
		"name": "offlineMembersForChannel",
		"scope": "instance",
		"kind": "function",
		"description": "Creates an array of `IGuildMember` that\rhave permissions to read `channel` and currently offline.\r\rDoes not guarantee every offline member unless\r`IUserCollection.fetchMembers` has been called for the guild the `channel`\rbelongs to.\r\r> **Note:** This method computes permissions for all members and may be CPU\r>           intensive for large guilds.",
		"memberof": "IUserCollection",
		"params": [
			{
				"type": {
					"names": [
						"ITextChannel",
						"String"
					]
				},
				"description": "Channel or an id string",
				"name": "channel"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array.<IGuildMember>"
					]
				}
			}
		],
		"meta": {
			"lineno": 249,
			"filename": "IUserCollection.js",
			"path": "/lib/interfaces"
		},
		"order": 334
	},
	{
		"id": "IVoiceChannel#join",
		"longname": "IVoiceChannel#join",
		"name": "join",
		"scope": "instance",
		"kind": "function",
		"description": "Joins this voice channel.\rCreates a new voice connection if there are no active connections for\rthis channels' guild.\r\r> **Note:** One account can be only in one channel per guild.\r>           Promise will resolve instantly and contain the same instance\r>           if connection to the server is already established.\r\rIf there is a pending connection for the guild this channel belongs to,\rit will return the same promise.\r\rChecks permissions locally and returns a rejected promise with:\r\r- **`Error \"Missing permission\"`** if `Voice.CONNECT` permission is denied.\r\r- **`Error \"Channel is full\"`** if `Voice.MOVE_MEMBERS` permission is\r  denied and channel is full.\r\rReturns a rejected promise with **`Error \"Channel does not exist\"`** if\rguild is unavailable or channel does not exist in cache.\r\rReturned promise can be cancelled or rejected: see `VOICE_DISCONNECTED`\revent for more info.",
		"memberof": "IVoiceChannel",
		"params": [
			{
				"type": {
					"names": [
						"boolean"
					]
				},
				"optional": true,
				"name": "selfMute"
			},
			{
				"type": {
					"names": [
						"boolean"
					]
				},
				"optional": true,
				"name": "selfDeaf"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<VoiceConnectionInfo, (Error|Number)>"
					]
				}
			}
		],
		"meta": {
			"lineno": 66,
			"filename": "IVoiceChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 338
	},
	{
		"id": "IVoiceChannel#leave",
		"longname": "IVoiceChannel#leave",
		"name": "leave",
		"scope": "instance",
		"kind": "function",
		"description": "Leaves this voice channel if joined.",
		"memberof": "IVoiceChannel",
		"params": [],
		"meta": {
			"lineno": 96,
			"filename": "IVoiceChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 339
	},
	{
		"id": "IVoiceChannel#getVoiceConnectionInfo",
		"longname": "IVoiceChannel#getVoiceConnectionInfo",
		"name": "getVoiceConnectionInfo",
		"scope": "instance",
		"kind": "function",
		"description": "Retrieves `VoiceConnectionInfo` for this voice channel.",
		"memberof": "IVoiceChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"VoiceConnectionInfo",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 108,
			"filename": "IVoiceChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 340
	},
	{
		"id": "IVoiceConnection#ssrcToUser",
		"longname": "IVoiceConnection#ssrcToUser",
		"name": "ssrcToUser",
		"scope": "instance",
		"kind": "function",
		"description": "Resolves a user object from source id assigned to this voice connection.",
		"memberof": "IVoiceConnection",
		"params": [
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"name": "ssrc"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"IUser"
					]
				}
			}
		],
		"meta": {
			"lineno": 121,
			"filename": "IVoiceConnection.js",
			"path": "/lib/interfaces"
		},
		"order": 348
	},
	{
		"id": "IVoiceConnection#ssrcToMember",
		"longname": "IVoiceConnection#ssrcToMember",
		"name": "ssrcToMember",
		"scope": "instance",
		"kind": "function",
		"description": "Resolves a member object from source id assigned to this voice connection.",
		"memberof": "IVoiceConnection",
		"params": [
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"name": "ssrc"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"IGuildMember"
					]
				}
			}
		],
		"meta": {
			"lineno": 133,
			"filename": "IVoiceConnection.js",
			"path": "/lib/interfaces"
		},
		"order": 349
	},
	{
		"id": "IVoiceConnection#getEncoderStream",
		"longname": "IVoiceConnection#getEncoderStream",
		"name": "getEncoderStream",
		"scope": "instance",
		"kind": "function",
		"description": "Initializes encoder and gets stream for this voice connection.\r\rCalls without arguments return existing encoder without reinitialization.\r\rSee `AudioEncoder.initialize()` method for list of options.",
		"memberof": "IVoiceConnection",
		"params": [
			{
				"optional": true,
				"name": "options"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"AudioEncoderStream"
					]
				}
			}
		],
		"meta": {
			"lineno": 149,
			"filename": "IVoiceConnection.js",
			"path": "/lib/interfaces"
		},
		"order": 350
	},
	{
		"id": "IVoiceConnection#createExternalEncoder",
		"longname": "IVoiceConnection#createExternalEncoder",
		"name": "createExternalEncoder",
		"scope": "instance",
		"kind": "function",
		"description": "Creates an external encoder.\r\rAccepts options object with `type` property (default `{type: \"ffmpeg\"}`).\rEach type supports additional options.\rSee docs for returned classes for usage info.",
		"memberof": "IVoiceConnection",
		"params": [
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"optional": true,
				"name": "options"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"FFmpegEncoder",
						"OggOpusPlayer",
						"WebmOpusPlayer"
					]
				}
			}
		],
		"meta": {
			"lineno": 169,
			"filename": "IVoiceConnection.js",
			"path": "/lib/interfaces"
		},
		"order": 351
	},
	{
		"id": "IVoiceConnection#getEncoder",
		"longname": "IVoiceConnection#getEncoder",
		"name": "getEncoder",
		"scope": "instance",
		"kind": "function",
		"description": "Initializes encoder instance for this voice connection.\r\rCalls without arguments return existing encoder without reinitialization.\r\rSee `AudioEncoder.initialize()` method for list of options.",
		"memberof": "IVoiceConnection",
		"params": [
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"optional": true,
				"name": "options"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"AudioEncoder"
					]
				}
			}
		],
		"meta": {
			"lineno": 183,
			"filename": "IVoiceConnection.js",
			"path": "/lib/interfaces"
		},
		"order": 352
	},
	{
		"id": "IVoiceConnection#getDecoder",
		"longname": "IVoiceConnection#getDecoder",
		"name": "getDecoder",
		"scope": "instance",
		"kind": "function",
		"description": "Initializes decoder instance for this voice connection.\r\rCalls without arguments return existing decoder without reinitialization.",
		"memberof": "IVoiceConnection",
		"params": [
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"optional": true,
				"name": "options"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"AudioDecoder"
					]
				}
			}
		],
		"meta": {
			"lineno": 195,
			"filename": "IVoiceConnection.js",
			"path": "/lib/interfaces"
		},
		"order": 353
	},
	{
		"id": "IVoiceConnection#disconnect",
		"longname": "IVoiceConnection#disconnect",
		"name": "disconnect",
		"scope": "instance",
		"kind": "function",
		"description": "Disconnects this voice connection.",
		"memberof": "IVoiceConnection",
		"params": [],
		"meta": {
			"lineno": 203,
			"filename": "IVoiceConnection.js",
			"path": "/lib/interfaces"
		},
		"order": 354
	},
	{
		"id": "IWebhookManager#fetchForGuild",
		"longname": "IWebhookManager#fetchForGuild",
		"name": "fetchForGuild",
		"scope": "instance",
		"kind": "function",
		"description": "**Requires logging in with an API token.**\r\rMakes a request to get webhook objects for the specified guild.",
		"memberof": "IWebhookManager",
		"params": [
			{
				"type": {
					"names": [
						"IGuild",
						"String"
					]
				},
				"name": "guild"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Array.<Object>, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 50,
			"filename": "IWebhookManager.js",
			"path": "/lib/interfaces"
		},
		"order": 356
	},
	{
		"id": "IWebhookManager#fetchForChannel",
		"longname": "IWebhookManager#fetchForChannel",
		"name": "fetchForChannel",
		"scope": "instance",
		"kind": "function",
		"description": "**Requires logging in with an API token.**\r\rMakes a request to get webhook objects for the specified channel.",
		"memberof": "IWebhookManager",
		"params": [
			{
				"type": {
					"names": [
						"IChannel",
						"String"
					]
				},
				"name": "channel"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Array.<Object>, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 62,
			"filename": "IWebhookManager.js",
			"path": "/lib/interfaces"
		},
		"order": 357
	},
	{
		"id": "IWebhookManager#create",
		"longname": "IWebhookManager#create",
		"name": "create",
		"scope": "instance",
		"kind": "function",
		"description": "**Requires logging in with an API token.**\r\rMakes a request to create a webhook for the channel.\r\rPromise resolves with a webhook object.",
		"memberof": "IWebhookManager",
		"params": [
			{
				"type": {
					"names": [
						"IChannel"
					]
				},
				"name": "channel"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"description": "Object with properties `{name: String, avatar: Buffer|String|null}`.\r\rString avatars must be base64 data-url encoded.",
				"name": "options"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 80,
			"filename": "IWebhookManager.js",
			"path": "/lib/interfaces"
		},
		"order": 358
	},
	{
		"id": "IWebhookManager#fetch",
		"longname": "IWebhookManager#fetch",
		"name": "fetch",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to fetch a webhook object.\r\rPromise resolves with a webhook object (does not contain a `user` object\rif fetched with `token` param).",
		"memberof": "IWebhookManager",
		"params": [
			{
				"type": {
					"names": [
						"Object",
						"String"
					]
				},
				"description": "Webhook object or id.",
				"name": "webhook"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"description": "Webhook token, not required if currently logged in\rwith an account that has access to the webhook.",
				"name": "token"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 102,
			"filename": "IWebhookManager.js",
			"path": "/lib/interfaces"
		},
		"order": 359
	},
	{
		"id": "IWebhookManager#edit",
		"longname": "IWebhookManager#edit",
		"name": "edit",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to edit the specified webhook.\r\rPromise resolves with a webhook object (does not contain a `user` object\rif edited with `token` param).",
		"memberof": "IWebhookManager",
		"params": [
			{
				"type": {
					"names": [
						"Object",
						"String"
					]
				},
				"description": "Webhook object or id.",
				"name": "webhook"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"description": "Webhook token, not required and can be set to null if currently logged in\rwith an account that has access to the webhook.",
				"name": "token"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"description": "Object with properties `{name: String, avatar: Buffer|String|null}`.\r\rString avatars must be base64 data-url encoded.",
				"name": "options"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 122,
			"filename": "IWebhookManager.js",
			"path": "/lib/interfaces"
		},
		"order": 360
	},
	{
		"id": "IWebhookManager#delete",
		"longname": "IWebhookManager#delete",
		"name": "delete",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to delete the specified webhook.",
		"memberof": "IWebhookManager",
		"params": [
			{
				"type": {
					"names": [
						"Object",
						"String"
					]
				},
				"description": "Webhook object or id.",
				"name": "webhook"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"description": "Webhook token, not required and can be set to null if currently logged in\rwith an account that has access to the webhook.",
				"name": "token"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 142,
			"filename": "IWebhookManager.js",
			"path": "/lib/interfaces"
		},
		"order": 361
	},
	{
		"id": "IWebhookManager#execute",
		"longname": "IWebhookManager#execute",
		"name": "execute",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to execute the specified webhook.\r\r> **Note:** Embeds in file uploads are not supported.",
		"memberof": "IWebhookManager",
		"params": [
			{
				"type": {
					"names": [
						"Object",
						"String"
					]
				},
				"description": "Webhook object or id.",
				"name": "webhook"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"description": "Required unless webhook object contains token.",
				"name": "token"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"description": "Refer to [official API documentation](https://discordapp.com/developers/docs/)\rfor more information.",
				"name": "options"
			},
			{
				"type": {
					"names": [
						"boolean"
					]
				},
				"optional": true,
				"description": "Wait for server confirmation of message delivery,\rreturned promise will contain a raw message object or an error if message\rcreation failed.",
				"name": "wait"
			}
		],
		"examples": [
			"const webhookId = \"232330225768333313\";\rconst token = \"EtuNYHGkElBlE7BE266Jk...NzHvccXaUCQUOY64NbFWz9zbQ\";\rclient.Webhooks.execute(webhookId, token, {content: \"text message\"});\rclient.Webhooks.execute(webhookId, token, {\r  // text message\r  content: \"text message\",\r  username: \"Different Username\",\r  avatar_url: \"https://localhost/test.png\",\r  tts: false,\r  embeds: [{\r    color: 0x3498db,\r    author: {name: \"who dis\"},\r    title: \"This is an embed\",\r    description: \"Nobody will read this anyway\",\r    url: \"http://google.com\",\r    timestamp: \"2016-10-03T03:32:31.205Z\",\r    fields: [{name: \"some field\", value: \"some value\"}],\r    footer: {text: \"footer text\"}\r  }]\r});\r\rclient.Webhooks.execute(webhookId, token, {\r  // file upload\r  content: \"text message\",\r  username: \"Different Username\",\r  file: fs.readFileSync(\"test.png\"),\r  filename: \"test.png\"\r});"
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 192,
			"filename": "IWebhookManager.js",
			"path": "/lib/interfaces"
		},
		"order": 362
	},
	{
		"id": "IWebhookManager#executeSlack",
		"longname": "IWebhookManager#executeSlack",
		"name": "executeSlack",
		"scope": "instance",
		"kind": "function",
		"description": "Makes a request to execute the specified webhook with slack-compatible\roptions.",
		"memberof": "IWebhookManager",
		"params": [
			{
				"type": {
					"names": [
						"Object",
						"String"
					]
				},
				"description": "Webhook object or id.",
				"name": "webhook"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"description": "Required unless webhook object contains token.",
				"name": "token"
			},
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"description": "Refer to [Slack's documentation](https://api.slack.com/incoming-webhooks)\rfor more information.\r\rDiscord does not support Slack's `channel`, `icon_emoji`, `mrkdwn`,\ror `mrkdwn_in` properties.",
				"name": "options"
			},
			{
				"type": {
					"names": [
						"boolean"
					]
				},
				"optional": true,
				"description": "Wait for server confirmation of message delivery, defaults to true.\rWhen set to false, a message that is not saved does not return an error.",
				"name": "wait"
			}
		],
		"examples": [
			"const webhookId = \"232330225768333313\";\rconst token = \"EtuNYHGkElBlE7BE266Jk...NzHvccXaUCQUOY64NbFWz9zbQ\";\rclient.Webhooks.executeSlack(webhookId, token, {\r  text: \"text message\",\r  username: \"Different Username\"\r});"
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 222,
			"filename": "IWebhookManager.js",
			"path": "/lib/interfaces"
		},
		"order": 363
	},
	{
		"id": "AudioEncoder#initialize",
		"longname": "AudioEncoder#initialize",
		"name": "initialize",
		"scope": "instance",
		"kind": "function",
		"description": "Initializes worker object.",
		"memberof": "AudioEncoder",
		"params": [
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"name": "options"
			}
		],
		"examples": [
			"var options = {};\r\r// frame size in milliseconds, forced range from 20 to 60\r// (frame sizes below 20ms are unsupported)\roptions.frameDuration = 60; // < default\r// input sample rate,\r// anything other than 48000 will be resampled by the library\r// to match Discord output sample rate\roptions.sampleRate = 48000; // < default\roptions.sampleRate = 44100; // will be resampled to 48000\r// number of channels, only mono (1) or stereo (2)\roptions.channels = 1; // < default\r// read as 32-bit floating point audio\roptions.float = false;\r\r// downmix to mono audio\roptions.downmix = \"average\";\r// encode multichannel audio\roptions.downmix = false; // < default\r\r// use emscripten-compiled opus codec\roptions.engine = \"internal\"; // < default\r// try to use native `node-opus` module,\r// must be installed in discordie/node_modules\roptions.engine = \"native\";\r\r// proxy mode, passes packets straight to the muxer\r// packets should be opus encoded already\r// in this mode it only works as scheduler for packets\roptions.proxy = false; // < default\roptions.proxy = true;\r\r// OPUS_AUTO          -1000\r// OPUS_BITRATE_MAX   -1\roptions.bitrate = -1000; // < default\r// encode 64kbps audio\roptions.bitrate = 64000;\r// encode 128kbps audio - max bitrate for Discord servers, do not exceed\roptions.bitrate = 128000;\r\rencoder.initialize(options);"
		],
		"meta": {
			"lineno": 144,
			"filename": "AudioEncoder.js",
			"path": "/lib/voice"
		},
		"order": 467
	},
	{
		"id": "AudioEncoder#setVolume",
		"longname": "AudioEncoder#setVolume",
		"name": "setVolume",
		"scope": "instance",
		"kind": "function",
		"description": "Sets volume.\rDoes not apply in proxy mode.",
		"memberof": "AudioEncoder",
		"params": [
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"description": "Number range from 0 to 100",
				"name": "volume"
			}
		],
		"meta": {
			"lineno": 209,
			"filename": "AudioEncoder.js",
			"path": "/lib/voice"
		},
		"order": 468
	},
	{
		"id": "AudioEncoder#setBitrate",
		"longname": "AudioEncoder#setBitrate",
		"name": "setBitrate",
		"scope": "instance",
		"kind": "function",
		"description": "Sets bitrate.\rDoes not apply in proxy mode.",
		"memberof": "AudioEncoder",
		"params": [
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"description": "Number range from 8000 to 512000",
				"name": "bitrate"
			}
		],
		"meta": {
			"lineno": 223,
			"filename": "AudioEncoder.js",
			"path": "/lib/voice"
		},
		"order": 469
	},
	{
		"id": "AudioEncoder#enqueue",
		"longname": "AudioEncoder#enqueue",
		"name": "enqueue",
		"scope": "instance",
		"kind": "function",
		"description": "Enqueues audio (PCM or Opus packet (proxy mode), depending on options)\rto the queue buffer.",
		"memberof": "AudioEncoder",
		"params": [
			{
				"type": {
					"names": [
						"Buffer"
					]
				},
				"name": "chunk"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"description": "Number of samples per channel",
				"name": "sampleCount"
			}
		],
		"meta": {
			"lineno": 237,
			"filename": "AudioEncoder.js",
			"path": "/lib/voice"
		},
		"order": 470
	},
	{
		"id": "AudioEncoder#enqueueMultiple",
		"longname": "AudioEncoder#enqueueMultiple",
		"name": "enqueueMultiple",
		"scope": "instance",
		"kind": "function",
		"description": "Enqueues an array of audio chunks (PCM or Opus packet (proxy mode),\rdepending on options) to the queue buffer.\r\rAll chunks should have the same `sampleCount`.",
		"memberof": "AudioEncoder",
		"params": [
			{
				"type": {
					"names": [
						"Array.<Buffer>"
					]
				},
				"name": "chunks"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"description": "Number of samples per channel",
				"name": "sampleCount"
			}
		],
		"meta": {
			"lineno": 256,
			"filename": "AudioEncoder.js",
			"path": "/lib/voice"
		},
		"order": 471
	},
	{
		"id": "AudioEncoder#clearQueue",
		"longname": "AudioEncoder#clearQueue",
		"name": "clearQueue",
		"scope": "instance",
		"kind": "function",
		"description": "Clears audio queue.",
		"memberof": "AudioEncoder",
		"params": [],
		"meta": {
			"lineno": 267,
			"filename": "AudioEncoder.js",
			"path": "/lib/voice"
		},
		"order": 472
	},
	{
		"id": "AudioEncoder#kill",
		"longname": "AudioEncoder#kill",
		"name": "kill",
		"scope": "instance",
		"kind": "function",
		"description": "Shuts down the worker.",
		"memberof": "AudioEncoder",
		"params": [],
		"meta": {
			"lineno": 275,
			"filename": "AudioEncoder.js",
			"path": "/lib/voice"
		},
		"order": 473
	},
	{
		"id": "ExternalEncoderBase#play",
		"longname": "ExternalEncoderBase#play",
		"name": "play",
		"scope": "instance",
		"kind": "function",
		"description": "Connects pipe into AudioEncoderStream of the bound voice connection.\r\rThis function handles automatic unpiping and kills process.\rThe stream will become disposed and no longer playable after\rcalling `unpipe()` or `stop()`.\r\rUse `pipe()` method if you want to control the process manually\rand `destroy()` it later.",
		"memberof": "ExternalEncoderBase",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"AudioEncoderStream"
					]
				}
			}
		],
		"meta": {
			"lineno": 63,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 475
	},
	{
		"id": "ExternalEncoderBase#stop",
		"longname": "ExternalEncoderBase#stop",
		"name": "stop",
		"scope": "instance",
		"kind": "function",
		"description": "Unpipes internal stream from the bound voice connection.",
		"memberof": "ExternalEncoderBase",
		"params": [],
		"meta": {
			"lineno": 91,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 476
	},
	{
		"id": "ExternalEncoderBase#pipe",
		"longname": "ExternalEncoderBase#pipe",
		"name": "pipe",
		"scope": "instance",
		"kind": "function",
		"description": "Pipes stream into destination.\r\r> **Note:** In case of manual piping you have to invoke\r> `IVoiceConnection.getEncoderStream` with the correct settings yourself.\r> For proxy (externally encoding) streams only `{proxy: true}` is required.",
		"memberof": "ExternalEncoderBase",
		"params": [
			{
				"type": {
					"names": [
						"WritableStream"
					]
				},
				"name": "dest"
			}
		],
		"meta": {
			"lineno": 103,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 477
	},
	{
		"id": "ExternalEncoderBase#unpipe",
		"longname": "ExternalEncoderBase#unpipe",
		"name": "unpipe",
		"scope": "instance",
		"kind": "function",
		"description": "Unpipes stream from destination.",
		"memberof": "ExternalEncoderBase",
		"params": [
			{
				"type": {
					"names": [
						"WritableStream"
					]
				},
				"optional": true,
				"name": "dest"
			}
		],
		"meta": {
			"lineno": 109,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 478
	},
	{
		"id": "ExternalEncoderBase#destroy",
		"longname": "ExternalEncoderBase#destroy",
		"name": "destroy",
		"scope": "instance",
		"kind": "function",
		"description": "Destroys all handles, releases resources and disposes this instance.",
		"memberof": "ExternalEncoderBase",
		"params": [],
		"meta": {
			"lineno": 114,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 479
	},
	{
		"id": "AudioEncoderStream#resetTimestamp",
		"longname": "AudioEncoderStream#resetTimestamp",
		"name": "resetTimestamp",
		"scope": "instance",
		"kind": "function",
		"description": "Resets current timestamp.",
		"memberof": "AudioEncoderStream",
		"params": [],
		"meta": {
			"lineno": 192,
			"filename": "AudioEncoderStream.js",
			"path": "/lib/voice/streams"
		},
		"order": 486
	},
	{
		"id": "AudioEncoderStream#unpipeAll",
		"longname": "AudioEncoderStream#unpipeAll",
		"name": "unpipeAll",
		"scope": "instance",
		"kind": "function",
		"description": "Unpipes the connected stream if piped.",
		"memberof": "AudioEncoderStream",
		"params": [],
		"meta": {
			"lineno": 199,
			"filename": "AudioEncoderStream.js",
			"path": "/lib/voice/streams"
		},
		"order": 487
	},
	{
		"id": "IGuildCollection#getBy",
		"longname": "IGuildCollection#getBy",
		"name": "getBy",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#getBy",
		"inherited": true,
		"description": "Returns an an element, if `key` of an element in the collection\rwith exact `value` can be found.\rOtherwise null is returned.",
		"memberof": "IGuildCollection",
		"params": [
			{
				"name": "key"
			},
			{
				"name": "value"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"*"
					]
				}
			}
		],
		"meta": {
			"lineno": 34,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 488
	},
	{
		"id": "IGuildCollection#get",
		"longname": "IGuildCollection#get",
		"name": "get",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#get",
		"inherited": true,
		"description": "Returns an element with requested `id`, if exists in the collection.\rOtherwise null is returned.",
		"memberof": "IGuildCollection",
		"params": [
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "id"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"*"
					]
				}
			}
		],
		"meta": {
			"lineno": 55,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 489
	},
	{
		"id": "IGuildCollection#filter",
		"longname": "IGuildCollection#filter",
		"name": "filter",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#filter",
		"inherited": true,
		"description": "Creates a new array with all elements that pass the test implemented\rby the provided function.",
		"memberof": "IGuildCollection",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array"
					]
				}
			}
		],
		"meta": {
			"lineno": 82,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 490
	},
	{
		"id": "IGuildCollection#find",
		"longname": "IGuildCollection#find",
		"name": "find",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#find",
		"inherited": true,
		"description": "Returns a value in the collection, if an element in the collection\rsatisfies the provided testing function. Otherwise null is returned.",
		"memberof": "IGuildCollection",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Object",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 110,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 491
	},
	{
		"id": "IGuildCollection#forEach",
		"longname": "IGuildCollection#forEach",
		"name": "forEach",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#forEach",
		"inherited": true,
		"description": "Executes a provided function once per element.",
		"memberof": "IGuildCollection",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"meta": {
			"lineno": 125,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 492
	},
	{
		"id": "IGuildCollection#map",
		"longname": "IGuildCollection#map",
		"name": "map",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#map",
		"inherited": true,
		"description": "Creates a new array with the results of calling a provided function on\revery element in this collection.",
		"memberof": "IGuildCollection",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array"
					]
				}
			}
		],
		"meta": {
			"lineno": 140,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 493
	},
	{
		"id": "IGuildCollection#toArray",
		"longname": "IGuildCollection#toArray",
		"name": "toArray",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#toArray",
		"inherited": true,
		"description": "Creates a new array with elements of this collection.",
		"memberof": "IGuildCollection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Array"
					]
				}
			}
		],
		"meta": {
			"lineno": 164,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 494
	},
	{
		"id": "IChannelCollection#getBy",
		"longname": "IChannelCollection#getBy",
		"name": "getBy",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#getBy",
		"inherited": true,
		"description": "Returns an an element, if `key` of an element in the collection\rwith exact `value` can be found.\rOtherwise null is returned.",
		"memberof": "IChannelCollection",
		"params": [
			{
				"name": "key"
			},
			{
				"name": "value"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"*"
					]
				}
			}
		],
		"meta": {
			"lineno": 34,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 497
	},
	{
		"id": "IChannelCollection#get",
		"longname": "IChannelCollection#get",
		"name": "get",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#get",
		"inherited": true,
		"description": "Returns an element with requested `id`, if exists in the collection.\rOtherwise null is returned.",
		"memberof": "IChannelCollection",
		"params": [
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "id"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"*"
					]
				}
			}
		],
		"meta": {
			"lineno": 55,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 498
	},
	{
		"id": "IChannelCollection#filter",
		"longname": "IChannelCollection#filter",
		"name": "filter",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#filter",
		"inherited": true,
		"description": "Creates a new array with all elements that pass the test implemented\rby the provided function.",
		"memberof": "IChannelCollection",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array"
					]
				}
			}
		],
		"meta": {
			"lineno": 82,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 499
	},
	{
		"id": "IChannelCollection#find",
		"longname": "IChannelCollection#find",
		"name": "find",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#find",
		"inherited": true,
		"description": "Returns a value in the collection, if an element in the collection\rsatisfies the provided testing function. Otherwise null is returned.",
		"memberof": "IChannelCollection",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Object",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 110,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 500
	},
	{
		"id": "IChannelCollection#forEach",
		"longname": "IChannelCollection#forEach",
		"name": "forEach",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#forEach",
		"inherited": true,
		"description": "Executes a provided function once per element.",
		"memberof": "IChannelCollection",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"meta": {
			"lineno": 125,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 501
	},
	{
		"id": "IChannelCollection#map",
		"longname": "IChannelCollection#map",
		"name": "map",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#map",
		"inherited": true,
		"description": "Creates a new array with the results of calling a provided function on\revery element in this collection.",
		"memberof": "IChannelCollection",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array"
					]
				}
			}
		],
		"meta": {
			"lineno": 140,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 502
	},
	{
		"id": "IChannelCollection#toArray",
		"longname": "IChannelCollection#toArray",
		"name": "toArray",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#toArray",
		"inherited": true,
		"description": "Creates a new array with elements of this collection.",
		"memberof": "IChannelCollection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Array"
					]
				}
			}
		],
		"meta": {
			"lineno": 164,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 503
	},
	{
		"id": "IUserCollection#getBy",
		"longname": "IUserCollection#getBy",
		"name": "getBy",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#getBy",
		"inherited": true,
		"description": "Returns an an element, if `key` of an element in the collection\rwith exact `value` can be found.\rOtherwise null is returned.",
		"memberof": "IUserCollection",
		"params": [
			{
				"name": "key"
			},
			{
				"name": "value"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"*"
					]
				}
			}
		],
		"meta": {
			"lineno": 34,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 507
	},
	{
		"id": "IUserCollection#get",
		"longname": "IUserCollection#get",
		"name": "get",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#get",
		"inherited": true,
		"description": "Returns an element with requested `id`, if exists in the collection.\rOtherwise null is returned.",
		"memberof": "IUserCollection",
		"params": [
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "id"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"*"
					]
				}
			}
		],
		"meta": {
			"lineno": 55,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 508
	},
	{
		"id": "IUserCollection#filter",
		"longname": "IUserCollection#filter",
		"name": "filter",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#filter",
		"inherited": true,
		"description": "Creates a new array with all elements that pass the test implemented\rby the provided function.",
		"memberof": "IUserCollection",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array"
					]
				}
			}
		],
		"meta": {
			"lineno": 82,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 509
	},
	{
		"id": "IUserCollection#find",
		"longname": "IUserCollection#find",
		"name": "find",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#find",
		"inherited": true,
		"description": "Returns a value in the collection, if an element in the collection\rsatisfies the provided testing function. Otherwise null is returned.",
		"memberof": "IUserCollection",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Object",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 110,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 510
	},
	{
		"id": "IUserCollection#forEach",
		"longname": "IUserCollection#forEach",
		"name": "forEach",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#forEach",
		"inherited": true,
		"description": "Executes a provided function once per element.",
		"memberof": "IUserCollection",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"meta": {
			"lineno": 125,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 511
	},
	{
		"id": "IUserCollection#map",
		"longname": "IUserCollection#map",
		"name": "map",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#map",
		"inherited": true,
		"description": "Creates a new array with the results of calling a provided function on\revery element in this collection.",
		"memberof": "IUserCollection",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array"
					]
				}
			}
		],
		"meta": {
			"lineno": 140,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 512
	},
	{
		"id": "IUserCollection#toArray",
		"longname": "IUserCollection#toArray",
		"name": "toArray",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#toArray",
		"inherited": true,
		"description": "Creates a new array with elements of this collection.",
		"memberof": "IUserCollection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Array"
					]
				}
			}
		],
		"meta": {
			"lineno": 164,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 513
	},
	{
		"id": "IMessageCollection#getBy",
		"longname": "IMessageCollection#getBy",
		"name": "getBy",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#getBy",
		"inherited": true,
		"description": "Returns an an element, if `key` of an element in the collection\rwith exact `value` can be found.\rOtherwise null is returned.",
		"memberof": "IMessageCollection",
		"params": [
			{
				"name": "key"
			},
			{
				"name": "value"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"*"
					]
				}
			}
		],
		"meta": {
			"lineno": 34,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 516
	},
	{
		"id": "IMessageCollection#get",
		"longname": "IMessageCollection#get",
		"name": "get",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#get",
		"inherited": true,
		"description": "Returns an element with requested `id`, if exists in the collection.\rOtherwise null is returned.",
		"memberof": "IMessageCollection",
		"params": [
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "id"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"*"
					]
				}
			}
		],
		"meta": {
			"lineno": 55,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 517
	},
	{
		"id": "IMessageCollection#filter",
		"longname": "IMessageCollection#filter",
		"name": "filter",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#filter",
		"inherited": true,
		"description": "Creates a new array with all elements that pass the test implemented\rby the provided function.",
		"memberof": "IMessageCollection",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array"
					]
				}
			}
		],
		"meta": {
			"lineno": 82,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 518
	},
	{
		"id": "IMessageCollection#find",
		"longname": "IMessageCollection#find",
		"name": "find",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#find",
		"inherited": true,
		"description": "Returns a value in the collection, if an element in the collection\rsatisfies the provided testing function. Otherwise null is returned.",
		"memberof": "IMessageCollection",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Object",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 110,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 519
	},
	{
		"id": "IMessageCollection#forEach",
		"longname": "IMessageCollection#forEach",
		"name": "forEach",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#forEach",
		"inherited": true,
		"description": "Executes a provided function once per element.",
		"memberof": "IMessageCollection",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"meta": {
			"lineno": 125,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 520
	},
	{
		"id": "IMessageCollection#map",
		"longname": "IMessageCollection#map",
		"name": "map",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#map",
		"inherited": true,
		"description": "Creates a new array with the results of calling a provided function on\revery element in this collection.",
		"memberof": "IMessageCollection",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array"
					]
				}
			}
		],
		"meta": {
			"lineno": 140,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 521
	},
	{
		"id": "IMessageCollection#toArray",
		"longname": "IMessageCollection#toArray",
		"name": "toArray",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#toArray",
		"inherited": true,
		"description": "Creates a new array with elements of this collection.",
		"memberof": "IMessageCollection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Array"
					]
				}
			}
		],
		"meta": {
			"lineno": 164,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 522
	},
	{
		"id": "IDirectMessageChannelCollection#getBy",
		"longname": "IDirectMessageChannelCollection#getBy",
		"name": "getBy",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#getBy",
		"inherited": true,
		"description": "Returns an an element, if `key` of an element in the collection\rwith exact `value` can be found.\rOtherwise null is returned.",
		"memberof": "IDirectMessageChannelCollection",
		"params": [
			{
				"name": "key"
			},
			{
				"name": "value"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"*"
					]
				}
			}
		],
		"meta": {
			"lineno": 34,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 525
	},
	{
		"id": "IDirectMessageChannelCollection#get",
		"longname": "IDirectMessageChannelCollection#get",
		"name": "get",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#get",
		"inherited": true,
		"description": "Returns an element with requested `id`, if exists in the collection.\rOtherwise null is returned.",
		"memberof": "IDirectMessageChannelCollection",
		"params": [
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "id"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"*"
					]
				}
			}
		],
		"meta": {
			"lineno": 55,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 526
	},
	{
		"id": "IDirectMessageChannelCollection#filter",
		"longname": "IDirectMessageChannelCollection#filter",
		"name": "filter",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#filter",
		"inherited": true,
		"description": "Creates a new array with all elements that pass the test implemented\rby the provided function.",
		"memberof": "IDirectMessageChannelCollection",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array"
					]
				}
			}
		],
		"meta": {
			"lineno": 82,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 527
	},
	{
		"id": "IDirectMessageChannelCollection#find",
		"longname": "IDirectMessageChannelCollection#find",
		"name": "find",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#find",
		"inherited": true,
		"description": "Returns a value in the collection, if an element in the collection\rsatisfies the provided testing function. Otherwise null is returned.",
		"memberof": "IDirectMessageChannelCollection",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Object",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 110,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 528
	},
	{
		"id": "IDirectMessageChannelCollection#forEach",
		"longname": "IDirectMessageChannelCollection#forEach",
		"name": "forEach",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#forEach",
		"inherited": true,
		"description": "Executes a provided function once per element.",
		"memberof": "IDirectMessageChannelCollection",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"meta": {
			"lineno": 125,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 529
	},
	{
		"id": "IDirectMessageChannelCollection#map",
		"longname": "IDirectMessageChannelCollection#map",
		"name": "map",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#map",
		"inherited": true,
		"description": "Creates a new array with the results of calling a provided function on\revery element in this collection.",
		"memberof": "IDirectMessageChannelCollection",
		"params": [
			{
				"type": {
					"names": [
						"function"
					]
				},
				"description": "Function with signature fn(item)",
				"name": "fn"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Array"
					]
				}
			}
		],
		"meta": {
			"lineno": 140,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 530
	},
	{
		"id": "IDirectMessageChannelCollection#toArray",
		"longname": "IDirectMessageChannelCollection#toArray",
		"name": "toArray",
		"scope": "instance",
		"kind": "function",
		"inherits": "ICollectionBase#toArray",
		"inherited": true,
		"description": "Creates a new array with elements of this collection.",
		"memberof": "IDirectMessageChannelCollection",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Array"
					]
				}
			}
		],
		"meta": {
			"lineno": 164,
			"filename": "ICollectionBase.js",
			"path": "/lib/interfaces"
		},
		"order": 531
	},
	{
		"id": "IGuildMember#isMentioned",
		"longname": "IGuildMember#isMentioned",
		"name": "isMentioned",
		"scope": "instance",
		"kind": "function",
		"inherits": "IUser#isMentioned",
		"inherited": true,
		"description": "Checks whether the user is mentioned in a `message`.",
		"memberof": "IGuildMember",
		"params": [
			{
				"type": {
					"names": [
						"IMessage"
					]
				},
				"name": "message"
			},
			{
				"type": {
					"names": [
						"boolean"
					]
				},
				"name": "ignoreImplicitMentions"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"meta": {
			"lineno": 135,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 539
	},
	{
		"id": "IGuildMember#openDM",
		"longname": "IGuildMember#openDM",
		"name": "openDM",
		"scope": "instance",
		"kind": "function",
		"inherits": "IUser#openDM",
		"inherited": true,
		"description": "Opens or gets existing Direct Message channel.",
		"memberof": "IGuildMember",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IDirectMessageChannel, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 153,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 540
	},
	{
		"id": "IGuildMember#memberOf",
		"longname": "IGuildMember#memberOf",
		"name": "memberOf",
		"scope": "instance",
		"kind": "function",
		"inherits": "IUser#memberOf",
		"inherited": true,
		"description": "Attempts to get a guild member interface, returns null if this user is not\ra member of the `guild` or `guild` is not in cache.",
		"memberof": "IGuildMember",
		"params": [
			{
				"type": {
					"names": [
						"IGuild",
						"String"
					]
				},
				"name": "guild"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"IGuildMember",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 163,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 541
	},
	{
		"id": "IGuildMember#permissionsFor",
		"longname": "IGuildMember#permissionsFor",
		"name": "permissionsFor",
		"scope": "instance",
		"kind": "function",
		"inherits": "IUser#permissionsFor",
		"inherited": true,
		"description": "Resolves permissions for user in `context`.\r\rReturns a helper object with getter boolean properties.\r\rThrows:\r\r- ** `\"user must be an instance of IUser\"` **\r\r  If the method was called without binding to a `IUser` object\r  (as a function).\r\r- ** `\"context must be an instance of IChannel or IGuild\"` **\r\r  If context type is invalid.\r\r- ** `\"Invalid context\"` **\r\r  If context object no longer exists in cache.\r\r- ** `\"User is not a member of the context\"` **\r\r  If this user is not a member of the guild or\r  guild the channel belongs to.\r\rSee documentation of `IPermissions` for list of possible permissions.",
		"memberof": "IGuildMember",
		"params": [
			{
				"type": {
					"names": [
						"IChannel",
						"IGuild"
					]
				},
				"name": "context"
			}
		],
		"examples": [
			"const guild = client.Guilds.find(g => g.name == \"test\");\rconst channel = guild.channels.find(c => c.name == \"restricted\");\rconst user = guild.members.find(m => m.username == \"testuser\");\r\rconst guildPerms = user.permissionsFor(guild); // resolves to role permissions\rconst channelPerms = user.permissionsFor(channel); // resolves to channel permissions\r\rconsole.log(guildPerms.General.MANAGE_ROLES); // false\rconsole.log(guildPerms.Text.READ_MESSAGES); // true\r// The `restricted` channel has `READ_MESSAGES` denied\rconsole.log(channelPerms.Text.READ_MESSAGES); // false"
		],
		"returns": [
			{
				"type": {
					"names": [
						"IPermissions"
					]
				}
			}
		],
		"meta": {
			"lineno": 209,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 542
	},
	{
		"id": "IGuildMember#can",
		"longname": "IGuildMember#can",
		"name": "can",
		"scope": "instance",
		"kind": "function",
		"inherits": "IUser#can",
		"inherited": true,
		"description": "Resolves permissions for user in `context` and checks if\ruser has `permission`.\r\rSee `IUser.permissionsFor` method for list of throwable errors.\r\rSee documentation of `IPermissions` for full list of possible permissions.",
		"memberof": "IGuildMember",
		"params": [
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"description": "One or multiple permission bits",
				"name": "permission"
			},
			{
				"type": {
					"names": [
						"IChannel",
						"IGuild"
					]
				},
				"name": "context"
			}
		],
		"examples": [
			"const guild = client.Guilds.find(g => g.name == \"test\");\rconst channel = guild.channels.find(c => c.name == \"node_discordie\");\rconst user = guild.members.find(m => m.username == \"testuser\");\ruser.can(Discordie.Permissions.General.KICK_MEMBERS, guild); // resolves to role permissions\ruser.can(Discordie.Permissions.Text.READ_MESSAGES, channel); // resolves to channel permissions"
		],
		"returns": [
			{
				"type": {
					"names": [
						"boolean"
					]
				}
			}
		],
		"meta": {
			"lineno": 230,
			"filename": "IUser.js",
			"path": "/lib/interfaces"
		},
		"order": 543
	},
	{
		"id": "ITextChannel#createInvite",
		"longname": "ITextChannel#createInvite",
		"name": "createInvite",
		"scope": "instance",
		"kind": "function",
		"inherits": "IChannel#createInvite",
		"inherited": true,
		"description": "Makes a request to create an invite for this channel.",
		"memberof": "ITextChannel",
		"params": [
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"name": "options"
			}
		],
		"examples": [
			"channel.createInvite({\r  max_age: 60 * 60 * 24, // value in seconds\r  max_uses: 0, // pretty obvious\r  temporary: false\r  // temporary membership, kicks members without roles on disconnect\r});\r// Example response:\r{\r  \"max_age\": 86400,\r  \"code\": \"AAAAAAAAAAAAAAAA\",\r  \"guild\": {\r    \"splash_hash\": null,\r    \"id\": \"00000000000000000\",\r    \"name\": \"test\"\r  },\r  \"revoked\": false,\r  \"created_at\": \"2015-10-16T10:45:38.566978+00:00\",\r  \"temporary\": false,\r  \"uses\": 0,\r  \"max_uses\": 0,\r  \"inviter\": {\r    \"username\": \"testuser\",\r    \"discriminator\": \"3273\",\r    \"bot\": true,\r    \"id\": \"00000000000000000\",\r    \"avatar\": null\r  },\r  \"channel\": {\r    \"type\": \"text\",\r    \"id\": \"000000000000000000\",\r    \"name\": \"testchannel\"\r  }\r}"
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 151,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 556
	},
	{
		"id": "ITextChannel#createPermissionOverwrite",
		"longname": "ITextChannel#createPermissionOverwrite",
		"name": "createPermissionOverwrite",
		"scope": "instance",
		"kind": "function",
		"inherits": "IChannel#createPermissionOverwrite",
		"inherited": true,
		"description": "Makes a request to create a permission overwrite for this channel.",
		"memberof": "ITextChannel",
		"params": [
			{
				"type": {
					"names": [
						"IAuthenticatedUser",
						"IRole",
						"IGuildMember"
					]
				},
				"name": "roleOrMember"
			},
			{
				"type": {
					"names": [
						"IPermissions",
						"Number"
					]
				},
				"optional": true,
				"name": "allow"
			},
			{
				"type": {
					"names": [
						"IPermissions",
						"Number"
					]
				},
				"optional": true,
				"name": "deny"
			}
		],
		"examples": [
			"channel.createPermissionOverwrite(this.User);\rchannel.createPermissionOverwrite(\r  channel.guild.members.find(m => m.username == \"testuser\")\r);\rchannel.createPermissionOverwrite(\r  channel.guild.roles.find(r => r.name == \"new role\")\r)\r.then(overwrite => console.log(overwrite))\r.catch(error => console.log(error));"
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IPermissionOverwrite, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 172,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 557
	},
	{
		"id": "ITextChannel#update",
		"longname": "ITextChannel#update",
		"name": "update",
		"scope": "instance",
		"kind": "function",
		"inherits": "IChannel#update",
		"inherited": true,
		"description": "Makes a request to update this channel.",
		"memberof": "ITextChannel",
		"params": [
			{
				"type": {
					"names": [
						"String"
					]
				},
				"optional": true,
				"name": "name"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"optional": true,
				"name": "topic"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "Only for voice channels",
				"name": "bitrate"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "Only for voice channels",
				"name": "userLimit"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IChannel, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 214,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 558
	},
	{
		"id": "ITextChannel#clone",
		"longname": "ITextChannel#clone",
		"name": "clone",
		"scope": "instance",
		"kind": "function",
		"inherits": "IChannel#clone",
		"inherited": true,
		"description": "Makes a request to create a new channel with permission overwrites of\rthis channel.",
		"memberof": "ITextChannel",
		"params": [
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "name"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "See IChannel / Discordie.ChannelTypes",
				"name": "type"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "Only for voice channels",
				"name": "bitrate"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "Only for voice channels",
				"name": "userLimit"
			}
		],
		"meta": {
			"lineno": 237,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 559
	},
	{
		"id": "ITextChannel#setPosition",
		"longname": "ITextChannel#setPosition",
		"name": "setPosition",
		"scope": "instance",
		"kind": "function",
		"inherits": "IChannel#setPosition",
		"inherited": true,
		"description": "Moves this channel to `position` and makes a batch channel update request.",
		"memberof": "ITextChannel",
		"params": [
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"name": "position"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 256,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 560
	},
	{
		"id": "ITextChannel#delete",
		"longname": "ITextChannel#delete",
		"name": "delete",
		"scope": "instance",
		"kind": "function",
		"inherits": "IChannel#delete",
		"inherited": true,
		"description": "Makes a request to delete this channel.",
		"memberof": "ITextChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 272,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 561
	},
	{
		"id": "ITextChannel#getInvites",
		"longname": "ITextChannel#getInvites",
		"name": "getInvites",
		"scope": "instance",
		"kind": "function",
		"inherits": "IChannel#getInvites",
		"inherited": true,
		"description": "Makes a request to get a list of invites for this channel.",
		"memberof": "ITextChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Array.<Object>, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 280,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 562
	},
	{
		"id": "IVoiceChannel#createInvite",
		"longname": "IVoiceChannel#createInvite",
		"name": "createInvite",
		"scope": "instance",
		"kind": "function",
		"inherits": "IChannel#createInvite",
		"inherited": true,
		"description": "Makes a request to create an invite for this channel.",
		"memberof": "IVoiceChannel",
		"params": [
			{
				"type": {
					"names": [
						"Object"
					]
				},
				"name": "options"
			}
		],
		"examples": [
			"channel.createInvite({\r  max_age: 60 * 60 * 24, // value in seconds\r  max_uses: 0, // pretty obvious\r  temporary: false\r  // temporary membership, kicks members without roles on disconnect\r});\r// Example response:\r{\r  \"max_age\": 86400,\r  \"code\": \"AAAAAAAAAAAAAAAA\",\r  \"guild\": {\r    \"splash_hash\": null,\r    \"id\": \"00000000000000000\",\r    \"name\": \"test\"\r  },\r  \"revoked\": false,\r  \"created_at\": \"2015-10-16T10:45:38.566978+00:00\",\r  \"temporary\": false,\r  \"uses\": 0,\r  \"max_uses\": 0,\r  \"inviter\": {\r    \"username\": \"testuser\",\r    \"discriminator\": \"3273\",\r    \"bot\": true,\r    \"id\": \"00000000000000000\",\r    \"avatar\": null\r  },\r  \"channel\": {\r    \"type\": \"text\",\r    \"id\": \"000000000000000000\",\r    \"name\": \"testchannel\"\r  }\r}"
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Object, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 151,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 572
	},
	{
		"id": "IVoiceChannel#createPermissionOverwrite",
		"longname": "IVoiceChannel#createPermissionOverwrite",
		"name": "createPermissionOverwrite",
		"scope": "instance",
		"kind": "function",
		"inherits": "IChannel#createPermissionOverwrite",
		"inherited": true,
		"description": "Makes a request to create a permission overwrite for this channel.",
		"memberof": "IVoiceChannel",
		"params": [
			{
				"type": {
					"names": [
						"IAuthenticatedUser",
						"IRole",
						"IGuildMember"
					]
				},
				"name": "roleOrMember"
			},
			{
				"type": {
					"names": [
						"IPermissions",
						"Number"
					]
				},
				"optional": true,
				"name": "allow"
			},
			{
				"type": {
					"names": [
						"IPermissions",
						"Number"
					]
				},
				"optional": true,
				"name": "deny"
			}
		],
		"examples": [
			"channel.createPermissionOverwrite(this.User);\rchannel.createPermissionOverwrite(\r  channel.guild.members.find(m => m.username == \"testuser\")\r);\rchannel.createPermissionOverwrite(\r  channel.guild.roles.find(r => r.name == \"new role\")\r)\r.then(overwrite => console.log(overwrite))\r.catch(error => console.log(error));"
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IPermissionOverwrite, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 172,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 573
	},
	{
		"id": "IVoiceChannel#update",
		"longname": "IVoiceChannel#update",
		"name": "update",
		"scope": "instance",
		"kind": "function",
		"inherits": "IChannel#update",
		"inherited": true,
		"description": "Makes a request to update this channel.",
		"memberof": "IVoiceChannel",
		"params": [
			{
				"type": {
					"names": [
						"String"
					]
				},
				"optional": true,
				"name": "name"
			},
			{
				"type": {
					"names": [
						"String"
					]
				},
				"optional": true,
				"name": "topic"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "Only for voice channels",
				"name": "bitrate"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "Only for voice channels",
				"name": "userLimit"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<IChannel, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 214,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 574
	},
	{
		"id": "IVoiceChannel#clone",
		"longname": "IVoiceChannel#clone",
		"name": "clone",
		"scope": "instance",
		"kind": "function",
		"inherits": "IChannel#clone",
		"inherited": true,
		"description": "Makes a request to create a new channel with permission overwrites of\rthis channel.",
		"memberof": "IVoiceChannel",
		"params": [
			{
				"type": {
					"names": [
						"String"
					]
				},
				"name": "name"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "See IChannel / Discordie.ChannelTypes",
				"name": "type"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "Only for voice channels",
				"name": "bitrate"
			},
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"optional": true,
				"description": "Only for voice channels",
				"name": "userLimit"
			}
		],
		"meta": {
			"lineno": 237,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 575
	},
	{
		"id": "IVoiceChannel#setPosition",
		"longname": "IVoiceChannel#setPosition",
		"name": "setPosition",
		"scope": "instance",
		"kind": "function",
		"inherits": "IChannel#setPosition",
		"inherited": true,
		"description": "Moves this channel to `position` and makes a batch channel update request.",
		"memberof": "IVoiceChannel",
		"params": [
			{
				"type": {
					"names": [
						"Number"
					]
				},
				"name": "position"
			}
		],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 256,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 576
	},
	{
		"id": "IVoiceChannel#delete",
		"longname": "IVoiceChannel#delete",
		"name": "delete",
		"scope": "instance",
		"kind": "function",
		"inherits": "IChannel#delete",
		"inherited": true,
		"description": "Makes a request to delete this channel.",
		"memberof": "IVoiceChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise"
					]
				}
			}
		],
		"meta": {
			"lineno": 272,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 577
	},
	{
		"id": "IVoiceChannel#getInvites",
		"longname": "IVoiceChannel#getInvites",
		"name": "getInvites",
		"scope": "instance",
		"kind": "function",
		"inherits": "IChannel#getInvites",
		"inherited": true,
		"description": "Makes a request to get a list of invites for this channel.",
		"memberof": "IVoiceChannel",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"Promise.<Array.<Object>, Error>"
					]
				}
			}
		],
		"meta": {
			"lineno": 280,
			"filename": "IChannel.js",
			"path": "/lib/interfaces"
		},
		"order": 578
	},
	{
		"id": "FFmpegEncoder#play",
		"longname": "FFmpegEncoder#play",
		"name": "play",
		"scope": "instance",
		"kind": "function",
		"inherits": "ExternalEncoderBase#play",
		"inherited": true,
		"overrides": "ExternalEncoderBase#play",
		"description": "Connects pipe into AudioEncoderStream of the bound voice connection.\r\rThis function handles automatic unpiping and kills process.\rThe stream will become disposed and no longer playable after\rcalling `unpipe()` or `stop()`.\r\rUse `pipe()` method if you want to control the process manually\rand `destroy()` it later.",
		"memberof": "FFmpegEncoder",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"AudioEncoderStream"
					]
				}
			}
		],
		"meta": {
			"lineno": 63,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 585
	},
	{
		"id": "FFmpegEncoder#stop",
		"longname": "FFmpegEncoder#stop",
		"name": "stop",
		"scope": "instance",
		"kind": "function",
		"inherits": "ExternalEncoderBase#stop",
		"inherited": true,
		"description": "Unpipes internal stream from the bound voice connection.",
		"memberof": "FFmpegEncoder",
		"params": [],
		"meta": {
			"lineno": 91,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 586
	},
	{
		"id": "FFmpegEncoder#pipe",
		"longname": "FFmpegEncoder#pipe",
		"name": "pipe",
		"scope": "instance",
		"kind": "function",
		"inherits": "ExternalEncoderBase#pipe",
		"inherited": true,
		"overrides": "ExternalEncoderBase#pipe",
		"description": "Pipes stream into destination.\r\r> **Note:** In case of manual piping you have to invoke\r> `IVoiceConnection.getEncoderStream` with the correct settings yourself.\r> For proxy (externally encoding) streams only `{proxy: true}` is required.",
		"memberof": "FFmpegEncoder",
		"params": [
			{
				"type": {
					"names": [
						"WritableStream"
					]
				},
				"name": "dest"
			}
		],
		"meta": {
			"lineno": 103,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 587
	},
	{
		"id": "FFmpegEncoder#unpipe",
		"longname": "FFmpegEncoder#unpipe",
		"name": "unpipe",
		"scope": "instance",
		"kind": "function",
		"inherits": "ExternalEncoderBase#unpipe",
		"inherited": true,
		"overrides": "ExternalEncoderBase#unpipe",
		"description": "Unpipes stream from destination.",
		"memberof": "FFmpegEncoder",
		"params": [
			{
				"type": {
					"names": [
						"WritableStream"
					]
				},
				"optional": true,
				"name": "dest"
			}
		],
		"meta": {
			"lineno": 109,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 588
	},
	{
		"id": "FFmpegEncoder#destroy",
		"longname": "FFmpegEncoder#destroy",
		"name": "destroy",
		"scope": "instance",
		"kind": "function",
		"inherits": "ExternalEncoderBase#destroy",
		"inherited": true,
		"overrides": "ExternalEncoderBase#destroy",
		"description": "Destroys all handles, releases resources and disposes this instance.",
		"memberof": "FFmpegEncoder",
		"params": [],
		"meta": {
			"lineno": 114,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 589
	},
	{
		"id": "OggOpusPlayer#play",
		"longname": "OggOpusPlayer#play",
		"name": "play",
		"scope": "instance",
		"kind": "function",
		"inherits": "ExternalEncoderBase#play",
		"inherited": true,
		"description": "Connects pipe into AudioEncoderStream of the bound voice connection.\r\rThis function handles automatic unpiping and kills process.\rThe stream will become disposed and no longer playable after\rcalling `unpipe()` or `stop()`.\r\rUse `pipe()` method if you want to control the process manually\rand `destroy()` it later.",
		"memberof": "OggOpusPlayer",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"AudioEncoderStream"
					]
				}
			}
		],
		"meta": {
			"lineno": 63,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 591
	},
	{
		"id": "OggOpusPlayer#stop",
		"longname": "OggOpusPlayer#stop",
		"name": "stop",
		"scope": "instance",
		"kind": "function",
		"inherits": "ExternalEncoderBase#stop",
		"inherited": true,
		"description": "Unpipes internal stream from the bound voice connection.",
		"memberof": "OggOpusPlayer",
		"params": [],
		"meta": {
			"lineno": 91,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 592
	},
	{
		"id": "OggOpusPlayer#pipe",
		"longname": "OggOpusPlayer#pipe",
		"name": "pipe",
		"scope": "instance",
		"kind": "function",
		"inherits": "ExternalEncoderBase#pipe",
		"inherited": true,
		"overrides": "ExternalEncoderBase#pipe",
		"description": "Pipes stream into destination.\r\r> **Note:** In case of manual piping you have to invoke\r> `IVoiceConnection.getEncoderStream` with the correct settings yourself.\r> For proxy (externally encoding) streams only `{proxy: true}` is required.",
		"memberof": "OggOpusPlayer",
		"params": [
			{
				"type": {
					"names": [
						"WritableStream"
					]
				},
				"name": "dest"
			}
		],
		"meta": {
			"lineno": 103,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 593
	},
	{
		"id": "OggOpusPlayer#unpipe",
		"longname": "OggOpusPlayer#unpipe",
		"name": "unpipe",
		"scope": "instance",
		"kind": "function",
		"inherits": "ExternalEncoderBase#unpipe",
		"inherited": true,
		"overrides": "ExternalEncoderBase#unpipe",
		"description": "Unpipes stream from destination.",
		"memberof": "OggOpusPlayer",
		"params": [
			{
				"type": {
					"names": [
						"WritableStream"
					]
				},
				"optional": true,
				"name": "dest"
			}
		],
		"meta": {
			"lineno": 109,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 594
	},
	{
		"id": "OggOpusPlayer#destroy",
		"longname": "OggOpusPlayer#destroy",
		"name": "destroy",
		"scope": "instance",
		"kind": "function",
		"inherits": "ExternalEncoderBase#destroy",
		"inherited": true,
		"description": "Destroys all handles, releases resources and disposes this instance.",
		"memberof": "OggOpusPlayer",
		"params": [],
		"meta": {
			"lineno": 114,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 595
	},
	{
		"id": "WebmOpusPlayer#play",
		"longname": "WebmOpusPlayer#play",
		"name": "play",
		"scope": "instance",
		"kind": "function",
		"inherits": "ExternalEncoderBase#play",
		"inherited": true,
		"description": "Connects pipe into AudioEncoderStream of the bound voice connection.\r\rThis function handles automatic unpiping and kills process.\rThe stream will become disposed and no longer playable after\rcalling `unpipe()` or `stop()`.\r\rUse `pipe()` method if you want to control the process manually\rand `destroy()` it later.",
		"memberof": "WebmOpusPlayer",
		"params": [],
		"returns": [
			{
				"type": {
					"names": [
						"AudioEncoderStream"
					]
				}
			}
		],
		"meta": {
			"lineno": 63,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 597
	},
	{
		"id": "WebmOpusPlayer#stop",
		"longname": "WebmOpusPlayer#stop",
		"name": "stop",
		"scope": "instance",
		"kind": "function",
		"inherits": "ExternalEncoderBase#stop",
		"inherited": true,
		"description": "Unpipes internal stream from the bound voice connection.",
		"memberof": "WebmOpusPlayer",
		"params": [],
		"meta": {
			"lineno": 91,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 598
	},
	{
		"id": "WebmOpusPlayer#pipe",
		"longname": "WebmOpusPlayer#pipe",
		"name": "pipe",
		"scope": "instance",
		"kind": "function",
		"inherits": "ExternalEncoderBase#pipe",
		"inherited": true,
		"overrides": "ExternalEncoderBase#pipe",
		"description": "Pipes stream into destination.\r\r> **Note:** In case of manual piping you have to invoke\r> `IVoiceConnection.getEncoderStream` with the correct settings yourself.\r> For proxy (externally encoding) streams only `{proxy: true}` is required.",
		"memberof": "WebmOpusPlayer",
		"params": [
			{
				"type": {
					"names": [
						"WritableStream"
					]
				},
				"name": "dest"
			}
		],
		"meta": {
			"lineno": 103,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 599
	},
	{
		"id": "WebmOpusPlayer#unpipe",
		"longname": "WebmOpusPlayer#unpipe",
		"name": "unpipe",
		"scope": "instance",
		"kind": "function",
		"inherits": "ExternalEncoderBase#unpipe",
		"inherited": true,
		"overrides": "ExternalEncoderBase#unpipe",
		"description": "Unpipes stream from destination.",
		"memberof": "WebmOpusPlayer",
		"params": [
			{
				"type": {
					"names": [
						"WritableStream"
					]
				},
				"optional": true,
				"name": "dest"
			}
		],
		"meta": {
			"lineno": 109,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 600
	},
	{
		"id": "WebmOpusPlayer#destroy",
		"longname": "WebmOpusPlayer#destroy",
		"name": "destroy",
		"scope": "instance",
		"kind": "function",
		"inherits": "ExternalEncoderBase#destroy",
		"inherited": true,
		"description": "Destroys all handles, releases resources and disposes this instance.",
		"memberof": "WebmOpusPlayer",
		"params": [],
		"meta": {
			"lineno": 114,
			"filename": "ExternalEncoderBase.js",
			"path": "/lib/voice/players"
		},
		"order": 601
	},
	{
		"id": "AuthenticatedUser.id",
		"longname": "AuthenticatedUser.id",
		"name": "id",
		"scope": "static",
		"kind": "member",
		"memberof": "AuthenticatedUser",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 13,
			"filename": "AuthenticatedUser.js",
			"path": "/lib/models"
		},
		"order": 365
	},
	{
		"id": "AuthenticatedUser.username",
		"longname": "AuthenticatedUser.username",
		"name": "username",
		"scope": "static",
		"kind": "member",
		"memberof": "AuthenticatedUser",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 15,
			"filename": "AuthenticatedUser.js",
			"path": "/lib/models"
		},
		"order": 366
	},
	{
		"id": "AuthenticatedUser.discriminator",
		"longname": "AuthenticatedUser.discriminator",
		"name": "discriminator",
		"scope": "static",
		"kind": "member",
		"memberof": "AuthenticatedUser",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 17,
			"filename": "AuthenticatedUser.js",
			"path": "/lib/models"
		},
		"order": 367
	},
	{
		"id": "AuthenticatedUser.email",
		"longname": "AuthenticatedUser.email",
		"name": "email",
		"scope": "static",
		"kind": "member",
		"memberof": "AuthenticatedUser",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 19,
			"filename": "AuthenticatedUser.js",
			"path": "/lib/models"
		},
		"order": 368
	},
	{
		"id": "AuthenticatedUser.verified",
		"longname": "AuthenticatedUser.verified",
		"name": "verified",
		"scope": "static",
		"kind": "member",
		"memberof": "AuthenticatedUser",
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 21,
			"filename": "AuthenticatedUser.js",
			"path": "/lib/models"
		},
		"order": 369
	},
	{
		"id": "AuthenticatedUser.status",
		"longname": "AuthenticatedUser.status",
		"name": "status",
		"scope": "static",
		"kind": "member",
		"memberof": "AuthenticatedUser",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 23,
			"filename": "AuthenticatedUser.js",
			"path": "/lib/models"
		},
		"order": 370
	},
	{
		"id": "AuthenticatedUser.avatar",
		"longname": "AuthenticatedUser.avatar",
		"name": "avatar",
		"scope": "static",
		"kind": "member",
		"memberof": "AuthenticatedUser",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 25,
			"filename": "AuthenticatedUser.js",
			"path": "/lib/models"
		},
		"order": 371
	},
	{
		"id": "AuthenticatedUser.token",
		"longname": "AuthenticatedUser.token",
		"name": "token",
		"scope": "static",
		"kind": "member",
		"memberof": "AuthenticatedUser",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 27,
			"filename": "AuthenticatedUser.js",
			"path": "/lib/models"
		},
		"order": 372
	},
	{
		"id": "AuthenticatedUser.bot",
		"longname": "AuthenticatedUser.bot",
		"name": "bot",
		"scope": "static",
		"kind": "member",
		"memberof": "AuthenticatedUser",
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 29,
			"filename": "AuthenticatedUser.js",
			"path": "/lib/models"
		},
		"order": 373
	},
	{
		"id": "AuthenticatedUser.mfa_enabled",
		"longname": "AuthenticatedUser.mfa_enabled",
		"name": "mfa_enabled",
		"scope": "static",
		"kind": "member",
		"memberof": "AuthenticatedUser",
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 31,
			"filename": "AuthenticatedUser.js",
			"path": "/lib/models"
		},
		"order": 374
	},
	{
		"id": "AuthenticatedUser.game",
		"longname": "AuthenticatedUser.game",
		"name": "game",
		"scope": "static",
		"kind": "member",
		"memberof": "AuthenticatedUser",
		"returns": [
			{
				"type": {
					"names": [
						"Object",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 33,
			"filename": "AuthenticatedUser.js",
			"path": "/lib/models"
		},
		"order": 375
	},
	{
		"id": "AuthenticatedUser.afk",
		"longname": "AuthenticatedUser.afk",
		"name": "afk",
		"scope": "static",
		"kind": "member",
		"memberof": "AuthenticatedUser",
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 35,
			"filename": "AuthenticatedUser.js",
			"path": "/lib/models"
		},
		"order": 376
	},
	{
		"id": "Call.channel_id",
		"longname": "Call.channel_id",
		"name": "channel_id",
		"scope": "static",
		"kind": "member",
		"memberof": "Call",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 12,
			"filename": "Call.js",
			"path": "/lib/models"
		},
		"order": 378
	},
	{
		"id": "Call.message_id",
		"longname": "Call.message_id",
		"name": "message_id",
		"scope": "static",
		"kind": "member",
		"memberof": "Call",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 14,
			"filename": "Call.js",
			"path": "/lib/models"
		},
		"order": 379
	},
	{
		"id": "Call.region",
		"longname": "Call.region",
		"name": "region",
		"scope": "static",
		"kind": "member",
		"memberof": "Call",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 16,
			"filename": "Call.js",
			"path": "/lib/models"
		},
		"order": 380
	},
	{
		"id": "Call.ringing",
		"longname": "Call.ringing",
		"name": "ringing",
		"scope": "static",
		"kind": "member",
		"memberof": "Call",
		"returns": [
			{
				"type": {
					"names": [
						"Array.<String>",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 18,
			"filename": "Call.js",
			"path": "/lib/models"
		},
		"order": 381
	},
	{
		"id": "Call.unavailable",
		"longname": "Call.unavailable",
		"name": "unavailable",
		"scope": "static",
		"kind": "member",
		"memberof": "Call",
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 20,
			"filename": "Call.js",
			"path": "/lib/models"
		},
		"order": 382
	},
	{
		"id": "Channel.id",
		"longname": "Channel.id",
		"name": "id",
		"scope": "static",
		"kind": "member",
		"memberof": "Channel",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 13,
			"filename": "Channel.js",
			"path": "/lib/models"
		},
		"order": 384
	},
	{
		"id": "Channel.name",
		"longname": "Channel.name",
		"name": "name",
		"scope": "static",
		"kind": "member",
		"memberof": "Channel",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 15,
			"filename": "Channel.js",
			"path": "/lib/models"
		},
		"order": 385
	},
	{
		"id": "Channel.topic",
		"longname": "Channel.topic",
		"name": "topic",
		"scope": "static",
		"kind": "member",
		"memberof": "Channel",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 17,
			"filename": "Channel.js",
			"path": "/lib/models"
		},
		"order": 386
	},
	{
		"id": "Channel.position",
		"longname": "Channel.position",
		"name": "position",
		"scope": "static",
		"kind": "member",
		"memberof": "Channel",
		"returns": [
			{
				"type": {
					"names": [
						"Number",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 19,
			"filename": "Channel.js",
			"path": "/lib/models"
		},
		"order": 387
	},
	{
		"id": "Channel.type",
		"longname": "Channel.type",
		"name": "type",
		"scope": "static",
		"kind": "member",
		"memberof": "Channel",
		"returns": [
			{
				"type": {
					"names": [
						"Number",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 21,
			"filename": "Channel.js",
			"path": "/lib/models"
		},
		"order": 388
	},
	{
		"id": "Channel.guild_id",
		"longname": "Channel.guild_id",
		"name": "guild_id",
		"scope": "static",
		"kind": "member",
		"memberof": "Channel",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 23,
			"filename": "Channel.js",
			"path": "/lib/models"
		},
		"order": 389
	},
	{
		"id": "Channel.recipients",
		"longname": "Channel.recipients",
		"name": "recipients",
		"scope": "static",
		"kind": "member",
		"memberof": "Channel",
		"returns": [
			{
				"type": {
					"names": [
						"Set",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 25,
			"filename": "Channel.js",
			"path": "/lib/models"
		},
		"order": 390
	},
	{
		"id": "Channel.permission_overwrites",
		"longname": "Channel.permission_overwrites",
		"name": "permission_overwrites",
		"scope": "static",
		"kind": "member",
		"memberof": "Channel",
		"returns": [
			{
				"type": {
					"names": [
						"Array",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 27,
			"filename": "Channel.js",
			"path": "/lib/models"
		},
		"order": 391
	},
	{
		"id": "Channel.bitrate",
		"longname": "Channel.bitrate",
		"name": "bitrate",
		"scope": "static",
		"kind": "member",
		"memberof": "Channel",
		"returns": [
			{
				"type": {
					"names": [
						"Number",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 29,
			"filename": "Channel.js",
			"path": "/lib/models"
		},
		"order": 392
	},
	{
		"id": "Channel.user_limit",
		"longname": "Channel.user_limit",
		"name": "user_limit",
		"scope": "static",
		"kind": "member",
		"memberof": "Channel",
		"returns": [
			{
				"type": {
					"names": [
						"Number",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 31,
			"filename": "Channel.js",
			"path": "/lib/models"
		},
		"order": 393
	},
	{
		"id": "Channel.owner_id",
		"longname": "Channel.owner_id",
		"name": "owner_id",
		"scope": "static",
		"kind": "member",
		"memberof": "Channel",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 33,
			"filename": "Channel.js",
			"path": "/lib/models"
		},
		"order": 394
	},
	{
		"id": "Channel.icon",
		"longname": "Channel.icon",
		"name": "icon",
		"scope": "static",
		"kind": "member",
		"memberof": "Channel",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 35,
			"filename": "Channel.js",
			"path": "/lib/models"
		},
		"order": 395
	},
	{
		"id": "Guild.id",
		"longname": "Guild.id",
		"name": "id",
		"scope": "static",
		"kind": "member",
		"memberof": "Guild",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 12,
			"filename": "Guild.js",
			"path": "/lib/models"
		},
		"order": 397
	},
	{
		"id": "Guild.name",
		"longname": "Guild.name",
		"name": "name",
		"scope": "static",
		"kind": "member",
		"memberof": "Guild",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 14,
			"filename": "Guild.js",
			"path": "/lib/models"
		},
		"order": 398
	},
	{
		"id": "Guild.owner_id",
		"longname": "Guild.owner_id",
		"name": "owner_id",
		"scope": "static",
		"kind": "member",
		"memberof": "Guild",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 16,
			"filename": "Guild.js",
			"path": "/lib/models"
		},
		"order": 399
	},
	{
		"id": "Guild.icon",
		"longname": "Guild.icon",
		"name": "icon",
		"scope": "static",
		"kind": "member",
		"memberof": "Guild",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 18,
			"filename": "Guild.js",
			"path": "/lib/models"
		},
		"order": 400
	},
	{
		"id": "Guild.splash",
		"longname": "Guild.splash",
		"name": "splash",
		"scope": "static",
		"kind": "member",
		"memberof": "Guild",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 20,
			"filename": "Guild.js",
			"path": "/lib/models"
		},
		"order": 401
	},
	{
		"id": "Guild.features",
		"longname": "Guild.features",
		"name": "features",
		"scope": "static",
		"kind": "member",
		"memberof": "Guild",
		"returns": [
			{
				"type": {
					"names": [
						"Set",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 22,
			"filename": "Guild.js",
			"path": "/lib/models"
		},
		"order": 402
	},
	{
		"id": "Guild.emojis",
		"longname": "Guild.emojis",
		"name": "emojis",
		"scope": "static",
		"kind": "member",
		"memberof": "Guild",
		"returns": [
			{
				"type": {
					"names": [
						"Array.<Object>",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 24,
			"filename": "Guild.js",
			"path": "/lib/models"
		},
		"order": 403
	},
	{
		"id": "Guild.default_message_notifications",
		"longname": "Guild.default_message_notifications",
		"name": "default_message_notifications",
		"scope": "static",
		"kind": "member",
		"memberof": "Guild",
		"returns": [
			{
				"type": {
					"names": [
						"Number",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 26,
			"filename": "Guild.js",
			"path": "/lib/models"
		},
		"order": 404
	},
	{
		"id": "Guild.roles",
		"longname": "Guild.roles",
		"name": "roles",
		"scope": "static",
		"kind": "member",
		"memberof": "Guild",
		"returns": [
			{
				"type": {
					"names": [
						"Map",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 28,
			"filename": "Guild.js",
			"path": "/lib/models"
		},
		"order": 405
	},
	{
		"id": "Guild.afk_channel_id",
		"longname": "Guild.afk_channel_id",
		"name": "afk_channel_id",
		"scope": "static",
		"kind": "member",
		"memberof": "Guild",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 30,
			"filename": "Guild.js",
			"path": "/lib/models"
		},
		"order": 406
	},
	{
		"id": "Guild.afk_timeout",
		"longname": "Guild.afk_timeout",
		"name": "afk_timeout",
		"scope": "static",
		"kind": "member",
		"memberof": "Guild",
		"returns": [
			{
				"type": {
					"names": [
						"Number",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 32,
			"filename": "Guild.js",
			"path": "/lib/models"
		},
		"order": 407
	},
	{
		"id": "Guild.verification_level",
		"longname": "Guild.verification_level",
		"name": "verification_level",
		"scope": "static",
		"kind": "member",
		"memberof": "Guild",
		"returns": [
			{
				"type": {
					"names": [
						"Number",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 34,
			"filename": "Guild.js",
			"path": "/lib/models"
		},
		"order": 408
	},
	{
		"id": "Guild.region",
		"longname": "Guild.region",
		"name": "region",
		"scope": "static",
		"kind": "member",
		"memberof": "Guild",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 36,
			"filename": "Guild.js",
			"path": "/lib/models"
		},
		"order": 409
	},
	{
		"id": "Guild.member_count",
		"longname": "Guild.member_count",
		"name": "member_count",
		"scope": "static",
		"kind": "member",
		"memberof": "Guild",
		"returns": [
			{
				"type": {
					"names": [
						"Number",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 38,
			"filename": "Guild.js",
			"path": "/lib/models"
		},
		"order": 410
	},
	{
		"id": "Guild.large",
		"longname": "Guild.large",
		"name": "large",
		"scope": "static",
		"kind": "member",
		"memberof": "Guild",
		"returns": [
			{
				"type": {
					"names": [
						"Boolean",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 40,
			"filename": "Guild.js",
			"path": "/lib/models"
		},
		"order": 411
	},
	{
		"id": "Guild.mfa_level",
		"longname": "Guild.mfa_level",
		"name": "mfa_level",
		"scope": "static",
		"kind": "member",
		"memberof": "Guild",
		"returns": [
			{
				"type": {
					"names": [
						"Number",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 42,
			"filename": "Guild.js",
			"path": "/lib/models"
		},
		"order": 412
	},
	{
		"id": "Guild.joined_at",
		"longname": "Guild.joined_at",
		"name": "joined_at",
		"scope": "static",
		"kind": "member",
		"memberof": "Guild",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 44,
			"filename": "Guild.js",
			"path": "/lib/models"
		},
		"order": 413
	},
	{
		"id": "GuildMember.id",
		"longname": "GuildMember.id",
		"name": "id",
		"scope": "static",
		"kind": "member",
		"memberof": "GuildMember",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 12,
			"filename": "GuildMember.js",
			"path": "/lib/models"
		},
		"order": 415
	},
	{
		"id": "GuildMember.guild_id",
		"longname": "GuildMember.guild_id",
		"name": "guild_id",
		"scope": "static",
		"kind": "member",
		"memberof": "GuildMember",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 14,
			"filename": "GuildMember.js",
			"path": "/lib/models"
		},
		"order": 416
	},
	{
		"id": "GuildMember.nick",
		"longname": "GuildMember.nick",
		"name": "nick",
		"scope": "static",
		"kind": "member",
		"memberof": "GuildMember",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 16,
			"filename": "GuildMember.js",
			"path": "/lib/models"
		},
		"order": 417
	},
	{
		"id": "GuildMember.roles",
		"longname": "GuildMember.roles",
		"name": "roles",
		"scope": "static",
		"kind": "member",
		"memberof": "GuildMember",
		"returns": [
			{
				"type": {
					"names": [
						"Array",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 18,
			"filename": "GuildMember.js",
			"path": "/lib/models"
		},
		"order": 418
	},
	{
		"id": "GuildMember.mute",
		"longname": "GuildMember.mute",
		"name": "mute",
		"scope": "static",
		"kind": "member",
		"memberof": "GuildMember",
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 20,
			"filename": "GuildMember.js",
			"path": "/lib/models"
		},
		"order": 419
	},
	{
		"id": "GuildMember.deaf",
		"longname": "GuildMember.deaf",
		"name": "deaf",
		"scope": "static",
		"kind": "member",
		"memberof": "GuildMember",
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 22,
			"filename": "GuildMember.js",
			"path": "/lib/models"
		},
		"order": 420
	},
	{
		"id": "GuildMember.self_mute",
		"longname": "GuildMember.self_mute",
		"name": "self_mute",
		"scope": "static",
		"kind": "member",
		"memberof": "GuildMember",
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 24,
			"filename": "GuildMember.js",
			"path": "/lib/models"
		},
		"order": 421
	},
	{
		"id": "GuildMember.self_deaf",
		"longname": "GuildMember.self_deaf",
		"name": "self_deaf",
		"scope": "static",
		"kind": "member",
		"memberof": "GuildMember",
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 26,
			"filename": "GuildMember.js",
			"path": "/lib/models"
		},
		"order": 422
	},
	{
		"id": "GuildMember.joined_at",
		"longname": "GuildMember.joined_at",
		"name": "joined_at",
		"scope": "static",
		"kind": "member",
		"memberof": "GuildMember",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 28,
			"filename": "GuildMember.js",
			"path": "/lib/models"
		},
		"order": 423
	},
	{
		"id": "Message.id",
		"longname": "Message.id",
		"name": "id",
		"scope": "static",
		"kind": "member",
		"memberof": "Message",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 13,
			"filename": "Message.js",
			"path": "/lib/models"
		},
		"order": 425
	},
	{
		"id": "Message.type",
		"longname": "Message.type",
		"name": "type",
		"scope": "static",
		"kind": "member",
		"memberof": "Message",
		"returns": [
			{
				"type": {
					"names": [
						"Number",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 15,
			"filename": "Message.js",
			"path": "/lib/models"
		},
		"order": 426
	},
	{
		"id": "Message.channel_id",
		"longname": "Message.channel_id",
		"name": "channel_id",
		"scope": "static",
		"kind": "member",
		"memberof": "Message",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 17,
			"filename": "Message.js",
			"path": "/lib/models"
		},
		"order": 427
	},
	{
		"id": "Message.author",
		"longname": "Message.author",
		"name": "author",
		"scope": "static",
		"kind": "member",
		"memberof": "Message",
		"returns": [
			{
				"type": {
					"names": [
						"User",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 19,
			"filename": "Message.js",
			"path": "/lib/models"
		},
		"order": 428
	},
	{
		"id": "Message.content",
		"longname": "Message.content",
		"name": "content",
		"scope": "static",
		"kind": "member",
		"memberof": "Message",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 21,
			"filename": "Message.js",
			"path": "/lib/models"
		},
		"order": 429
	},
	{
		"id": "Message.attachments",
		"longname": "Message.attachments",
		"name": "attachments",
		"scope": "static",
		"kind": "member",
		"memberof": "Message",
		"returns": [
			{
				"type": {
					"names": [
						"Array",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 23,
			"filename": "Message.js",
			"path": "/lib/models"
		},
		"order": 430
	},
	{
		"id": "Message.embeds",
		"longname": "Message.embeds",
		"name": "embeds",
		"scope": "static",
		"kind": "member",
		"memberof": "Message",
		"returns": [
			{
				"type": {
					"names": [
						"Array",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 25,
			"filename": "Message.js",
			"path": "/lib/models"
		},
		"order": 431
	},
	{
		"id": "Message.mentions",
		"longname": "Message.mentions",
		"name": "mentions",
		"scope": "static",
		"kind": "member",
		"memberof": "Message",
		"returns": [
			{
				"type": {
					"names": [
						"Array",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 27,
			"filename": "Message.js",
			"path": "/lib/models"
		},
		"order": 432
	},
	{
		"id": "Message.mention_roles",
		"longname": "Message.mention_roles",
		"name": "mention_roles",
		"scope": "static",
		"kind": "member",
		"memberof": "Message",
		"returns": [
			{
				"type": {
					"names": [
						"Array",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 29,
			"filename": "Message.js",
			"path": "/lib/models"
		},
		"order": 433
	},
	{
		"id": "Message.mention_everyone",
		"longname": "Message.mention_everyone",
		"name": "mention_everyone",
		"scope": "static",
		"kind": "member",
		"memberof": "Message",
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 31,
			"filename": "Message.js",
			"path": "/lib/models"
		},
		"order": 434
	},
	{
		"id": "Message.tts",
		"longname": "Message.tts",
		"name": "tts",
		"scope": "static",
		"kind": "member",
		"memberof": "Message",
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 33,
			"filename": "Message.js",
			"path": "/lib/models"
		},
		"order": 435
	},
	{
		"id": "Message.timestamp",
		"longname": "Message.timestamp",
		"name": "timestamp",
		"scope": "static",
		"kind": "member",
		"memberof": "Message",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 35,
			"filename": "Message.js",
			"path": "/lib/models"
		},
		"order": 436
	},
	{
		"id": "Message.edited_timestamp",
		"longname": "Message.edited_timestamp",
		"name": "edited_timestamp",
		"scope": "static",
		"kind": "member",
		"memberof": "Message",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 37,
			"filename": "Message.js",
			"path": "/lib/models"
		},
		"order": 437
	},
	{
		"id": "Message.nonce",
		"longname": "Message.nonce",
		"name": "nonce",
		"scope": "static",
		"kind": "member",
		"memberof": "Message",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 39,
			"filename": "Message.js",
			"path": "/lib/models"
		},
		"order": 438
	},
	{
		"id": "Message.webhook_id",
		"longname": "Message.webhook_id",
		"name": "webhook_id",
		"scope": "static",
		"kind": "member",
		"memberof": "Message",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 41,
			"filename": "Message.js",
			"path": "/lib/models"
		},
		"order": 439
	},
	{
		"id": "Message.reactions",
		"longname": "Message.reactions",
		"name": "reactions",
		"scope": "static",
		"kind": "member",
		"memberof": "Message",
		"returns": [
			{
				"type": {
					"names": [
						"Array",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 43,
			"filename": "Message.js",
			"path": "/lib/models"
		},
		"order": 440
	},
	{
		"id": "Message.pinned",
		"longname": "Message.pinned",
		"name": "pinned",
		"scope": "static",
		"kind": "member",
		"memberof": "Message",
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 45,
			"filename": "Message.js",
			"path": "/lib/models"
		},
		"order": 441
	},
	{
		"id": "IMessage.call",
		"longname": "IMessage.call",
		"name": "call",
		"scope": "static",
		"kind": "member",
		"description": "Raw MessageCall object:\r\r```js\r{\r  // Array of user ids participating in this call,\r  // only used to check if the call was missed\r  participants: [ \"108721394061205504\" ], // Array<String>\r\r  // Timestamp when call ended, null if call is in progress\r  ended_timestamp: \"2016-07-24T06:52:11.860000+00:00\" // String | null\r}\r```",
		"memberof": "IMessage",
		"returns": [
			{
				"type": {
					"names": [
						"Object",
						"null"
					]
				}
			}
		],
		"readonly": true,
		"meta": {
			"lineno": 63,
			"filename": "Message.js",
			"path": "/lib/models"
		},
		"order": 442
	},
	{
		"id": "Message.deleted",
		"longname": "Message.deleted",
		"name": "deleted",
		"scope": "static",
		"kind": "member",
		"memberof": "Message",
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 66,
			"filename": "Message.js",
			"path": "/lib/models"
		},
		"order": 443
	},
	{
		"id": "PermissionOverwrite.id",
		"longname": "PermissionOverwrite.id",
		"name": "id",
		"scope": "static",
		"kind": "member",
		"memberof": "PermissionOverwrite",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 12,
			"filename": "PermissionOverwrite.js",
			"path": "/lib/models"
		},
		"order": 445
	},
	{
		"id": "PermissionOverwrite.type",
		"longname": "PermissionOverwrite.type",
		"name": "type",
		"scope": "static",
		"kind": "member",
		"memberof": "PermissionOverwrite",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 14,
			"filename": "PermissionOverwrite.js",
			"path": "/lib/models"
		},
		"order": 446
	},
	{
		"id": "PermissionOverwrite.allow",
		"longname": "PermissionOverwrite.allow",
		"name": "allow",
		"scope": "static",
		"kind": "member",
		"memberof": "PermissionOverwrite",
		"returns": [
			{
				"type": {
					"names": [
						"Number",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 16,
			"filename": "PermissionOverwrite.js",
			"path": "/lib/models"
		},
		"order": 447
	},
	{
		"id": "PermissionOverwrite.deny",
		"longname": "PermissionOverwrite.deny",
		"name": "deny",
		"scope": "static",
		"kind": "member",
		"memberof": "PermissionOverwrite",
		"returns": [
			{
				"type": {
					"names": [
						"Number",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 18,
			"filename": "PermissionOverwrite.js",
			"path": "/lib/models"
		},
		"order": 448
	},
	{
		"id": "Role.id",
		"longname": "Role.id",
		"name": "id",
		"scope": "static",
		"kind": "member",
		"memberof": "Role",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 12,
			"filename": "Role.js",
			"path": "/lib/models"
		},
		"order": 450
	},
	{
		"id": "Role.name",
		"longname": "Role.name",
		"name": "name",
		"scope": "static",
		"kind": "member",
		"memberof": "Role",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 14,
			"filename": "Role.js",
			"path": "/lib/models"
		},
		"order": 451
	},
	{
		"id": "Role.permissions",
		"longname": "Role.permissions",
		"name": "permissions",
		"scope": "static",
		"kind": "member",
		"memberof": "Role",
		"returns": [
			{
				"type": {
					"names": [
						"Number",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 16,
			"filename": "Role.js",
			"path": "/lib/models"
		},
		"order": 452
	},
	{
		"id": "Role.mentionable",
		"longname": "Role.mentionable",
		"name": "mentionable",
		"scope": "static",
		"kind": "member",
		"memberof": "Role",
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 18,
			"filename": "Role.js",
			"path": "/lib/models"
		},
		"order": 453
	},
	{
		"id": "Role.position",
		"longname": "Role.position",
		"name": "position",
		"scope": "static",
		"kind": "member",
		"memberof": "Role",
		"returns": [
			{
				"type": {
					"names": [
						"Number",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 20,
			"filename": "Role.js",
			"path": "/lib/models"
		},
		"order": 454
	},
	{
		"id": "Role.hoist",
		"longname": "Role.hoist",
		"name": "hoist",
		"scope": "static",
		"kind": "member",
		"memberof": "Role",
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 22,
			"filename": "Role.js",
			"path": "/lib/models"
		},
		"order": 455
	},
	{
		"id": "Role.color",
		"longname": "Role.color",
		"name": "color",
		"scope": "static",
		"kind": "member",
		"memberof": "Role",
		"returns": [
			{
				"type": {
					"names": [
						"Number",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 24,
			"filename": "Role.js",
			"path": "/lib/models"
		},
		"order": 456
	},
	{
		"id": "Role.managed",
		"longname": "Role.managed",
		"name": "managed",
		"scope": "static",
		"kind": "member",
		"memberof": "Role",
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 26,
			"filename": "Role.js",
			"path": "/lib/models"
		},
		"order": 457
	},
	{
		"id": "User.id",
		"longname": "User.id",
		"name": "id",
		"scope": "static",
		"kind": "member",
		"memberof": "User",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 12,
			"filename": "User.js",
			"path": "/lib/models"
		},
		"order": 459
	},
	{
		"id": "User.username",
		"longname": "User.username",
		"name": "username",
		"scope": "static",
		"kind": "member",
		"memberof": "User",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 14,
			"filename": "User.js",
			"path": "/lib/models"
		},
		"order": 460
	},
	{
		"id": "User.discriminator",
		"longname": "User.discriminator",
		"name": "discriminator",
		"scope": "static",
		"kind": "member",
		"memberof": "User",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 16,
			"filename": "User.js",
			"path": "/lib/models"
		},
		"order": 461
	},
	{
		"id": "User.avatar",
		"longname": "User.avatar",
		"name": "avatar",
		"scope": "static",
		"kind": "member",
		"memberof": "User",
		"returns": [
			{
				"type": {
					"names": [
						"String",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 18,
			"filename": "User.js",
			"path": "/lib/models"
		},
		"order": 462
	},
	{
		"id": "User.bot",
		"longname": "User.bot",
		"name": "bot",
		"scope": "static",
		"kind": "member",
		"memberof": "User",
		"returns": [
			{
				"type": {
					"names": [
						"boolean",
						"null"
					]
				}
			}
		],
		"meta": {
			"lineno": 20,
			"filename": "User.js",
			"path": "/lib/models"
		},
		"order": 463
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/docs.json
 ** module id = 323
 ** module chunks = 0
 **/